import clsx from 'clsx'
import { ISVG } from 'src/type'
interface IProps {
  color?: string
  size?: number
}
interface IIconProps {
  className?: string
  color?: string
}
export const DownloadIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M10.4613 13.7551C10.3429 13.8846 10.1755 13.9583 10 13.9583C9.82453 13.9583 9.65714 13.8846 9.53873 13.7551L6.2054 10.1092C5.97248 9.85448 5.99019 9.45915 6.24494 9.22623C6.49969 8.99332 6.89502 9.01102 7.12794 9.26577L9.375 11.7235V2.5C9.375 2.15482 9.65482 1.875 10 1.875C10.3452 1.875 10.625 2.15482 10.625 2.5V11.7235L12.8721 9.26577C13.105 9.01102 13.5003 8.99332 13.7551 9.22623C14.0098 9.45915 14.0275 9.85448 13.7946 10.1092L10.4613 13.7551Z"
        fill="currentColor"
      />
      <path
        d="M3.125 12.5C3.125 12.1548 2.84518 11.875 2.5 11.875C2.15482 11.875 1.875 12.1548 1.875 12.5V12.5457C1.87498 13.6854 1.87497 14.604 1.9721 15.3265C2.07295 16.0765 2.2887 16.7081 2.79029 17.2097C3.29189 17.7113 3.92345 17.927 4.67354 18.0279C5.39602 18.125 6.31462 18.125 7.45428 18.125H12.5457C13.6854 18.125 14.604 18.125 15.3265 18.0279C16.0766 17.927 16.7081 17.7113 17.2097 17.2097C17.7113 16.7081 17.9271 16.0765 18.0279 15.3265C18.125 14.604 18.125 13.6854 18.125 12.5457V12.5C18.125 12.1548 17.8452 11.875 17.5 11.875C17.1548 11.875 16.875 12.1548 16.875 12.5C16.875 13.6962 16.8737 14.5304 16.789 15.1599C16.7068 15.7714 16.5565 16.0952 16.3258 16.3258C16.0952 16.5565 15.7714 16.7068 15.1599 16.789C14.5304 16.8737 13.6962 16.875 12.5 16.875H7.5C6.30382 16.875 5.46956 16.8737 4.8401 16.789C4.22862 16.7068 3.90481 16.5565 3.67418 16.3258C3.44354 16.0952 3.29317 15.7714 3.21096 15.1599C3.12633 14.5304 3.125 13.6962 3.125 12.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const EditIcon = ({ width, height }: ISVG) => {
  return (
    <svg
      className="edit-icon"
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15H9V12L18 3L21 6L12 15Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 5.25L18.75 8.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.25 11.25V19.5C20.25 19.6989 20.171 19.8897 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V4.5C3.75 4.30109 3.82902 4.11032 3.96967 3.96967C4.11032 3.82902 4.30109 3.75 4.5 3.75H12.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ViewIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 9h6M9 12h6M9 15h3M14.69 20.25H4.5a.75.75 0 01-.75-.75v-15a.75.75 0 01.75-.75h15a.75.75 0 01.75.75v10.19a.742.742 0 01-.216.526l-4.818 4.818a.74.74 0 01-.525.216v0z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.184 15H15v5.184"
      ></path>
    </svg>
  )
}
export const AssistiveIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M2 6.5C2 4.37868 2 3.31802 2.65901 2.65901C3.31802 2 4.37868 2 6.5 2C8.62132 2 9.68198 2 10.341 2.65901C11 3.31802 11 4.37868 11 6.5C11 8.62132 11 9.68198 10.341 10.341C9.68198 11 8.62132 11 6.5 11C4.37868 11 3.31802 11 2.65901 10.341C2 9.68198 2 8.62132 2 6.5Z"
        fill="currentColor"
      />
      <path
        d="M13 17.5C13 15.3787 13 14.318 13.659 13.659C14.318 13 15.3787 13 17.5 13C19.6213 13 20.682 13 21.341 13.659C22 14.318 22 15.3787 22 17.5C22 19.6213 22 20.682 21.341 21.341C20.682 22 19.6213 22 17.5 22C15.3787 22 14.318 22 13.659 21.341C13 20.682 13 19.6213 13 17.5Z"
        fill="currentColor"
      />
      <path
        d="M2 17.5C2 15.3787 2 14.318 2.65901 13.659C3.31802 13 4.37868 13 6.5 13C8.62132 13 9.68198 13 10.341 13.659C11 14.318 11 15.3787 11 17.5C11 19.6213 11 20.682 10.341 21.341C9.68198 22 8.62132 22 6.5 22C4.37868 22 3.31802 22 2.65901 21.341C2 20.682 2 19.6213 2 17.5Z"
        fill="currentColor"
      />
      <path
        d="M13 6.5C13 4.37868 13 3.31802 13.659 2.65901C14.318 2 15.3787 2 17.5 2C19.6213 2 20.682 2 21.341 2.65901C22 3.31802 22 4.37868 22 6.5C22 8.62132 22 9.68198 21.341 10.341C20.682 11 19.6213 11 17.5 11C15.3787 11 14.318 11 13.659 10.341C13 9.68198 13 8.62132 13 6.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const EyeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CloseIconPreview = ({ width, height }: ISVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 12}
      height={height ?? 12}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M7.40992 6L10.9999 2.44C11.1909 2.24639 11.2971 1.98486 11.2952 1.71293C11.2933 1.441 11.1835 1.18096 10.9899 0.990001C10.7963 0.799045 10.5348 0.692821 10.2628 0.694696C9.99092 0.696571 9.73088 0.806393 9.53992 1L5.99992 4.59L2.45992 1.07C2.27256 0.88375 2.0191 0.779208 1.75492 0.779208C1.49073 0.779208 1.23728 0.88375 1.04992 1.07C0.956191 1.16296 0.881796 1.27357 0.831028 1.39542C0.780259 1.51728 0.754121 1.64799 0.754121 1.78C0.754121 1.91201 0.780259 2.04272 0.831028 2.16458C0.881796 2.28644 0.956191 2.39704 1.04992 2.49L4.58992 6L0.999919 9.56C0.808963 9.75361 0.702739 10.0151 0.704614 10.2871C0.70649 10.559 0.816311 10.819 1.00992 11.01C1.20353 11.201 1.46506 11.3072 1.73699 11.3053C2.00892 11.3034 2.26896 11.1936 2.45992 11L5.99992 7.41L9.53992 10.93C9.72728 11.1163 9.98073 11.2208 10.2449 11.2208C10.5091 11.2208 10.7626 11.1163 10.9499 10.93C11.0436 10.837 11.118 10.7264 11.1688 10.6046C11.2196 10.4827 11.2457 10.352 11.2457 10.22C11.2457 10.088 11.2196 9.95728 11.1688 9.83542C11.118 9.71356 11.0436 9.60296 10.9499 9.51L7.40992 6Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const DeleteIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.59244 1.87502H11.4103C11.5906 1.8749 11.7477 1.8748 11.8961 1.89849C12.4822 1.99208 12.9893 2.35762 13.2635 2.88403C13.3328 3.01727 13.3824 3.16634 13.4393 3.33745L13.5323 3.61654C13.5481 3.66378 13.5526 3.67715 13.5564 3.68768C13.7023 4.09111 14.0807 4.36383 14.5096 4.3747C14.5209 4.37498 14.5347 4.37503 14.5847 4.37503H17.0847C17.4299 4.37503 17.7097 4.65485 17.7097 5.00003C17.7097 5.34521 17.4299 5.62503 17.0847 5.62503H2.91797C2.57279 5.62503 2.29297 5.34521 2.29297 5.00003C2.29297 4.65485 2.57279 4.37503 2.91797 4.37503H5.41804C5.46808 4.37503 5.48189 4.37498 5.49316 4.3747C5.92204 4.36383 6.30039 4.09113 6.44632 3.6877C6.45016 3.67709 6.45457 3.66401 6.4704 3.61654L6.5634 3.33747C6.62031 3.16637 6.66991 3.01728 6.73929 2.88403C7.01341 2.35762 7.52058 1.99208 8.10666 1.89849C8.25501 1.8748 8.41211 1.8749 8.59244 1.87502ZM7.50809 4.37503C7.55102 4.29085 7.58906 4.20337 7.62178 4.1129C7.63172 4.08543 7.64146 4.05619 7.65399 4.01861L7.73715 3.7691C7.81313 3.54118 7.83062 3.49469 7.84798 3.46137C7.93935 3.2859 8.10841 3.16405 8.30377 3.13285C8.34087 3.12693 8.39049 3.12503 8.63076 3.12503H11.372C11.6122 3.12503 11.6619 3.12693 11.699 3.13285C11.8943 3.16405 12.0634 3.2859 12.1548 3.46137C12.1721 3.49469 12.1896 3.54117 12.2656 3.7691L12.3487 4.01846L12.381 4.11292C12.4137 4.20338 12.4517 4.29085 12.4946 4.37503H7.50809Z"
        fill="white"
      />
      <path
        d="M4.93054 7.04179C4.90758 6.69738 4.60977 6.43679 4.26535 6.45975C3.92094 6.48271 3.66035 6.78053 3.68331 7.12494L4.06952 12.9181C4.14077 13.987 4.19832 14.8505 4.33329 15.528C4.47362 16.2324 4.71231 16.8208 5.2053 17.2821C5.6983 17.7433 6.30126 17.9423 7.01347 18.0355C7.69849 18.1251 8.56384 18.125 9.63514 18.125H10.3676C11.4389 18.125 12.3043 18.1251 12.9893 18.0355C13.7015 17.9423 14.3044 17.7433 14.7974 17.2821C15.2904 16.8208 15.5291 16.2324 15.6694 15.528C15.8044 14.8505 15.862 13.987 15.9332 12.9181L16.3194 7.12494C16.3424 6.78053 16.0818 6.48271 15.7374 6.45975C15.393 6.43679 15.0952 6.69738 15.0722 7.04179L14.6889 12.7911C14.614 13.9143 14.5607 14.6958 14.4435 15.2838C14.3299 15.8542 14.1713 16.1561 13.9435 16.3692C13.7156 16.5824 13.4038 16.7206 12.8271 16.796C12.2326 16.8738 11.4493 16.875 10.3236 16.875H9.67914C8.55343 16.875 7.7701 16.8738 7.17559 16.796C6.59893 16.7206 6.28713 16.5824 6.05928 16.3692C5.83144 16.1561 5.67283 15.8542 5.5592 15.2838C5.44206 14.6958 5.38871 13.9143 5.31383 12.7911L4.93054 7.04179Z"
        fill="white"
      />
      <path
        d="M7.85585 8.5448C8.19932 8.51045 8.5056 8.76104 8.53994 9.10451L8.95661 13.2712C8.99096 13.6146 8.74037 13.9209 8.3969 13.9553C8.05344 13.9896 7.74716 13.739 7.71281 13.3956L7.29615 9.22889C7.2618 8.88542 7.51239 8.57915 7.85585 8.5448Z"
        fill="white"
      />
      <path
        d="M12.1469 8.5448C12.4904 8.57915 12.741 8.88542 12.7066 9.22889L12.2899 13.3956C12.2556 13.739 11.9493 13.9896 11.6059 13.9553C11.2624 13.9209 11.0118 13.6146 11.0461 13.2712L11.4628 9.10451C11.4972 8.76104 11.8034 8.51045 12.1469 8.5448Z"
        fill="white"
      />
    </svg>
  )
}
export const LinkedinIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <rect x="1.5" y="1.5" width="21" height="21" rx="10.5" fill="#1275B1" />
      <path
        d="M9.46392 7.26911C9.46392 7.97002 8.85639 8.53822 8.10696 8.53822C7.35753 8.53822 6.75 7.97002 6.75 7.26911C6.75 6.5682 7.35753 6 8.10696 6C8.85639 6 9.46392 6.5682 9.46392 7.26911Z"
        fill="white"
      />
      <path d="M6.93557 9.47107H9.25515V16.5H6.93557V9.47107Z" fill="white" />
      <path
        d="M12.9897 9.47107H10.6701V16.5H12.9897C12.9897 16.5 12.9897 14.2872 12.9897 12.9036C12.9897 12.0732 13.2732 11.2392 14.4046 11.2392C15.6833 11.2392 15.6756 12.3259 15.6696 13.1678C15.6618 14.2683 15.6804 15.3914 15.6804 16.5H18V12.7903C17.9804 10.4215 17.3631 9.33006 15.3325 9.33006C14.1265 9.33006 13.379 9.87754 12.9897 10.3729V9.47107Z"
        fill="white"
      />
    </svg>
  )
}
export const CopyIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 1.25H10.9436C9.10583 1.24998 7.65019 1.24997 6.51098 1.40314C5.33856 1.56076 4.38961 1.89288 3.64124 2.64124C2.89288 3.38961 2.56076 4.33856 2.40314 5.51098C2.24997 6.65019 2.24998 8.10582 2.25 9.94357V16C2.25 17.8722 3.62205 19.424 5.41551 19.7047C5.55348 20.4687 5.81753 21.1208 6.34835 21.6517C6.95027 22.2536 7.70814 22.5125 8.60825 22.6335C9.47522 22.75 10.5775 22.75 11.9451 22.75H15.0549C16.4225 22.75 17.5248 22.75 18.3918 22.6335C19.2919 22.5125 20.0497 22.2536 20.6517 21.6517C21.2536 21.0497 21.5125 20.2919 21.6335 19.3918C21.75 18.5248 21.75 17.4225 21.75 16.0549V10.9451C21.75 9.57754 21.75 8.47522 21.6335 7.60825C21.5125 6.70814 21.2536 5.95027 20.6517 5.34835C20.1208 4.81753 19.4687 4.55348 18.7047 4.41551C18.424 2.62205 16.8722 1.25 15 1.25ZM17.1293 4.27117C16.8265 3.38623 15.9876 2.75 15 2.75H11C9.09318 2.75 7.73851 2.75159 6.71085 2.88976C5.70476 3.02502 5.12511 3.27869 4.7019 3.7019C4.27869 4.12511 4.02502 4.70476 3.88976 5.71085C3.75159 6.73851 3.75 8.09318 3.75 10V16C3.75 16.9876 4.38624 17.8265 5.27117 18.1293C5.24998 17.5194 5.24999 16.8297 5.25 16.0549V10.9451C5.24998 9.57754 5.24996 8.47522 5.36652 7.60825C5.48754 6.70814 5.74643 5.95027 6.34835 5.34835C6.95027 4.74643 7.70814 4.48754 8.60825 4.36652C9.47522 4.24996 10.5775 4.24998 11.9451 4.25H15.0549C15.8297 4.24999 16.5194 4.24998 17.1293 4.27117ZM7.40901 6.40901C7.68577 6.13225 8.07435 5.9518 8.80812 5.85315C9.56347 5.75159 10.5646 5.75 12 5.75H15C16.4354 5.75 17.4365 5.75159 18.1919 5.85315C18.9257 5.9518 19.3142 6.13225 19.591 6.40901C19.8678 6.68577 20.0482 7.07435 20.1469 7.80812C20.2484 8.56347 20.25 9.56458 20.25 11V16C20.25 17.4354 20.2484 18.4365 20.1469 19.1919C20.0482 19.9257 19.8678 20.3142 19.591 20.591C19.3142 20.8678 18.9257 21.0482 18.1919 21.1469C17.4365 21.2484 16.4354 21.25 15 21.25H12C10.5646 21.25 9.56347 21.2484 8.80812 21.1469C8.07435 21.0482 7.68577 20.8678 7.40901 20.591C7.13225 20.3142 6.9518 19.9257 6.85315 19.1919C6.75159 18.4365 6.75 17.4354 6.75 16V11C6.75 9.56458 6.75159 8.56347 6.85315 7.80812C6.9518 7.07435 7.13225 6.68577 7.40901 6.40901Z"
        fill="#1C274C"
      />
    </svg>
  )
}
export const HelpIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="help-question-1--circle-faq-frame-help-info-mark-more-query-question"
        clipPath="url(#clip0_4_7633)"
      >
        <g id="help-question-1--circle-faq-frame-help-info-mark-more-query-question_2">
          <path
            id="Vector"
            d="M7.99986 15.4287C12.1026 15.4287 15.4284 12.1028 15.4284 8.00011C15.4284 3.89742 12.1026 0.571533 7.99986 0.571533C3.89718 0.571533 0.571289 3.89742 0.571289 8.00011C0.571289 12.1028 3.89718 15.4287 7.99986 15.4287Z"
            stroke="#404041"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M6 5.99975C6 5.60418 6.11741 5.21751 6.33737 4.88861C6.55733 4.55972 6.86998 4.30337 7.23576 4.15199C7.60154 4.00062 8.00405 3.96102 8.39235 4.03818C8.78067 4.11535 9.13736 4.30583 9.41733 4.58554C9.69728 4.86525 9.88793 5.22161 9.96518 5.60957C10.0424 5.99753 10.0028 6.39966 9.85126 6.76511C9.69975 7.13056 9.44317 7.44292 9.11397 7.66268C8.78478 7.88244 8.39774 7.99974 8.00182 7.99974V9.33306"
            stroke="#404041"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g id="Group 2567">
            <path
              id="Vector_3"
              d="M7.99958 11.9528C7.84179 11.9528 7.71387 11.8249 7.71387 11.6671C7.71387 11.5092 7.84179 11.3813 7.99958 11.3813"
              stroke="#404041"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_4"
              d="M8 11.9528C8.15779 11.9528 8.28571 11.8249 8.28571 11.6671C8.28571 11.5092 8.15779 11.3813 8 11.3813"
              stroke="#404041"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4_7633">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const HighlightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_4_7599)">
        <path
          d="M8.57129 0.571533H2.857C2.55389 0.571533 2.26321 0.691941 2.04888 0.906268C1.83456 1.1206 1.71415 1.41128 1.71415 1.71439V12.0001L0.571289 15.4287L5.14272 14.2858H14.2856C14.5887 14.2858 14.8794 14.1654 15.0937 13.9511C15.308 13.7368 15.4284 13.446 15.4284 13.143V7.42868"
          stroke="#404041"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.55748 9.29949L6.12891 9.91663L6.70033 6.44235L12.1061 1.05949C12.2123 0.952372 12.3387 0.86735 12.478 0.809328C12.6172 0.751308 12.7666 0.721436 12.9175 0.721436C13.0684 0.721436 13.2178 0.751308 13.357 0.809328C13.4963 0.86735 13.6227 0.952372 13.729 1.05949L14.9404 2.27092C15.0475 2.37716 15.1325 2.50357 15.1906 2.64284C15.2485 2.78209 15.2784 2.93148 15.2784 3.08235C15.2784 3.23321 15.2485 3.3826 15.1906 3.52187C15.1325 3.66113 15.0475 3.78753 14.9404 3.89377L9.55748 9.29949Z"
          stroke="#404041"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7599">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const UnHighLightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_6525_5668)">
        <path
          d="M9.74501 3.8434C9.54973 3.64815 9.54973 3.33155 9.74501 3.1363C9.94026 2.94105 10.2569 2.94105 10.4521 3.1363L12.8116 5.49583C13.0069 5.69108 13.0069 6.00768 12.8116 6.20293C12.714 6.30055 12.586 6.3494 12.4581 6.3494C12.3302 6.3494 12.2022 6.30055 12.1046 6.20293L9.74501 3.8434ZM16 15.4464C16 15.7225 15.7762 15.9464 15.5 15.9464C15.5 15.9464 5.64498 15.948 5.64495 15.948C5.11367 15.9481 4.58076 15.7786 4.13157 15.4983C3.93379 15.3749 3.75079 15.2274 3.58601 15.0626L0.885355 12.3619C-0.195645 11.281 -0.30152 9.62799 0.649261 8.67718L8.62542 0.701021C9.57626 -0.249792 11.2293 -0.143854 12.3102 0.937114L15.0109 3.63777C16.0919 4.71877 16.1977 6.37174 15.2469 7.32255L7.62307 14.9464H15.5C15.7762 14.9464 16 15.1702 16 15.4464ZM3.3192 7.42143L8.52651 12.6287L14.5398 6.61543C15.1007 6.05452 14.9948 5.03593 14.3037 4.34483L11.6031 1.64418C11.2106 1.25168 10.7123 1.04793 10.2524 1.04793C9.90251 1.04793 9.57482 1.16577 9.33245 1.40808L3.3192 7.42143ZM4.2931 14.3555C4.98417 15.0466 6.00273 15.1525 6.5637 14.5916L7.81945 13.3358L2.6121 8.12852L1.35635 9.38427C0.795448 9.94518 0.901355 10.9637 1.59245 11.6548L4.2931 14.3555Z"
          fill="#404041"
        />
      </g>
      <defs>
        <clipPath id="clip0_6525_5668">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const ScratchPadIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_4_7603)">
        <path
          d="M9.14272 0.571533H1.71415C1.08296 0.571533 0.571289 1.08321 0.571289 1.71439V14.2858C0.571289 14.917 1.08296 15.4287 1.71415 15.4287H11.9999C12.6311 15.4287 13.1427 14.917 13.1427 14.2858V9.14296"
          stroke="#404041"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.571289 12H13.1427"
          stroke="#404041"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 3.42871H6.28571"
          stroke="#404041"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 6.28589H5.14286"
          stroke="#404041"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2792 8.57816L6.85059 9.19531L7.42201 5.72102L12.2563 0.909588C12.3625 0.80247 12.4889 0.717449 12.6283 0.659427C12.7675 0.601405 12.9168 0.571533 13.0677 0.571533C13.2187 0.571533 13.368 0.601405 13.5072 0.659427C13.6465 0.717449 13.7729 0.80247 13.8791 0.909588L15.0905 2.12102C15.1977 2.22726 15.2828 2.35366 15.3407 2.49293C15.3988 2.6322 15.4286 2.78158 15.4286 2.93245C15.4286 3.08332 15.3988 3.2327 15.3407 3.37196C15.2828 3.51122 15.1977 3.63764 15.0905 3.74388L10.2792 8.57816Z"
          stroke="#404041"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7603">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const CloseIcon = ({
  className = 'stroke-[#050505] ',
}: {
  className?: string
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 18L6 6"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 18L18 6"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const FlagIcon = ({
  width = '24',
  height = '24',
}: {
  width?: string
  height?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5.75 1C6.16421 1 6.5 1.33579 6.5 1.75V3.6L8.22067 3.25587C9.8712 2.92576 11.5821 3.08284 13.1449 3.70797L13.5582 3.87329C14.9831 4.44323 16.5513 4.54967 18.0401 4.17746C18.6711 4.01972 19.1778 4.7036 18.8432 5.26132L17.5647 7.39221C17.2232 7.96137 17.0524 8.24595 17.0119 8.55549C16.9951 8.68461 16.9951 8.81539 17.0119 8.94451C17.0524 9.25405 17.2232 9.53863 17.5647 10.1078L19.1253 12.7089C19.4361 13.2269 19.1582 13.898 18.5721 14.0445L18.472 14.0695C16.7024 14.5119 14.8385 14.3854 13.1449 13.708C11.5821 13.0828 9.8712 12.9258 8.22067 13.2559L6.5 13.6V21.75C6.5 22.1642 6.16421 22.5 5.75 22.5C5.33579 22.5 5 22.1642 5 21.75V1.75C5 1.33579 5.33579 1 5.75 1Z"
        fill="#F80903"
      />
    </svg>
  )
}
export const CalculatorIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <rect width="48" height="48" rx="8" fill="white" />
      <path
        d="M13.1424 0.571533H2.85672C2.22555 0.571533 1.71387 1.08321 1.71387 1.71439V14.2858C1.71387 14.917 2.22555 15.4287 2.85672 15.4287H13.1424C13.7736 15.4287 14.2853 14.917 14.2853 14.2858V1.71439C14.2853 1.08321 13.7736 0.571533 13.1424 0.571533Z"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.71387 6.28589H14.2853"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.857 9.7145C4.69921 9.7145 4.57129 9.58658 4.57129 9.42878C4.57129 9.27099 4.69921 9.14307 4.857 9.14307"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.85742 9.7145C5.01522 9.7145 5.14314 9.58658 5.14314 9.42878C5.14314 9.27099 5.01522 9.14307 4.85742 9.14307"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99958 9.7145C7.84179 9.7145 7.71387 9.58658 7.71387 9.42878C7.71387 9.27099 7.84179 9.14307 7.99958 9.14307"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.7145C8.15779 9.7145 8.28571 9.58658 8.28571 9.42878C8.28571 9.27099 8.15779 9.14307 8 9.14307"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1422 9.7145C10.9844 9.7145 10.8564 9.58658 10.8564 9.42878C10.8564 9.27099 10.9844 9.14307 11.1422 9.14307"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1426 9.7145C11.3004 9.7145 11.4283 9.58658 11.4283 9.42878C11.4283 9.27099 11.3004 9.14307 11.1426 9.14307"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.857 12.5714C4.69921 12.5714 4.57129 12.4435 4.57129 12.2857C4.57129 12.1279 4.69921 12 4.857 12"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.85742 12.5714C5.01522 12.5714 5.14314 12.4435 5.14314 12.2857C5.14314 12.1279 5.01522 12 4.85742 12"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99958 12.5714C7.84179 12.5714 7.71387 12.4435 7.71387 12.2857C7.71387 12.1279 7.84179 12 7.99958 12"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.5714C8.15779 12.5714 8.28571 12.4435 8.28571 12.2857C8.28571 12.1279 8.15779 12 8 12"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1422 12.5714C10.9844 12.5714 10.8564 12.4435 10.8564 12.2857C10.8564 12.1279 10.9844 12 11.1422 12"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1426 12.5714C11.3004 12.5714 11.4283 12.4435 11.4283 12.2857C11.4283 12.1279 11.3004 12 11.1426 12"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.428 3.42871H10.2852"
        stroke="#404041"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const ArrowUpIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
    >
      <path
        d="M0.667317 5.33343L5.00065 1.6001L9.33398 5.33343"
        stroke="#404041"
        strokeLinecap="square"
      />
    </svg>
  )
}
export const ExhibitsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <g stroke="#404041">
        <path d="M11.43.572H1.714c-.631 0-1.143.511-1.143 1.142v9.715c0 .63.512 1.143 1.143 1.143h9.714c.632 0 1.143-.512 1.143-1.143V1.714c0-.63-.511-1.142-1.143-1.142Z" />
        <path d="M15.429 4v10.286a1.143 1.143 0 0 1-1.143 1.143H4" />
      </g>
    </svg>
  )
}
export const TextSquareIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <g stroke="#404041">
        <path d="M5.144 14.286.572 15.429 1.715 12V1.714A1.143 1.143 0 0 1 2.858.572h11.429a1.143 1.143 0 0 1 1.142 1.142v11.429a1.143 1.143 0 0 1-1.142 1.143H5.144ZM5.145 5.714h6.857M5.145 9.143h4.571" />
      </g>
    </svg>
  )
}
export const WinDowLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_3286_4533)">
        <path
          d="M8.19375 1.71875L0 2.79625V9.60875H8.19375V1.71875ZM0 17.2437L8.19375 18.41V10.3912H0V17.2437ZM9.0975 10.4938L9.13 18.4662L20 20V10.4938H9.0975ZM20 0L9.1625 1.555V9.5725H20V0Z"
          fill="#A1A1A1"
          className="logo"
        />
      </g>
      <defs>
        <clipPath id="clip0_3286_4533">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const AppleLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
    >
      <g clipPath="url(#clip0_3286_4535)">
        <path
          d="M15.0322 11.6879C15.0633 15.0172 17.9664 16.1252 17.9986 16.1393C17.9741 16.2173 17.5347 17.7181 16.4691 19.2682C15.5478 20.6085 14.5918 21.9437 13.0856 21.9714C11.6057 21.9985 11.1298 21.0979 9.43787 21.0979C7.74641 21.0979 7.21769 21.9437 5.81678 21.9985C4.36298 22.0533 3.25589 20.5494 2.32707 19.214C0.429043 16.4827 -1.02144 11.4959 0.926192 8.12967C1.89373 6.45801 3.6228 5.39945 5.49955 5.3723C6.92714 5.34519 8.27458 6.3283 9.14733 6.3283C10.0195 6.3283 11.6569 5.14603 13.3784 5.31966C14.099 5.34952 16.1219 5.60941 17.4208 7.50192C17.3161 7.56651 15.0071 8.90449 15.0322 11.6879ZM12.2509 3.51263C13.0227 2.58268 13.5422 1.2881 13.4005 0C12.2879 0.0445079 10.9426 0.737936 10.1446 1.66738C9.42947 2.49044 8.80315 3.80781 8.97214 5.07041C10.2122 5.16591 11.479 4.44317 12.2509 3.51263Z"
          fill="#A1A1A1"
          className="logo"
        />
      </g>
      <defs>
        <clipPath id="clip0_3286_4535">
          <rect width="18" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const SecurityIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M5.85 19.2291L1.26 15.4791C0.86751 15.1621 0.550722 14.7615 0.332741 14.3065C0.11476 13.8515 0.00108308 13.3536 0 12.8491V5.4991C0.000370822 4.84614 0.189308 4.20718 0.544104 3.65902C0.898899 3.11086 1.40445 2.67683 2 2.4091L6.6 0.309097C7.04251 0.106708 7.5234 0.00195312 8.01 0.00195312C8.4966 0.00195312 8.97749 0.106708 9.42 0.309097L14 2.4091C14.5955 2.67683 15.1011 3.11086 15.4559 3.65902C15.8107 4.20718 15.9996 4.84614 16 5.4991V12.8491C16.0001 13.3528 15.888 13.8502 15.6718 14.3051C15.4555 14.7601 15.1407 15.1611 14.75 15.4791L10.16 19.2291C9.55388 19.7307 8.79177 20.0052 8.005 20.0052C7.21824 20.0052 6.45612 19.7307 5.85 19.2291Z"
        fill="#A1A1A1"
      />
      <path
        d="M10.0001 12.699C9.90384 12.7 9.80835 12.6819 9.71911 12.6459C9.62987 12.6098 9.54863 12.5565 9.48008 12.489L5.48008 8.57895C5.33963 8.43833 5.26074 8.2477 5.26074 8.04895C5.26074 7.8502 5.33963 7.65958 5.48008 7.51895C5.62365 7.38026 5.81546 7.30273 6.01508 7.30273C6.2147 7.30273 6.40652 7.38026 6.55008 7.51895L10.5501 11.429C10.6905 11.5696 10.7694 11.7602 10.7694 11.959C10.7694 12.1577 10.6905 12.3483 10.5501 12.489C10.477 12.5588 10.3907 12.6133 10.2962 12.6494C10.2018 12.6854 10.1011 12.7023 10.0001 12.699Z"
        fill="#A1A1A1"
      />
      <path
        d="M5.99957 12.6993C5.89951 12.7 5.8003 12.6809 5.70764 12.6431C5.61497 12.6054 5.53067 12.5497 5.45957 12.4793C5.31912 12.3386 5.24023 12.148 5.24023 11.9493C5.24023 11.7505 5.31912 11.5599 5.45957 11.4193L9.45957 7.50927C9.52309 7.41671 9.60657 7.33958 9.70386 7.28358C9.80115 7.22758 9.90977 7.19413 10.0217 7.18571C10.1337 7.17728 10.2461 7.1941 10.3506 7.2349C10.4552 7.27571 10.5493 7.33947 10.626 7.42149C10.7026 7.50351 10.7599 7.60168 10.7935 7.70878C10.8272 7.81587 10.8363 7.92916 10.8204 8.04028C10.8044 8.15139 10.7637 8.25751 10.7013 8.35079C10.6388 8.44408 10.5562 8.52216 10.4596 8.57927L6.45957 12.4893C6.33425 12.6091 6.17218 12.6831 5.99957 12.6993Z"
        fill="#A1A1A1"
      />
    </svg>
  )
}
export const PhoneLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.1562 0H3.84375C3.61997 0 3.40536 0.0888948 3.24713 0.247129C3.08889 0.405362 3 0.619974 3 0.84375V23.1562C3 23.38 3.08889 23.5946 3.24713 23.7529C3.40536 23.9111 3.61997 24 3.84375 24H20.1562C20.38 24 20.5946 23.9111 20.7529 23.7529C20.9111 23.5946 21 23.38 21 23.1562V0.84375C21 0.619974 20.9111 0.405362 20.7529 0.247129C20.5946 0.0888948 20.38 0 20.1562 0V0ZM4.6875 21V3H19.3125V21H4.6875Z"
        fill="#A1A1A1"
        className="logo"
      />
    </svg>
  )
}
export const AlertIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
    >
      <path
        d="M50 9.375C27.5996 9.375 9.375 27.5996 9.375 50C9.375 72.4004 27.5996 90.625 50 90.625C72.4004 90.625 90.625 72.4004 90.625 50C90.625 27.5996 72.4004 9.375 50 9.375ZM53.9062 71.8574H46.0938V64.0449H53.9062V71.8574ZM53.125 59.375H46.875L45.7031 28.125H54.2969L53.125 59.375Z"
        fill="#FFB800"
      />
    </svg>
  )
}
export const AlertTriagle = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      className={className}
    >
      <path
        d="M44.0025 26.5833C45.5213 26.5833 46.7525 27.8146 46.7525 29.3333V47.6667C46.7525 49.1854 45.5213 50.4167 44.0025 50.4167C42.4838 50.4167 41.2525 49.1854 41.2525 47.6667V29.3333C41.2525 27.8146 42.4838 26.5833 44.0025 26.5833Z"
        fill="#FFB700"
      />
      <path
        d="M44.0025 62.3333C46.0276 62.3333 47.6692 60.6917 47.6692 58.6667C47.6692 56.6416 46.0276 55 44.0025 55C41.9775 55 40.3359 56.6416 40.3359 58.6667C40.3359 60.6917 41.9775 62.3333 44.0025 62.3333Z"
        fill="#FFB700"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.4154 16.4136C34.3457 11.4214 38.5093 8.25 44.0025 8.25C49.4958 8.25 53.6593 11.4214 57.5896 16.4136C61.455 21.3233 65.5513 28.5862 70.7923 37.8786L72.3891 40.7098C76.7216 48.3913 80.1435 54.4584 81.9409 59.3281C83.7778 64.3046 84.2141 68.8231 81.4355 72.8088C78.7391 76.6765 74.2403 78.259 68.5661 79.006C62.9137 79.7501 55.3124 79.75 45.5603 79.75H42.4449C32.6929 79.75 25.0914 79.7501 19.4389 79.006C13.7647 78.259 9.26594 76.6765 6.56957 72.8088C3.79093 68.8231 4.22728 64.3046 6.0641 59.3281C7.86151 54.4584 11.2834 48.3914 15.6159 40.7099L17.2125 37.8791C22.4536 28.5864 26.55 21.3234 30.4154 16.4136ZM34.7368 19.8158C31.1655 24.3521 27.2718 31.2395 21.8741 40.8098L20.5407 43.174C16.0445 51.1457 12.8494 56.8284 11.2238 61.2325C9.61917 65.5801 9.84165 67.8851 11.0814 69.6633C12.4033 71.5596 14.8846 72.859 20.1568 73.553C25.4074 74.2442 32.6455 74.25 42.6691 74.25H45.3359C55.3596 74.25 62.5976 74.2442 67.8483 73.553C73.1204 72.859 75.6017 71.5596 76.9237 69.6633C78.1634 67.8851 78.3859 65.5801 76.7812 61.2325C75.1556 56.8284 71.9605 51.1457 67.4644 43.1739L66.1309 40.8097C60.7333 31.2395 56.8396 24.3521 53.2682 19.8158C49.73 15.3217 46.982 13.75 44.0025 13.75C41.023 13.75 38.275 15.3217 34.7368 19.8158Z"
        fill="#FFB700"
      />
    </svg>
  )
}
export const LoginIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
    >
      <path
        d="M84.375 15.625H37.5C36.6712 15.625 35.8763 15.9542 35.2903 16.5403C34.7042 17.1263 34.375 17.9212 34.375 18.75V46.875H64.3301L51.8301 34.375L56.25 29.9551L74.084 47.791C74.6696 48.377 74.9986 49.1716 74.9986 50C74.9986 50.8284 74.6696 51.623 74.084 52.209L56.25 70.0449L51.8301 65.625L64.3301 53.125H34.375V81.25C34.375 82.0788 34.7042 82.8737 35.2903 83.4597C35.8763 84.0458 36.6712 84.375 37.5 84.375H84.375C85.2038 84.375 85.9987 84.0458 86.5847 83.4597C87.1708 82.8737 87.5 82.0788 87.5 81.25V18.75C87.5 17.9212 87.1708 17.1263 86.5847 16.5403C85.9987 15.9542 85.2038 15.625 84.375 15.625Z"
        fill="#FFB800"
      />
      <path d="M34.375 46.875H12.5V53.125H34.375V46.875Z" fill="#FFB800" />
    </svg>
  )
}

export const ActiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.7033 10.3421C40.6532 7.55263 47.3478 7.55263 53.2977 10.3421L77.8321 21.8444C81.6905 23.6533 83.4173 27.5815 83.4173 31.1668C83.4173 34.752 81.6905 38.6802 77.8321 40.4891L72.4173 43.0277V60.9599C72.4173 65.5544 70.1137 69.9904 65.92 72.3128C63.1637 73.8393 59.5415 75.6768 55.7297 77.1392C51.9628 78.5844 47.7916 79.75 44.0006 79.75C40.2097 79.75 36.0385 78.5844 32.2716 77.1392C28.4598 75.6768 24.8376 73.8393 22.0813 72.3128C17.8876 69.9904 15.584 65.5544 15.584 60.9599V43.0275L10.1692 40.4889L10.084 40.4485V51.3333C10.084 52.8521 8.85277 54.0833 7.33398 54.0833C5.8152 54.0833 4.58398 52.8521 4.58398 51.3333V31.1667C4.58398 27.5814 6.31079 23.6531 10.1692 21.8442L34.7033 10.3421ZM21.084 45.606V60.9599C21.084 63.7576 22.4727 66.2425 24.7458 67.5014C27.3735 68.9566 30.7522 70.6654 34.2416 72.0041C37.7759 73.36 41.2063 74.25 44.0006 74.25C46.795 74.25 50.2254 73.36 53.7597 72.0041C57.2491 70.6654 60.6278 68.9566 63.2555 67.5014C65.5286 66.2425 66.9173 63.7576 66.9173 60.9599V45.6062L53.298 51.9912C47.3481 54.7807 40.6536 54.7807 34.7036 51.9912L21.084 45.606ZM12.5039 35.5091C11.0255 34.816 10.084 33.1627 10.084 31.1666C10.084 29.1704 11.0256 27.5172 12.5039 26.8241L37.0379 15.322C41.5087 13.226 46.4923 13.226 50.963 15.322L75.4975 26.8243C76.9758 27.5173 77.9173 29.1706 77.9173 31.1667C77.9173 33.1629 76.9757 34.8161 75.4974 35.5092L50.9633 47.0113C46.4926 49.1073 41.509 49.1073 37.0383 47.0113L12.5039 35.5091Z"
        fill="#FFB700"
      />
    </svg>
  )
}
export const ConfirmIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.5243 13.3132C62.2344 14.0763 56.4508 15.9964 48.3339 18.702L29.9592 24.8269C23.4325 27.0025 18.7051 28.5807 15.3661 30.0008C11.8752 31.4856 10.6333 32.5205 10.23 33.2143C8.98774 35.3512 8.98774 37.9903 10.23 40.1272C10.6333 40.821 11.8752 41.8559 15.3661 43.3407C18.7051 44.7608 23.4325 46.339 29.9592 48.5146C30.0623 48.5489 30.1641 48.5828 30.2646 48.6162C32.0472 49.2092 33.4331 49.6702 34.6252 50.4682C35.7738 51.2371 36.7604 52.2238 37.5293 53.3724C38.3274 54.5645 38.7884 55.9504 39.3814 57.733C39.4148 57.8335 39.4486 57.9353 39.483 58.0383C41.6586 64.5651 43.2367 69.2924 44.6569 72.6315C46.1416 76.1224 47.1766 77.3642 47.8703 77.7675C50.0072 79.0098 52.6464 79.0098 54.7833 77.7675C55.477 77.3642 56.512 76.1224 57.9967 72.6315C59.4169 69.2925 60.995 64.5651 63.1706 58.0384L69.2955 39.6637C72.0011 31.5468 73.9212 25.7632 74.6844 21.4732C75.4511 17.1629 74.8652 15.3319 73.7654 14.2322C72.6656 13.1324 70.8347 12.5464 66.5243 13.3132ZM65.5375 7.76605C70.3123 6.91667 74.6126 7.11134 77.7494 10.2482C80.8862 13.385 81.0809 17.6853 80.2315 22.46C79.3873 27.2059 77.3285 33.382 74.722 41.2014L68.4706 59.9555C66.3495 66.3188 64.7014 71.2631 63.1815 74.8367C61.7154 78.2836 60.0876 81.201 57.615 82.6385C53.7275 84.8985 48.9261 84.8985 45.0386 82.6385C42.566 81.201 40.9382 78.2836 39.4721 74.8367C37.9522 71.2631 36.3041 66.3189 34.1831 59.9557L34.1379 59.82C33.3948 57.5908 33.1683 56.986 32.8474 56.5067C32.4882 55.9702 32.0274 55.5093 31.4909 55.1502C31.0115 54.8293 30.4068 54.6028 28.1775 53.8597L28.0417 53.8144C21.6786 51.6934 16.7344 50.0453 13.1609 48.5254C9.71393 47.0594 6.79653 45.4315 5.35908 42.9589C3.09906 39.0714 3.09906 34.2701 5.35908 30.3826C6.79653 27.91 9.71393 26.2821 13.1609 24.8161C16.7344 23.2962 21.6787 21.6481 28.042 19.527L46.7963 13.2756C54.6156 10.6691 60.7917 8.6103 65.5375 7.76605ZM64.8266 23.193C65.9207 24.2992 65.9108 26.0829 64.8046 27.1769L49.7799 42.036C48.6737 43.13 46.89 43.1201 45.796 42.0139C44.7019 40.9077 44.7118 39.124 45.818 38.03L60.8427 23.1709C61.9489 22.0769 63.7326 22.0868 64.8266 23.193Z"
        fill="#FFB700"
      />
    </svg>
  )
}

export const CloseIconNote = ({ color = '#1C274C' }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 18L6 6"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 18L18 6"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export const SaveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.4136 3C15.4465 3 15.4791 3.00105 15.5117 3.00313C16.1804 3.03536 16.8152 3.31521 17.2908 3.79081L20.2092 6.70919C20.7155 7.21554 21 7.90229 21 8.61838V18.3C21 19.7912 19.7912 21 18.3 21H5.7C4.20883 21 3 19.7912 3 18.3V5.7C3 4.20883 4.20883 3 5.7 3H15.4136ZM5.7 19.65H6.6V15.6C6.6 14.6059 7.40589 13.8 8.4 13.8H15.6C16.5941 13.8 17.4 14.6059 17.4 15.6V19.65H18.3C19.0456 19.65 19.65 19.0456 19.65 18.3V8.61838C19.65 8.26034 19.5078 7.91696 19.2546 7.66378L16.5 4.90919V7.5C16.5 8.49411 15.6941 9.3 14.7 9.3H9.3C8.30589 9.3 7.5 8.49411 7.5 7.5V4.35H5.7C4.95441 4.35 4.35 4.95441 4.35 5.7V18.3C4.35 19.0456 4.95441 19.65 5.7 19.65ZM8.85 4.35V7.5C8.85 7.74853 9.05147 7.95 9.3 7.95H14.7C14.9485 7.95 15.15 7.74853 15.15 7.5V4.35H8.85ZM16.05 19.65H7.95V15.6C7.95 15.3515 8.15147 15.15 8.4 15.15H15.6C15.8485 15.15 16.05 15.3515 16.05 15.6V19.65Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M17.071 10H2.93M10 2.929V17.07"
      ></path>
    </svg>
  )
}
export const WordIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="word_icon"
    >
      <g clipPath="url(#clip0_4134_6175)">
        <path
          d="M23.25 3.75052H13.5V1.50052C13.5 1.27702 13.401 1.06552 13.2285 0.923022C13.0575 0.780522 12.828 0.719022 12.612 0.764022L0.612 3.01402C0.2565 3.08002 0 3.38902 0 3.75052V20.2505C0 20.6105 0.2565 20.921 0.612 20.987L12.612 23.237C12.657 23.246 12.7035 23.2505 12.75 23.2505C12.924 23.2505 13.0935 23.1905 13.2285 23.078C13.401 22.9355 13.5 22.7225 13.5 22.5005V20.2505H23.25C23.664 20.2505 24 19.9145 24 19.5005V4.50052C24 4.08652 23.664 3.75052 23.25 3.75052ZM10.4955 9.08302L9.7455 15.8345C9.7065 16.178 9.4365 16.4525 9.093 16.4945C9.0615 16.499 9.0315 16.5005 9 16.5005C8.691 16.5005 8.409 16.3085 8.298 16.0145L6.75 11.8865L5.202 16.0145C5.082 16.3355 4.767 16.532 4.419 16.496C4.0785 16.46 3.8055 16.196 3.7575 15.8555L3.0075 10.6055C2.949 10.196 3.234 9.81652 3.6435 9.75802C4.0545 9.69802 4.434 9.98452 4.4925 10.394L4.827 12.74L6.0465 9.48652C6.2655 8.90152 7.2315 8.90152 7.452 9.48652L8.601 12.5495L9.0045 8.91652C9.051 8.50552 9.432 8.21152 9.8325 8.25502C10.245 8.30152 10.5405 8.67202 10.4955 9.08302ZM22.5 18.7505H13.5V17.2505H20.25C20.664 17.2505 21 16.9145 21 16.5005C21 16.0865 20.664 15.7505 20.25 15.7505H13.5V14.2505H20.25C20.664 14.2505 21 13.9145 21 13.5005C21 13.0865 20.664 12.7505 20.25 12.7505H13.5V11.2505H20.25C20.664 11.2505 21 10.9145 21 10.5005C21 10.0865 20.664 9.75052 20.25 9.75052H13.5V8.25052H20.25C20.664 8.25052 21 7.91452 21 7.50052C21 7.08652 20.664 6.75052 20.25 6.75052H13.5V5.25052H22.5V18.7505Z"
          fill="#295496"
        />
      </g>
      <defs>
        <clipPath id="clip0_4134_6175">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const ExcelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="excel_icon"
    >
      <g clipPath="url(#clip0_4134_6159)">
        <path
          d="M23.25 3.75052H13.5V1.50052C13.5 1.27702 13.401 1.06552 13.2285 0.923022C13.0575 0.780522 12.828 0.719022 12.612 0.764022L0.612 3.01402C0.2565 3.08002 0 3.38902 0 3.75052V20.2505C0 20.6105 0.2565 20.921 0.612 20.987L12.612 23.237C12.657 23.246 12.7035 23.2505 12.75 23.2505C12.924 23.2505 13.0935 23.1905 13.2285 23.078C13.401 22.9355 13.5 22.7225 13.5 22.5005V20.2505H23.25C23.664 20.2505 24 19.9145 24 19.5005V4.50052C24 4.08652 23.664 3.75052 23.25 3.75052ZM10.314 14.507C10.587 14.8175 10.5555 15.2915 10.2435 15.5645C10.101 15.689 9.9255 15.7505 9.75 15.7505C9.5415 15.7505 9.3345 15.6635 9.186 15.494L7.005 13.0025L5.0925 15.4625C4.944 15.6515 4.722 15.7505 4.5 15.7505C4.3395 15.7505 4.1775 15.6995 4.0395 15.593C3.7125 15.338 3.654 14.867 3.9075 14.54L5.9985 11.852L3.936 9.49402C3.663 9.18352 3.6945 8.70952 4.0065 8.43652C4.317 8.16352 4.7895 8.19352 5.0655 8.50702L6.9375 10.646L9.159 7.79002C9.414 7.46452 9.885 7.40452 10.212 7.65952C10.539 7.91302 10.5975 8.38402 10.3425 8.71252L7.9425 11.7965L10.314 14.507ZM22.5 18.7505H13.5V17.2505H15.75C16.164 17.2505 16.5 16.9145 16.5 16.5005C16.5 16.0865 16.164 15.7505 15.75 15.7505H13.5V14.2505H15.75C16.164 14.2505 16.5 13.9145 16.5 13.5005C16.5 13.0865 16.164 12.7505 15.75 12.7505H13.5V11.2505H15.75C16.164 11.2505 16.5 10.9145 16.5 10.5005C16.5 10.0865 16.164 9.75052 15.75 9.75052H13.5V8.25052H15.75C16.164 8.25052 16.5 7.91452 16.5 7.50052C16.5 7.08652 16.164 6.75052 15.75 6.75052H13.5V5.25052H22.5V18.7505Z"
          fill="#DCDDDD"
        />
        <path
          d="M20.25 6.75049H18.75C18.336 6.75049 18 7.08649 18 7.50049C18 7.91449 18.336 8.25049 18.75 8.25049H20.25C20.664 8.25049 21 7.91449 21 7.50049C21 7.08649 20.664 6.75049 20.25 6.75049Z"
          fill="#DCDDDD"
        />
        <path
          d="M20.25 9.75049H18.75C18.336 9.75049 18 10.0865 18 10.5005C18 10.9145 18.336 11.2505 18.75 11.2505H20.25C20.664 11.2505 21 10.9145 21 10.5005C21 10.0865 20.664 9.75049 20.25 9.75049Z"
          fill="#DCDDDD"
        />
        <path
          d="M20.25 12.7505H18.75C18.336 12.7505 18 13.0865 18 13.5005C18 13.9145 18.336 14.2505 18.75 14.2505H20.25C20.664 14.2505 21 13.9145 21 13.5005C21 13.0865 20.664 12.7505 20.25 12.7505Z"
          fill="#DCDDDD"
        />
        <path
          d="M20.25 15.7505H18.75C18.336 15.7505 18 16.0865 18 16.5005C18 16.9145 18.336 17.2505 18.75 17.2505H20.25C20.664 17.2505 21 16.9145 21 16.5005C21 16.0865 20.664 15.7505 20.25 15.7505Z"
          fill="#DCDDDD"
        />
      </g>
      <defs>
        <clipPath id="clip0_4134_6159">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const DocIcon = () => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4164_363)">
        <path d="M14.6245 63L8.98828 57.375H14.6245V63Z" fill="#1D80B2" />
        <path d="M57.375 63L63.0112 57.375H57.375V63Z" fill="#1D80B2" />
        <path
          d="M57.3755 14.625H48.3867V5.63623L57.3755 14.625Z"
          fill="#B2B2B2"
        />
        <path
          d="M48.375 5.625H16.4138C15.9393 5.625 15.4844 5.81346 15.1489 6.14891C14.8135 6.48437 14.625 6.93934 14.625 7.41375V64.7887C14.625 65.2642 14.8131 65.7203 15.1482 66.0576C15.4834 66.3948 15.9383 66.5858 16.4138 66.5887H55.5863C55.8265 66.5874 56.064 66.5379 56.2848 66.4433C56.5057 66.3487 56.7053 66.2108 56.872 66.0378C57.0387 65.8648 57.1691 65.6602 57.2555 65.436C57.3419 65.2118 57.3825 64.9726 57.375 64.7325V14.625H48.375V5.625Z"
          fill="#E9E9E0"
        />
        <path
          d="M10.125 37.125H61.875C62.1734 37.125 62.4595 37.2435 62.6705 37.4545C62.8815 37.6655 63 37.9516 63 38.25V57.375H9V38.25C9 37.9516 9.11853 37.6655 9.32951 37.4545C9.54048 37.2435 9.82663 37.125 10.125 37.125Z"
          fill="#2598DE"
        />
        <path
          d="M20.2383 14.625H41.7258"
          stroke="#2598DE"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.2383 22.061H52.2433"
          stroke="#2598DE"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.2383 22.061H35.1558"
          stroke="#2598DE"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.0469 29.4976H52.2431"
          stroke="#2598DE"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.2383 29.4976H42.682"
          stroke="#2598DE"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49.1367 46.1846H47.006C46.9776 45.9658 46.9194 45.7684 46.8313 45.5922C46.7433 45.4161 46.6268 45.2655 46.4819 45.1405C46.337 45.0155 46.1651 44.9204 45.9663 44.855C45.7702 44.7868 45.5529 44.7528 45.3143 44.7528C44.891 44.7528 44.5259 44.8564 44.2191 45.0638C43.9151 45.2712 43.6808 45.5709 43.516 45.963C43.354 46.355 43.2731 46.8295 43.2731 47.3863C43.2731 47.9658 43.3555 48.4516 43.5202 48.8437C43.6879 49.2329 43.9222 49.5269 44.2234 49.7258C44.5273 49.9218 44.8867 50.0198 45.3015 50.0198C45.5344 50.0198 45.7461 49.99 45.9364 49.9303C46.1296 49.8707 46.2987 49.784 46.4435 49.6704C46.5913 49.5539 46.712 49.4133 46.8058 49.2485C46.9023 49.0809 46.9691 48.892 47.006 48.6817L49.1367 48.6945C49.0998 49.0809 48.9876 49.4616 48.8001 49.8366C48.6154 50.2116 48.3612 50.5539 48.0373 50.8635C47.7134 51.1704 47.3185 51.4147 46.8526 51.5965C46.3896 51.7783 45.8583 51.8692 45.2589 51.8692C44.4691 51.8692 43.7617 51.6959 43.1367 51.3493C42.5146 50.9999 42.0231 50.4914 41.6623 49.8238C41.3015 49.1562 41.1211 48.3437 41.1211 47.3863C41.1211 46.426 41.3043 45.6121 41.6708 44.9445C42.0373 44.2769 42.533 43.7698 43.158 43.4232C43.783 43.0766 44.4833 42.9033 45.2589 42.9033C45.7873 42.9033 46.2759 42.9772 46.7248 43.1249C47.1737 43.2698 47.5685 43.4829 47.9094 43.7641C48.2504 44.0425 48.5273 44.3849 48.7404 44.7911C48.9535 45.1974 49.0856 45.6618 49.1367 46.1846Z"
          fill="white"
        />
        <path
          d="M39.9833 47.3863C39.9833 48.3465 39.7987 49.1604 39.4293 49.828C39.06 50.4956 38.56 51.0028 37.9293 51.3493C37.3015 51.6959 36.5969 51.8692 35.8157 51.8692C35.0316 51.8692 34.3256 51.6945 33.6978 51.3451C33.07 50.9956 32.5714 50.4885 32.2021 49.8238C31.8356 49.1562 31.6523 48.3437 31.6523 47.3863C31.6523 46.426 31.8356 45.6121 32.2021 44.9445C32.5714 44.2769 33.07 43.7698 33.6978 43.4232C34.3256 43.0766 35.0316 42.9033 35.8157 42.9033C36.5969 42.9033 37.3015 43.0766 37.9293 43.4232C38.56 43.7698 39.06 44.2769 39.4293 44.9445C39.7987 45.6121 39.9833 46.426 39.9833 47.3863ZM37.8271 47.3863C37.8271 46.8181 37.7461 46.338 37.5842 45.9459C37.4251 45.5539 37.195 45.257 36.8938 45.0553C36.5955 44.8536 36.2362 44.7528 35.8157 44.7528C35.3981 44.7528 35.0387 44.8536 34.7376 45.0553C34.4364 45.257 34.2049 45.5539 34.043 45.9459C33.8839 46.338 33.8043 46.8181 33.8043 47.3863C33.8043 47.9545 33.8839 48.4346 34.043 48.8266C34.2049 49.2187 34.4364 49.5155 34.7376 49.7172C35.0387 49.9189 35.3981 50.0198 35.8157 50.0198C36.2362 50.0198 36.5955 49.9189 36.8938 49.7172C37.195 49.5155 37.4251 49.2187 37.5842 48.8266C37.7461 48.4346 37.8271 47.9545 37.8271 47.3863Z"
          fill="white"
        />
        <path
          d="M26.2063 51.7497H22.9805V43.0225H26.2021C27.0913 43.0225 27.8569 43.1972 28.4989 43.5466C29.1438 43.8932 29.641 44.3932 29.9904 45.0466C30.3398 45.6972 30.5146 46.4756 30.5146 47.3818C30.5146 48.2909 30.3398 49.0722 29.9904 49.7256C29.6438 50.379 29.1481 50.8804 28.5032 51.2298C27.8583 51.5764 27.0927 51.7497 26.2063 51.7497ZM25.0898 49.9514H26.1254C26.614 49.9514 27.0273 49.8691 27.3654 49.7043C27.7063 49.5367 27.9634 49.2654 28.1367 48.8904C28.3129 48.5125 28.4009 48.0097 28.4009 47.3818C28.4009 46.754 28.3129 46.254 28.1367 45.8818C27.9606 45.5068 27.7006 45.2369 27.3569 45.0722C27.016 44.9046 26.5955 44.8208 26.0955 44.8208H25.0898V49.9514Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4164_363">
          <rect width="72" height="72" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const ImageIcon = () => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.6245 63L8.98828 57.375H14.6245V63Z" fill="#0D725A" />
      <path d="M57.375 63L63.0112 57.375H57.375V63Z" fill="#0D725A" />
      <path
        d="M57.3755 14.625H48.3867V5.63623L57.3755 14.625Z"
        fill="#B2B2B2"
      />
      <path
        d="M48.375 5.625H16.4138C15.9393 5.625 15.4844 5.81346 15.1489 6.14891C14.8135 6.48437 14.625 6.93934 14.625 7.41375V64.7887C14.625 65.2642 14.8131 65.7203 15.1482 66.0576C15.4834 66.3948 15.9383 66.5858 16.4138 66.5887H55.5863C55.8265 66.5874 56.064 66.5379 56.2848 66.4433C56.5057 66.3487 56.7053 66.2108 56.872 66.0378C57.0387 65.8648 57.1691 65.6602 57.2555 65.436C57.3419 65.2118 57.3825 64.9726 57.375 64.7325V14.625H48.375V5.625Z"
        fill="#E9E9E0"
      />
      <path
        d="M36.3269 31.5114L27.9681 22.9727L19.6094 31.5114H36.3269Z"
        stroke="#2A9F85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7148 27.8215L40.8261 19.564L52.3011 31.5115H36.3261L32.7148 27.8215Z"
        stroke="#2A9F85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7125 18.675C30.1415 18.675 31.3 17.5165 31.3 16.0875C31.3 14.6585 30.1415 13.5 28.7125 13.5C27.2835 13.5 26.125 14.6585 26.125 16.0875C26.125 17.5165 27.2835 18.675 28.7125 18.675Z"
        stroke="#2A9F85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.125 37.125H61.875C62.1734 37.125 62.4595 37.2435 62.6705 37.4545C62.8815 37.6655 63 37.9516 63 38.25V57.375H9V38.25C9 37.9516 9.11853 37.6655 9.32951 37.4545C9.54048 37.2435 9.82663 37.125 10.125 37.125Z"
        fill="#2A9F85"
      />
      <path
        d="M45.0437 45.8735C44.9954 45.6945 44.9244 45.5368 44.8306 45.4005C44.7369 45.2613 44.6218 45.1434 44.4854 45.0468C44.3491 44.9502 44.1928 44.8778 44.0167 44.8295C43.8406 44.7783 43.6474 44.7528 43.4371 44.7528C43.0138 44.7528 42.6474 44.855 42.3377 45.0596C42.0309 45.2641 41.7937 45.5624 41.6261 45.9545C41.4585 46.3437 41.3746 46.8167 41.3746 47.3735C41.3746 47.9332 41.4556 48.4104 41.6175 48.8053C41.7795 49.2002 42.0138 49.5013 42.3207 49.7087C42.6275 49.9161 42.9996 50.0198 43.4371 50.0198C43.8235 50.0198 44.1502 49.9573 44.4173 49.8323C44.6871 49.7045 44.8917 49.5241 45.0309 49.2911C45.1701 49.0581 45.2397 48.784 45.2397 48.4687L45.6317 48.5155H43.5096V46.9772H47.2724V48.132C47.2724 48.9133 47.1062 49.5823 46.7738 50.1391C46.4442 50.6959 45.9897 51.1235 45.4102 51.4218C44.8335 51.7201 44.1701 51.8692 43.4201 51.8692C42.5877 51.8692 41.8562 51.6888 41.2255 51.328C40.5948 50.9672 40.1033 50.453 39.7511 49.7854C39.3988 49.115 39.2227 48.3195 39.2227 47.3991C39.2227 46.6832 39.3292 46.0482 39.5423 45.4942C39.7553 44.9374 40.0522 44.4658 40.4329 44.0795C40.8164 43.6931 41.2596 43.4005 41.7624 43.2016C42.2681 43.0028 42.8121 42.9033 43.3945 42.9033C43.9002 42.9033 44.3704 42.9758 44.805 43.1207C45.2425 43.2655 45.6289 43.4701 45.9641 43.7343C46.3022 43.9985 46.5764 44.3124 46.7866 44.676C46.9968 45.0397 47.1275 45.4388 47.1786 45.8735H45.0437Z"
        fill="white"
      />
      <path
        d="M28.2422 43.0225H30.8544L33.0703 48.4259H33.1726L35.3885 43.0225H38.0007V51.7497H35.9467V46.3889H35.8743L33.7777 51.6943H32.4652L30.3686 46.3591H30.2962V51.7497H28.2422V43.0225Z"
        fill="white"
      />
      <path d="M26.918 43.0225V51.7497H24.8086V43.0225H26.918Z" fill="white" />
    </svg>
  )
}
export const VideoIcon = () => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4164_353)">
        <path d="M14.6245 63L8.98828 57.375H14.6245V63Z" fill="#AD2337" />
        <path d="M57.375 63L63.0112 57.375H57.375V63Z" fill="#AD2337" />
        <path
          d="M57.3755 14.625H48.3867V5.63623L57.3755 14.625Z"
          fill="#B2B2B2"
        />
        <path
          d="M48.375 5.625H16.4138C15.9393 5.625 15.4844 5.81346 15.1489 6.14891C14.8135 6.48437 14.625 6.93934 14.625 7.41375V64.7887C14.625 65.2642 14.8131 65.7203 15.1482 66.0576C15.4834 66.3948 15.9383 66.5858 16.4138 66.5887H55.5863C55.8265 66.5874 56.064 66.5379 56.2848 66.4433C56.5057 66.3487 56.7053 66.2108 56.872 66.0378C57.0387 65.8648 57.1691 65.6602 57.2555 65.436C57.3419 65.2118 57.3825 64.9726 57.375 64.7325V14.625H48.375V5.625Z"
          fill="#E9E9E0"
        />
        <path
          d="M10.125 37.125H61.875C62.1734 37.125 62.4595 37.2435 62.6705 37.4545C62.8815 37.6655 63 37.9516 63 38.25V57.375H9V38.25C9 37.9516 9.11853 37.6655 9.32951 37.4545C9.54048 37.2435 9.82663 37.125 10.125 37.125Z"
          fill="#F15668"
        />
        <path
          d="M55.0966 47.3863C55.0966 48.3465 54.9119 49.1604 54.5426 49.828C54.1733 50.4956 53.6733 51.0028 53.0426 51.3493C52.4148 51.6959 51.7102 51.8692 50.929 51.8692C50.1449 51.8692 49.4389 51.6945 48.8111 51.3451C48.1832 50.9956 47.6847 50.4885 47.3153 49.8238C46.9489 49.1562 46.7656 48.3437 46.7656 47.3863C46.7656 46.426 46.9489 45.6121 47.3153 44.9445C47.6847 44.2769 48.1832 43.7698 48.8111 43.4232C49.4389 43.0766 50.1449 42.9033 50.929 42.9033C51.7102 42.9033 52.4148 43.0766 53.0426 43.4232C53.6733 43.7698 54.1733 44.2769 54.5426 44.9445C54.9119 45.6121 55.0966 46.426 55.0966 47.3863ZM52.9403 47.3863C52.9403 46.8181 52.8594 46.338 52.6974 45.9459C52.5384 45.5539 52.3082 45.257 52.0071 45.0553C51.7088 44.8536 51.3494 44.7528 50.929 44.7528C50.5114 44.7528 50.152 44.8536 49.8509 45.0553C49.5497 45.257 49.3182 45.5539 49.1562 45.9459C48.9972 46.338 48.9176 46.8181 48.9176 47.3863C48.9176 47.9545 48.9972 48.4346 49.1562 48.8266C49.3182 49.2187 49.5497 49.5155 49.8509 49.7172C50.152 49.9189 50.5114 50.0198 50.929 50.0198C51.3494 50.0198 51.7088 49.9189 52.0071 49.7172C52.3082 49.5155 52.5384 49.2187 52.6974 48.8266C52.8594 48.4346 52.9403 47.9545 52.9403 47.3863Z"
          fill="white"
        />
        <path
          d="M39.4531 51.7497V43.0225H45.5384V44.7355H41.5625V46.5253H45.2273V48.2426H41.5625V50.0367H45.5384V51.7497H39.4531Z"
          fill="white"
        />
        <path
          d="M33.9134 51.7497H30.6875V43.0225H33.9091C34.7983 43.0225 35.5639 43.1972 36.206 43.5466C36.8509 43.8932 37.348 44.3932 37.6974 45.0466C38.0469 45.6972 38.2216 46.4756 38.2216 47.3818C38.2216 48.2909 38.0469 49.0722 37.6974 49.7256C37.3509 50.379 36.8551 50.8804 36.2102 51.2298C35.5653 51.5764 34.7997 51.7497 33.9134 51.7497ZM32.7969 49.9514H33.8324C34.321 49.9514 34.7344 49.8691 35.0724 49.7043C35.4134 49.5367 35.6705 49.2654 35.8438 48.8904C36.0199 48.5125 36.108 48.0097 36.108 47.3818C36.108 46.754 36.0199 46.254 35.8438 45.8818C35.6676 45.5068 35.4077 45.2369 35.0639 45.0722C34.723 44.9046 34.3026 44.8208 33.8026 44.8208H32.7969V49.9514Z"
          fill="white"
        />
        <path
          d="M29.3633 43.0225V51.7497H27.2539V43.0225H29.3633Z"
          fill="white"
        />
        <path
          d="M19.978 43.0225L21.9297 49.4145H22.0021L23.9538 43.0225H26.3146L23.37 51.7497H20.5618L17.6172 43.0225H19.978Z"
          fill="white"
        />
        <path
          d="M29.1719 16.2451V22.9726V29.6889L42.8294 22.9726L29.1719 16.2451Z"
          stroke="#F15668"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4164_353">
          <rect width="72" height="72" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const UploadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M13.0535 2.49392C12.9114 2.33852 12.7106 2.25 12.5 2.25C12.2894 2.25 12.0886 2.33852 11.9465 2.49392L7.94648 6.86892C7.66698 7.17462 7.68822 7.64902 7.99392 7.92852C8.29963 8.20802 8.77402 8.18678 9.05352 7.88108L11.75 4.9318V16C11.75 16.4142 12.0858 16.75 12.5 16.75C12.9142 16.75 13.25 16.4142 13.25 16V4.9318L15.9465 7.88108C16.226 8.18678 16.7004 8.20802 17.0061 7.92852C17.3118 7.64902 17.333 7.17462 17.0535 6.86892L13.0535 2.49392Z"
        fill="#1C274C"
      />
      <path
        d="M4.25 15C4.25 14.5858 3.91422 14.25 3.5 14.25C3.08579 14.25 2.75 14.5858 2.75 15V15.0549C2.74998 16.4225 2.74996 17.5248 2.86652 18.3918C2.98754 19.2919 3.24643 20.0497 3.84835 20.6516C4.45027 21.2536 5.20814 21.5125 6.10825 21.6335C6.97522 21.75 8.07754 21.75 9.44513 21.75H15.5549C16.9225 21.75 18.0248 21.75 18.8918 21.6335C19.7919 21.5125 20.5497 21.2536 21.1517 20.6516C21.7536 20.0497 22.0125 19.2919 22.1335 18.3918C22.25 17.5248 22.25 16.4225 22.25 15.0549V15C22.25 14.5858 21.9142 14.25 21.5 14.25C21.0858 14.25 20.75 14.5858 20.75 15C20.75 16.4354 20.7484 17.4365 20.6469 18.1919C20.5482 18.9257 20.3678 19.3142 20.091 19.591C19.8142 19.8678 19.4257 20.0482 18.6919 20.1469C17.9365 20.2484 16.9354 20.25 15.5 20.25H9.5C8.06459 20.25 7.06347 20.2484 6.30812 20.1469C5.57435 20.0482 5.18577 19.8678 4.90901 19.591C4.63225 19.3142 4.4518 18.9257 4.35315 18.1919C4.25159 17.4365 4.25 16.4354 4.25 15Z"
        fill="#1C274C"
      />
    </svg>
  )
}

export const LinkIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.61597 17.2917C4.66813 17.2919 3.7415 17.011 2.95335 16.4845C2.16519 15.958 1.55092 15.2096 1.18827 14.3338C0.825613 13.4581 0.730874 12.4945 0.916037 11.5649C1.1012 10.6353 1.55794 9.78158 2.22847 9.11165L9.29931 2.03999C9.41655 1.92274 9.57557 1.85687 9.74139 1.85687C9.9072 1.85687 10.0662 1.92274 10.1835 2.03999C10.3007 2.15724 10.3666 2.31626 10.3666 2.48207C10.3666 2.64788 10.3007 2.80691 10.1835 2.92415L3.11181 9.99499C2.76945 10.3208 2.49576 10.7118 2.30686 11.145C2.11796 11.5782 2.01768 12.0449 2.01193 12.5175C2.00617 12.99 2.09506 13.459 2.27334 13.8967C2.45163 14.3344 2.71572 14.7319 3.05004 15.066C3.38436 15.4 3.78216 15.6638 4.21999 15.8417C4.65783 16.0196 5.12685 16.1081 5.59941 16.102C6.07198 16.0958 6.53854 15.9951 6.9716 15.8059C7.40465 15.6166 7.79545 15.3426 8.12097 15L17.2543 5.86665C17.6728 5.43446 17.9047 4.85506 17.8999 4.25344C17.895 3.65183 17.6539 3.07623 17.2285 2.65081C16.8031 2.22539 16.2275 1.98425 15.6258 1.97942C15.0242 1.97459 14.4448 2.20645 14.0126 2.62499L6.64764 9.99499C6.45226 10.1904 6.3425 10.4554 6.3425 10.7317C6.3425 11.008 6.45226 11.2729 6.64764 11.4683C6.84301 11.6637 7.108 11.7735 7.38431 11.7735C7.66061 11.7735 7.9256 11.6637 8.12097 11.4683L12.8335 6.75499C12.8911 6.69527 12.96 6.64762 13.0363 6.61483C13.1125 6.58204 13.1945 6.56476 13.2775 6.564C13.3605 6.56324 13.4428 6.57901 13.5196 6.6104C13.5964 6.64179 13.6663 6.68817 13.725 6.74682C13.7837 6.80548 13.8301 6.87524 13.8616 6.95203C13.893 7.02883 13.9089 7.11112 13.9082 7.19411C13.9075 7.27709 13.8903 7.35911 13.8576 7.43538C13.8249 7.51165 13.7773 7.58064 13.7176 7.63832L9.00431 12.3525C8.57454 12.7824 7.99162 13.0239 7.38377 13.024C6.77591 13.0241 6.19293 12.7827 5.76306 12.3529C5.33318 11.9231 5.09164 11.3402 5.09156 10.7324C5.09148 10.1245 5.33288 9.54153 5.76264 9.11165L13.1293 1.74999C13.7935 1.08573 14.6943 0.712511 15.6336 0.712433C16.5729 0.712355 17.4738 1.08542 18.1381 1.74957C18.8023 2.41372 19.1755 3.31454 19.1756 4.25386C19.1757 5.19318 18.8026 6.09406 18.1385 6.75832L9.00514 15.8883C8.56103 16.3347 8.03283 16.6885 7.45109 16.9294C6.86934 17.1703 6.24561 17.2934 5.61597 17.2917Z"
        fill="#A1A1A1"
        className="group-hover:fill-primary"
      />
    </svg>
  )
}

export const ShareLinkIcon = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 7.9375C3.6632 7.9375 3.1875 8.4132 3.1875 9C3.1875 9.5868 3.6632 10.0625 4.25 10.0625C4.8368 10.0625 5.3125 9.5868 5.3125 9C5.3125 8.4132 4.8368 7.9375 4.25 7.9375ZM2.125 9C2.125 7.82639 3.07639 6.875 4.25 6.875C5.4236 6.875 6.375 7.82639 6.375 9C6.375 10.1736 5.4236 11.125 4.25 11.125C3.07639 11.125 2.125 10.1736 2.125 9Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 3.15625C12.1632 3.15625 11.6875 3.63195 11.6875 4.21875C11.6875 4.80555 12.1632 5.28125 12.75 5.28125C13.3368 5.28125 13.8125 4.80555 13.8125 4.21875C13.8125 3.63195 13.3368 3.15625 12.75 3.15625ZM10.625 4.21875C10.625 3.04514 11.5764 2.09375 12.75 2.09375C13.9236 2.09375 14.875 3.04514 14.875 4.21875C14.875 5.39235 13.9236 6.34375 12.75 6.34375C11.5764 6.34375 10.625 5.39235 10.625 4.21875Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 12.7188C12.1632 12.7188 11.6875 13.1944 11.6875 13.7812C11.6875 14.3681 12.1632 14.8438 12.75 14.8438C13.3368 14.8438 13.8125 14.3681 13.8125 13.7812C13.8125 13.1944 13.3368 12.7188 12.75 12.7188ZM10.625 13.7812C10.625 12.6076 11.5764 11.6562 12.75 11.6562C13.9236 11.6562 14.875 12.6076 14.875 13.7812C14.875 14.9549 13.9236 15.9062 12.75 15.9062C11.5764 15.9062 10.625 14.9549 10.625 13.7812Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.17574 9.5209C5.31958 9.26517 5.64349 9.17448 5.89921 9.31832L11.6214 12.537C11.8772 12.6809 11.9679 13.0048 11.824 13.2605C11.6802 13.5162 11.3563 13.6069 11.1005 13.4631L5.37832 10.2444C5.1226 10.1005 5.0319 9.77662 5.17574 9.5209Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.824 4.73965C11.9679 4.99537 11.8772 5.31928 11.6214 5.46312L5.89921 8.68183C5.64349 8.82567 5.31958 8.73498 5.17574 8.47925C5.0319 8.22353 5.1226 7.89962 5.37832 7.75578L11.1005 4.53707C11.3563 4.39323 11.6802 4.48392 11.824 4.73965Z"
        fill="white"
      />
    </svg>
  )
}

export const IconDownload = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.51562 6.875C4.30428 6.875 4.10159 6.95896 3.95215 7.1084C3.80271 7.25784 3.71875 7.46053 3.71875 7.67188V14.5781C3.71875 14.7895 3.80271 14.9922 3.95215 15.1416C4.10159 15.291 4.30428 15.375 4.51562 15.375H12.4844C12.6957 15.375 12.8984 15.291 13.0479 15.1416C13.1973 14.9922 13.2812 14.7895 13.2812 14.5781V7.67188C13.2812 7.46053 13.1973 7.25784 13.0479 7.1084C12.8984 6.95896 12.6957 6.875 12.4844 6.875H11.1562C10.8628 6.875 10.625 6.63715 10.625 6.34375C10.625 6.05035 10.8628 5.8125 11.1562 5.8125H12.4844C12.9775 5.8125 13.4505 6.0084 13.7992 6.3571C14.1479 6.7058 14.3438 7.17874 14.3438 7.67188V14.5781C14.3438 15.0713 14.1479 15.5442 13.7992 15.8929C13.4505 16.2416 12.9775 16.4375 12.4844 16.4375H4.51562C4.02249 16.4375 3.54955 16.2416 3.20085 15.8929C2.85215 15.5442 2.65625 15.0713 2.65625 14.5781V7.67188C2.65625 7.17874 2.85215 6.7058 3.20085 6.3571C3.54955 6.0084 4.02249 5.8125 4.51562 5.8125H5.84375C6.13715 5.8125 6.375 6.05035 6.375 6.34375C6.375 6.63715 6.13715 6.875 5.84375 6.875H4.51562Z"
        fill="#404041"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.4681 9.1556C5.67557 8.94813 6.01193 8.94813 6.2194 9.1556L8.5 11.4362L10.7806 9.1556C10.9881 8.94813 11.3244 8.94813 11.5319 9.1556C11.7394 9.36307 11.7394 9.69943 11.5319 9.9069L8.87565 12.5632C8.66818 12.7706 8.33182 12.7706 8.12435 12.5632L5.4681 9.9069C5.26063 9.69943 5.26063 9.36307 5.4681 9.1556Z"
        fill="#404041"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 1.5625C8.7934 1.5625 9.03125 1.80035 9.03125 2.09375V11.6562C9.03125 11.9497 8.7934 12.1875 8.5 12.1875C8.2066 12.1875 7.96875 11.9497 7.96875 11.6562V2.09375C7.96875 1.80035 8.2066 1.5625 8.5 1.5625Z"
        fill="#404041"
      />
    </svg>
  )
}

export const IconCongrats = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50 65.625C48.9805 65.625 47.9687 65.5781 46.9707 65.4902C41.8209 65.03 36.8412 63.4148 32.4017 60.7648C27.9622 58.1148 24.1772 54.498 21.3281 50.1836L3.90625 81.25H26.3672L37.6953 100L53.8144 65.4121C52.5478 65.5531 51.2744 65.6242 50 65.625Z"
        fill="#FFB800"
      />
      <path
        d="M78.7109 50.1445C74.585 56.3932 68.5408 61.1323 61.4883 63.6484L53.457 81.1523L62.3047 100L73.6328 81.25H96.0937L78.7109 50.1445Z"
        fill="#FFB800"
      />
      <path
        d="M50.0039 40.625C55.1816 40.625 59.3789 36.4277 59.3789 31.25C59.3789 26.0723 55.1816 21.875 50.0039 21.875C44.8262 21.875 40.6289 26.0723 40.6289 31.25C40.6289 36.4277 44.8262 40.625 50.0039 40.625Z"
        fill="#FFB800"
      />
      <path
        d="M50 3.125C34.4922 3.125 21.875 15.7422 21.875 31.25C21.875 46.7578 34.4922 59.375 50 59.375C65.5078 59.375 78.125 46.7578 78.125 31.25C78.125 15.7422 65.5078 3.125 50 3.125ZM50 46.875C46.9097 46.875 43.8887 45.9586 41.3192 44.2417C38.7497 42.5248 36.747 40.0845 35.5644 37.2294C34.3818 34.3743 34.0723 31.2327 34.6752 28.2017C35.2781 25.1708 36.7663 22.3867 38.9515 20.2015C41.1367 18.0163 43.9208 16.5281 46.9517 15.9252C49.9827 15.3223 53.1243 15.6318 55.9794 16.8144C58.8345 17.997 61.2748 19.9997 62.9917 22.5692C64.7086 25.1387 65.625 28.1597 65.625 31.25C65.6203 35.3926 63.9727 39.3642 61.0434 42.2934C58.1142 45.2227 54.1426 46.8703 50 46.875Z"
        fill="#FFB800"
      />
    </svg>
  )
}

export const IconLoudSpeaker = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_12751_6366)">
        <path
          d="M10.4038 18.4791L9.83563 18.631C9.39969 18.7469 8.93969 18.5791 8.68376 18.211L6.25188 14.7428L10.34 15.1788L11.1159 17.0269C11.3638 17.6269 11.0319 18.311 10.4038 18.4791ZM2.51188 7.52284L1.19188 7.87878C0.335943 8.11065 -0.176245 8.99065 0.0559428 9.8469L0.89188 12.9669C1.12001 13.8228 2.00001 14.331 2.86001 14.0988L4.18001 13.7469L2.51188 7.52284ZM15.6663 13.8078L12.4303 1.7294C12.3331 1.36597 11.9016 1.21378 11.5978 1.43503L3.67032 7.2144L5.33751 13.4363L15.0925 14.4782C15.4663 14.5182 15.7638 14.1703 15.6663 13.8078ZM16.1572 3.80597C16.0659 3.80597 15.9744 3.78284 15.89 3.73409C15.6338 3.58628 15.5463 3.25878 15.6941 3.00284L16.4681 1.66253C16.6156 1.40597 16.9441 1.31847 17.1994 1.46659C17.4556 1.6144 17.5431 1.9419 17.3953 2.19784L16.6213 3.53815C16.5219 3.71003 16.3419 3.80597 16.1572 3.80597ZM16.9216 7.53378C16.685 7.53378 16.4688 7.37597 16.4047 7.1369C16.3284 6.85128 16.4978 6.55784 16.7834 6.48097L18.2784 6.08065C18.5656 6.0044 18.8578 6.17315 18.9347 6.4594C19.0109 6.74503 18.8416 7.03847 18.5559 7.11534L17.0609 7.51565C17.0138 7.52815 16.9675 7.53378 16.9216 7.53378ZM19.4641 11.9185C19.3728 11.9185 19.2813 11.8953 19.1969 11.8466L17.8566 11.0725C17.6003 10.9247 17.5128 10.5972 17.6606 10.3413C17.8084 10.0847 18.1366 9.99722 18.3919 10.1453L19.7322 10.9194C19.9884 11.0672 20.0759 11.3947 19.9281 11.6507C19.8291 11.8225 19.6488 11.9185 19.4641 11.9185Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_12751_6366">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
    >
      <path
        d="M36.7779 32.8884C35.7039 31.8144 33.9627 31.8144 32.8888 32.8884C31.8148 33.9623 31.8148 35.7035 32.8888 36.7775L40.111 43.9996L32.8889 51.2217C31.8149 52.2957 31.8149 54.0369 32.8889 55.1108C33.9628 56.1847 35.704 56.1847 36.778 55.1108L44 47.8887L51.222 55.1107C52.296 56.1847 54.0372 56.1847 55.1111 55.1107C56.1851 54.0368 56.1851 52.2956 55.1111 51.2216L47.8891 43.9996L55.1112 36.7775C56.1852 35.7036 56.1852 33.9624 55.1112 32.8885C54.0373 31.8145 52.2961 31.8145 51.2221 32.8885L44 40.1105L36.7779 32.8884Z"
        fill="#FFB700"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44 4.58301C40.5624 4.58301 37.2802 5.70714 31.9858 7.52043L29.3185 8.43351C23.8869 10.2927 19.6951 11.7276 16.6944 12.9466C15.1829 13.5607 13.8833 14.1555 12.8369 14.7632C11.8299 15.348 10.8197 16.0774 10.1333 17.0553C9.45488 18.0219 9.10409 19.2102 8.88365 20.3541C8.65448 21.5434 8.51629 22.97 8.4271 24.608C8.25 27.8603 8.25 32.3159 8.25 38.095V43.968C8.25 66.3385 25.1461 77.0639 35.1939 81.4531L35.2933 81.4965C36.5392 82.0409 37.7103 82.5526 39.0559 82.8971C40.4766 83.2608 41.986 83.4163 44 83.4163C46.014 83.4163 47.5234 83.2608 48.9441 82.8971C50.2897 82.5526 51.4608 82.0409 52.7066 81.4965L52.8061 81.4531C62.8539 77.0639 79.75 66.3385 79.75 43.968V38.0957C79.75 32.3162 79.75 27.8605 79.5729 24.608C79.4837 22.97 79.3455 21.5434 79.1164 20.3541C78.8959 19.2102 78.5451 18.0219 77.8667 17.0553C77.1803 16.0774 76.1701 15.348 75.1631 14.7632C74.1167 14.1555 72.8171 13.5607 71.3056 12.9466C68.3048 11.7276 64.113 10.2927 58.6815 8.43349L56.0143 7.52044C50.7198 5.70715 47.4376 4.58301 44 4.58301ZM33.2956 12.8854C39.2155 10.859 41.5883 10.083 44 10.083C46.4117 10.083 48.7845 10.859 54.7044 12.8854L56.8047 13.6044C62.3509 15.5028 66.3956 16.8885 69.2355 18.0422C70.653 18.618 71.68 19.1006 72.4009 19.5193C72.7569 19.726 73.0021 19.8965 73.1659 20.0297C73.3046 20.1425 73.3576 20.2064 73.3653 20.2158C73.3723 20.2272 73.4179 20.3034 73.4821 20.4836C73.5554 20.6894 73.6366 20.9843 73.7157 21.3949C73.8758 22.2259 73.9972 23.3674 74.081 24.907C74.249 27.9914 74.25 32.2969 74.25 38.1941V43.968C74.25 62.9434 60.0604 72.2823 50.6044 76.413C49.2424 77.008 48.4558 77.3448 47.5801 77.5689C46.7438 77.783 45.7233 77.9163 44 77.9163C42.2767 77.9163 41.2562 77.783 40.4199 77.5689C39.5442 77.3447 38.7576 77.0079 37.3955 76.413C27.9396 72.2823 13.75 62.9434 13.75 43.968V38.1941C13.75 32.2969 13.751 27.9914 13.919 24.907C14.0028 23.3674 14.1241 22.2259 14.2843 21.3949C14.3634 20.9843 14.4446 20.6894 14.5179 20.4836C14.5821 20.3035 14.6276 20.2273 14.6347 20.2158C14.6423 20.2065 14.6953 20.1426 14.8341 20.0297C14.9979 19.8965 15.2431 19.726 15.5991 19.5193C16.32 19.1006 17.347 18.618 18.7645 18.0422C21.6044 16.8885 25.6491 15.5028 31.1953 13.6044L33.2956 12.8854Z"
        fill="#FFB700"
      />
    </svg>
  )
}

export const IRibbon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.9997 10.0835C31.3432 10.0835 21.083 20.3436 21.083 33.0002C21.083 45.6567 31.3432 55.9168 43.9997 55.9168C56.6562 55.9168 66.9164 45.6567 66.9164 33.0002C66.9164 20.3436 56.6562 10.0835 43.9997 10.0835ZM15.5831 33.0002C15.5831 17.3061 28.3056 4.5835 43.9997 4.5835C59.6938 4.5835 72.4164 17.3061 72.4164 33.0002C72.4164 36.4504 71.8015 39.7571 70.6753 42.8165L79.0618 51.5C80.0054 52.4769 80.7913 53.2906 81.3785 53.9687C81.9569 54.6366 82.5499 55.4005 82.9001 56.2881C84.1226 59.3858 83.1392 63.0519 80.1905 64.8571C79.3426 65.3761 78.3768 65.5914 77.5466 65.7304C76.6976 65.8725 75.6189 65.9865 74.3461 66.1212L74.2607 66.1302C72.5771 66.3082 72.2572 66.365 72.0399 66.4483C71.3868 66.6986 70.8504 67.2319 70.5848 67.975C70.4912 68.2365 70.4342 68.6092 70.2636 70.3382L70.2555 70.4197C70.125 71.7436 70.0155 72.8533 69.8795 73.7241C69.747 74.5724 69.5453 75.5371 69.0614 76.3844C67.3405 79.3981 63.7128 80.5284 60.5661 79.1971C59.6803 78.8223 58.9306 78.195 58.2901 77.6004C57.6349 76.992 56.8489 76.1782 55.9058 75.2017L55.8339 75.1272L43.9997 62.6611L32.1492 75.1443L32.0937 75.2017C31.1505 76.1782 30.3646 76.992 29.7093 77.6004C29.0688 78.195 28.3191 78.8223 27.4334 79.1971C24.2866 80.5284 20.6589 79.3981 18.938 76.3844C18.4542 75.5371 18.2524 74.5724 18.1199 73.7241C17.9839 72.8533 17.8745 71.7436 17.7439 70.4196L17.7358 70.3382C17.5653 68.6092 17.5082 68.2365 17.4147 67.975C17.149 67.2319 16.6126 66.6986 15.9595 66.4483C15.7422 66.365 15.4224 66.3082 13.7387 66.1302L13.6534 66.1212C12.3805 65.9866 11.3018 65.8725 10.4528 65.7304C9.62262 65.5914 8.65681 65.3761 7.80897 64.8571C4.86026 63.0519 3.8768 59.3858 5.09928 56.2881C5.44957 55.4005 6.0425 54.6366 6.62095 53.9687C7.20818 53.2906 7.99416 52.4768 8.93783 51.4998L17.3242 42.8165C16.198 39.7571 15.5831 36.4504 15.5831 33.0002ZM19.9009 48.0656L12.9487 55.264C11.9362 56.3122 11.2559 57.018 10.7786 57.5692C10.3313 58.0857 10.2268 58.2856 10.2158 58.3066C9.88478 59.1462 10.2135 59.857 10.6499 60.1467C10.6826 60.1575 10.8692 60.2235 11.3609 60.3058C12.0253 60.4171 12.9359 60.5146 14.3172 60.6607C14.4096 60.6705 14.5013 60.68 14.5922 60.6896C15.8357 60.8196 16.9445 60.9356 17.928 61.3126C20.1243 62.1545 21.8045 63.9162 22.5936 66.1233C22.9466 67.1106 23.0554 68.224 23.1823 69.523C23.1912 69.6138 23.2001 69.7055 23.2093 69.7982C23.35 71.225 23.4451 72.1776 23.5541 72.8755C23.6473 73.4729 23.7225 73.6643 23.7251 73.6758C24.0177 74.1684 24.6193 74.4121 25.2831 74.1348C25.2831 74.1348 25.4664 74.0346 25.9672 73.5697C26.4975 73.0773 27.1766 72.3757 28.1847 71.332L28.193 71.3234L38.1663 60.8175C30.4814 59.2141 23.9359 54.5065 19.9009 48.0656ZM49.8332 60.8175C57.5181 59.2141 64.0635 54.5064 68.0986 48.0656L75.0508 55.264C76.0632 56.3122 76.7435 57.018 77.2208 57.5692C77.6681 58.0857 77.7726 58.2856 77.7836 58.3066C78.1145 59.1461 77.7859 59.857 77.3495 60.1467C77.3168 60.1575 77.1302 60.2235 76.6385 60.3058C75.9742 60.4171 75.0636 60.5146 73.6822 60.6607C73.5898 60.6705 73.4982 60.68 73.4072 60.6896C72.1638 60.8196 71.055 60.9356 70.0714 61.3126C67.8751 62.1545 66.195 63.9162 65.4058 66.1233C65.0528 67.1106 64.9441 68.224 64.8171 69.5229C64.8083 69.6138 64.7993 69.7055 64.7902 69.7982C64.6494 71.225 64.5544 72.1776 64.4454 72.8755C64.3521 73.4728 64.277 73.6642 64.2744 73.6758C63.9806 74.1702 63.3758 74.4138 62.7091 74.1318L62.7168 74.1349C62.7168 74.1349 62.533 74.0346 62.0323 73.5697C61.5019 73.0773 60.8228 72.3757 59.8148 71.332L59.8065 71.3234L49.8332 60.8175ZM43.9997 25.7933C43.7866 26.1623 43.5495 26.5873 43.2702 27.0884L42.9097 27.735C42.8843 27.7807 42.857 27.8305 42.8278 27.8839C42.5399 28.4105 42.063 29.2825 41.2679 29.8861C40.4562 30.5023 39.4798 30.7143 38.9089 30.8383C38.8517 30.8507 38.7985 30.8622 38.7501 30.8732L38.0501 31.0316C37.4078 31.1769 36.8846 31.2955 36.4372 31.4079C36.7282 31.7661 37.1062 32.2109 37.5978 32.7858L38.075 33.3438C38.1089 33.3834 38.1457 33.4258 38.1849 33.471C38.5807 33.9268 39.2196 34.6628 39.5151 35.6131C39.8071 36.552 39.7064 37.5191 39.6429 38.1292C39.6365 38.19 39.6306 38.2473 39.6254 38.3007L39.5532 39.0452C39.4863 39.7355 39.4343 40.2865 39.3997 40.7345C39.7818 40.5662 40.2164 40.3663 40.7328 40.1285L41.3882 39.8267C41.4333 39.806 41.4828 39.7826 41.5362 39.7574C42.0624 39.5093 42.9779 39.0775 43.9997 39.0775C45.0215 39.0775 45.937 39.5093 46.4632 39.7574C46.5167 39.7826 46.5661 39.806 46.6112 39.8267L47.2666 40.1285C47.783 40.3663 48.2176 40.5662 48.5997 40.7345C48.5651 40.2865 48.5131 39.7355 48.4462 39.0452L48.3741 38.3007C48.3689 38.2473 48.3629 38.19 48.3566 38.1292C48.293 37.5191 48.1923 36.552 48.4843 35.6131C48.7798 34.6628 49.4188 33.9268 49.8145 33.471C49.8537 33.4258 49.8905 33.3834 49.9244 33.3438L50.4016 32.7858C50.8933 32.2109 51.2712 31.7661 51.5622 31.4079C51.1148 31.2955 50.5916 31.1769 49.9494 31.0316L49.2494 30.8732C49.2009 30.8622 49.1478 30.8507 49.0906 30.8383C48.5196 30.7143 47.5432 30.5023 46.7315 29.8861C45.9364 29.2825 45.4596 28.4105 45.1716 27.8839C45.1424 27.8305 45.1152 27.7807 45.0897 27.735L44.7292 27.0884C44.4499 26.5873 44.2129 26.1623 43.9997 25.7933ZM40.3825 21.2655C41.0138 20.4411 42.1602 19.2502 43.9997 19.2502C45.8393 19.2502 46.9856 20.4411 47.6169 21.2655C48.2194 22.0523 48.8262 23.1414 49.4483 24.258C49.4766 24.3087 49.5049 24.3595 49.5332 24.4104L49.8937 25.057C49.9773 25.207 50.0431 25.325 50.1007 25.4259C50.2009 25.4494 50.3174 25.4759 50.4631 25.5088L51.1631 25.6672C51.2204 25.6802 51.2777 25.6931 51.3351 25.7061C52.537 25.9777 53.7316 26.2476 54.6486 26.609C55.6611 27.008 57.0336 27.7851 57.5625 29.4861C58.0821 31.1571 57.4264 32.5725 56.8537 33.4822C56.3237 34.3241 55.5182 35.2656 54.6935 36.2296C54.6562 36.2731 54.6189 36.3167 54.5816 36.3604L54.1044 36.9184C53.978 37.0663 53.8827 37.1778 53.8024 37.2743C53.8133 37.4075 53.8283 37.5627 53.8484 37.7702L53.9206 38.5148C53.9261 38.5716 53.9316 38.6283 53.9371 38.6849C54.0624 39.9753 54.1835 41.2224 54.1391 42.2199C54.0925 43.2658 53.8414 44.8491 52.4218 45.9268C50.9573 47.0385 49.3399 46.7962 48.3143 46.5023C47.3692 46.2315 46.2526 45.717 45.128 45.1988C45.0741 45.174 45.0202 45.1492 44.9663 45.1244L44.311 44.8226C44.1883 44.7662 44.0875 44.7198 43.9997 44.68C43.9119 44.7198 43.8111 44.7662 43.6885 44.8226L43.0331 45.1244C42.9792 45.1492 42.9253 45.174 42.8715 45.1988C41.7468 45.717 40.6302 46.2315 39.6851 46.5023C38.6595 46.7962 37.0421 47.0385 35.5776 45.9268C34.158 44.8491 33.907 43.2658 33.8604 42.2199C33.8159 41.2224 33.937 39.9753 34.0624 38.6849C34.0679 38.6283 34.0734 38.5716 34.0789 38.5148L34.151 37.7702C34.1711 37.5627 34.1861 37.4075 34.1971 37.2743C34.1168 37.1778 34.0215 37.0663 33.895 36.9184L33.4178 36.3604C33.3805 36.3167 33.3432 36.2731 33.3059 36.2296C32.4812 35.2656 31.6757 34.3241 31.1457 33.4822C30.573 32.5725 29.9173 31.1571 30.4369 29.4861C30.9659 27.7851 32.3383 27.008 33.3508 26.609C34.2678 26.2476 35.4624 25.9777 36.6644 25.7061C36.7217 25.6931 36.779 25.6802 36.8363 25.6672L37.5363 25.5088C37.682 25.4759 37.7985 25.4494 37.8987 25.4259C37.9563 25.325 38.0221 25.207 38.1057 25.057L38.4662 24.4104C38.4945 24.3595 38.5229 24.3087 38.5511 24.258C39.1732 23.1414 39.78 22.0523 40.3825 21.2655Z"
        fill="#FFB700"
      />
    </svg>
  )
}

export const IconSupportCenter = ({ onClick }: { onClick?: () => void }) => {
  return (
    <svg
      width="20"
      height="25"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className="cursor-pointer"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.707 14.7072C7.51947 14.8947 7.26516 15 7 15C6.73484 15 6.48053 14.8947 6.293 14.7072L2.293 10.7072C2.10553 10.5197 2.00021 10.2654 2.00021 10.0002C2.00021 9.73505 2.10553 9.48074 2.293 9.29322L6.293 5.29321C6.4816 5.11106 6.7342 5.01026 6.9964 5.01254C7.2586 5.01482 7.50941 5.11999 7.69482 5.3054C7.88023 5.4908 7.98539 5.74162 7.98767 6.00381C7.98995 6.26601 7.88916 6.51861 7.707 6.70721L5.414 9.00021L17 9.00021C17.2652 9.00021 17.5196 9.10557 17.7071 9.29311C17.8946 9.48064 18 9.735 18 10.0002C18 10.2654 17.8946 10.5198 17.7071 10.7073C17.5196 10.8949 17.2652 11.0002 17 11.0002L5.414 11.0002L7.707 13.2932C7.89447 13.4807 7.99979 13.7351 7.99979 14.0002C7.99979 14.2654 7.89447 14.5197 7.707 14.7072Z"
        fill="#404041"
      />
    </svg>
  )
}

export const IconRequestForm = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.6785 25.3378L18.6862 22.6673C18.6862 21.9309 19.2847 21.334 20.0229 21.334C20.7611 21.334 21.3595 21.9309 21.3595 22.6673V25.3026C21.3595 25.9447 21.3595 26.2657 21.5654 26.4626C21.7713 26.6594 22.0863 26.646 22.7162 26.6194C25.2001 26.5142 26.7262 26.1782 27.8019 25.1052C28.8801 24.0297 29.2159 22.5028 29.3205 20.0147C29.3413 19.5213 29.3517 19.2746 29.2595 19.11C29.1674 18.9454 28.7995 18.7399 28.0639 18.3291C27.2468 17.8728 26.6945 17.0011 26.6945 16.0007C26.6945 15.0002 27.2468 14.1285 28.0639 13.6722C28.7995 13.2614 29.1674 13.0559 29.2595 12.8914C29.3517 12.7268 29.3413 12.48 29.3205 11.9866C29.2159 9.49851 28.8801 7.97162 27.8019 6.89608C26.6316 5.7287 24.9283 5.43372 22.0383 5.35919C21.6655 5.34957 21.3595 5.65022 21.3595 6.02223V9.33398C21.3595 10.0704 20.7611 10.6673 20.0229 10.6673C19.2847 10.6673 18.6862 10.0704 18.6862 9.33398L18.6765 5.99872C18.6755 5.63128 18.3766 5.33398 18.0082 5.33398H13.328C8.28715 5.33398 5.76673 5.33398 4.20074 6.89608C3.12252 7.97162 2.78668 9.49851 2.68207 11.9866C2.66133 12.48 2.65095 12.7268 2.74309 12.8913C2.83523 13.0559 3.20307 13.2614 3.93874 13.6722C4.75578 14.1285 5.30806 15.0002 5.30806 16.0007C5.30806 17.0011 4.75578 17.8728 3.93874 18.3291C3.20308 18.7399 2.83523 18.9454 2.74309 19.11C2.65095 19.2746 2.66133 19.5213 2.68207 20.0147C2.78668 22.5028 3.12252 24.0297 4.20074 25.1052C5.76673 26.6673 8.28715 26.6673 13.328 26.6673H17.3418C17.9703 26.6673 18.2845 26.6673 18.4801 26.4727C18.6757 26.2782 18.6767 25.9647 18.6785 25.3378ZM21.3595 17.334V14.6673C21.3595 13.9309 20.7611 13.334 20.0229 13.334C19.2847 13.334 18.6862 13.9309 18.6862 14.6673V17.334C18.6862 18.0704 19.2847 18.6673 20.0229 18.6673C20.7611 18.6673 21.3595 18.0704 21.3595 17.334Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const IconChat = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        d="M20.3896 2.66797C23.5535 2.66797 25.1357 2.66749 26.3398 3.29297C27.3545 3.82005 28.1819 4.64745 28.709 5.66211C29.3345 6.86621 29.334 8.44847 29.334 11.6123V20.3896C29.334 23.5535 29.3345 25.1357 28.709 26.3398C28.1819 27.3545 27.3545 28.1819 26.3398 28.709C25.1357 29.3345 23.5535 29.334 20.3896 29.334H18.2236V19.7051H21.1865L21.7783 16.001H18.2236V13.4082C18.2237 12.3712 18.5941 11.5566 20.2236 11.5566H21.9268V8.14941C20.9638 8.00127 19.9268 7.85254 18.9639 7.85254C15.9269 7.85256 13.7783 9.70477 13.7783 13.0381V16.001H10.4453V19.7051H13.7783V29.334H11.6123C8.44847 29.334 6.86621 29.3345 5.66211 28.709C4.64745 28.1819 3.82005 27.3545 3.29297 26.3398C2.66749 25.1357 2.66797 23.5535 2.66797 20.3896V11.6123C2.66797 8.44847 2.66749 6.86621 3.29297 5.66211C3.82005 4.64745 4.64745 3.82005 5.66211 3.29297C6.86621 2.66749 8.44847 2.66797 11.6123 2.66797H20.3896Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const IconAccess = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        d="M20.6654 10.0007C20.6654 12.578 18.576 14.6673 15.9987 14.6673C13.4214 14.6673 11.332 12.578 11.332 10.0007C11.332 7.42332 13.4214 5.33398 15.9987 5.33398C18.576 5.33398 20.6654 7.42332 20.6654 10.0007Z"
        fill="currentColor"
      />
      <path
        d="M24 22.0007C24 24.578 20.4183 26.6673 16 26.6673C11.5817 26.6673 8 24.578 8 22.0007C8 19.4233 11.5817 17.334 16 17.334C20.4183 17.334 24 19.4233 24 22.0007Z"
        fill="currentColor"
      />
      <path
        d="M9.49737 6.66602C9.73398 6.66602 9.96498 6.68923 10.188 6.73343C9.64463 7.69862 9.33463 8.81279 9.33463 9.99935C9.33463 11.157 9.62971 12.2458 10.1488 13.1945C9.9379 13.2338 9.72012 13.2544 9.49737 13.2544C7.61148 13.2544 6.08267 11.7795 6.08267 9.96019C6.08267 8.14087 7.61148 6.66602 9.49737 6.66602Z"
        fill="currentColor"
      />
      <path
        d="M7.26442 25.314C6.5072 24.4088 6.0013 23.298 6.0013 21.9993C6.0013 20.7404 6.47673 19.658 7.19567 18.7683C4.6561 18.9653 2.66797 20.3543 2.66797 22.0385C2.66797 23.7386 4.69104 25.1378 7.26442 25.314Z"
        fill="currentColor"
      />
      <path
        d="M22.6659 9.99935C22.6659 11.157 22.3708 12.2458 21.8518 13.1945C22.0626 13.2338 22.2804 13.2544 22.5032 13.2544C24.3891 13.2544 25.9179 11.7795 25.9179 9.96019C25.9179 8.14087 24.3891 6.66602 22.5032 6.66602C22.2666 6.66602 22.0356 6.68923 21.8125 6.73343C22.3559 7.69862 22.6659 8.81279 22.6659 9.99935Z"
        fill="currentColor"
      />
      <path
        d="M24.7361 25.314C27.3095 25.1378 29.3326 23.7386 29.3326 22.0385C29.3326 20.3543 27.3444 18.9653 24.8049 18.7683C25.5238 19.658 25.9992 20.7404 25.9992 21.9993C25.9992 23.298 25.4933 24.4088 24.7361 25.314Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const IconContact = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        d="M29.9868 17.5459C30.0314 18.607 29.651 19.6424 28.9289 20.4249C28.2068 21.2074 27.2021 21.6732 26.1351 21.72C26.0727 21.7229 26.0104 21.7243 25.9482 21.7243C25.6647 21.7241 25.3821 21.6936 25.1051 21.6333C24.2834 22.8949 23.2059 23.9721 21.9416 24.7959C20.6772 25.6197 19.2539 26.172 17.7626 26.4176C17.5862 26.9329 17.2343 27.3706 16.7677 27.6553C16.3012 27.9399 15.7492 28.0535 15.2074 27.9765C14.6655 27.8994 14.1677 27.6365 13.8001 27.2332C13.4325 26.8299 13.2181 26.3116 13.1941 25.7678C13.1701 25.224 13.3378 24.689 13.6684 24.2551C13.9991 23.8213 14.4717 23.516 15.0047 23.3919C15.5377 23.2679 16.0975 23.3329 16.5874 23.5757C17.0773 23.8186 17.4664 24.224 17.6876 24.7218C19.7872 24.3357 21.6839 23.2293 23.0472 21.5953C24.4105 19.9614 25.154 17.9035 25.148 15.7804C25.148 10.7646 21.0443 6.684 16 6.684C10.9558 6.684 6.85199 10.7646 6.85199 15.7804C6.85171 17.3314 7.25034 18.8567 8.00998 20.2113C8.03573 20.256 8.05505 20.304 8.0674 20.3541C8.14077 20.5568 8.13293 20.7799 8.04549 20.9771C7.95805 21.1743 7.79771 21.3305 7.59766 21.4135C7.1078 21.6185 6.58168 21.724 6.0502 21.7239C5.98765 21.7239 5.92497 21.7225 5.86216 21.7196C4.79561 21.6722 3.79149 21.2062 3.06997 20.4237C2.34845 19.6412 1.96843 18.6062 2.01322 17.5455C2.03123 17.1226 2.02118 16.7452 2.01136 16.3803C2.00221 16.0367 1.99267 15.6813 2.00837 15.3106C2.0552 14.275 2.50322 13.2975 3.25858 12.583C4.01394 11.8685 5.01805 11.4723 6.06059 11.4774C7.73472 7.66864 11.5595 5 16 5C20.4405 5 24.2653 7.66864 25.9395 11.4775C26.9821 11.4715 27.9865 11.8674 28.742 12.5819C29.4975 13.2965 29.9454 14.2742 29.9916 15.31C30.0073 15.6813 29.9978 16.0366 29.9886 16.3801C29.9789 16.7451 29.9688 17.1227 29.9868 17.5459ZM23.1019 15.7804C23.1015 16.8623 22.8512 17.9296 22.3703 18.9001C21.8895 19.8706 21.1908 20.7183 20.3284 21.3778C19.4659 22.0374 18.4626 22.4911 17.3959 22.7041C16.3292 22.9171 15.2275 22.8836 14.1758 22.6062L11.3012 24.257C11.1562 24.3402 10.9896 24.3789 10.8224 24.368C10.6553 24.3571 10.4952 24.2972 10.3623 24.1958C10.2294 24.0944 10.1298 23.9561 10.0759 23.7984C10.0221 23.6407 10.0165 23.4707 10.0599 23.3098L10.7945 20.5846C9.57788 19.277 8.90093 17.5618 8.89837 15.7804C8.89837 11.8854 12.084 8.71693 16 8.71693C19.916 8.71693 23.1019 11.8854 23.1019 15.7804ZM14.0256 15.7804C14.0256 15.5571 13.9364 15.3429 13.7776 15.185C13.6188 15.0271 13.4034 14.9384 13.1788 14.9384H13.1774C13.01 14.9387 12.8464 14.9884 12.7074 15.0811C12.5684 15.1738 12.4601 15.3054 12.3962 15.4593C12.3324 15.6132 12.3158 15.7824 12.3487 15.9456C12.3815 16.1089 12.4623 16.2588 12.5808 16.3764C12.6993 16.494 12.8502 16.574 13.0144 16.6064C13.1786 16.6387 13.3488 16.6219 13.5034 16.5582C13.658 16.4944 13.7902 16.3865 13.8832 16.248C13.9761 16.1096 14.0258 15.9469 14.0258 15.7804H14.0256ZM16.8469 15.7804C16.8469 15.7529 16.8454 15.7253 16.8424 15.6979C16.8398 15.6704 16.8356 15.643 16.8301 15.6159C16.825 15.589 16.8182 15.5623 16.8097 15.5362C16.8018 15.5099 16.7922 15.484 16.7821 15.4582C16.7719 15.4324 16.7595 15.4083 16.7465 15.3841C16.7336 15.3598 16.7195 15.3362 16.7042 15.3134C16.6887 15.2903 16.6721 15.268 16.6544 15.2466C16.637 15.2251 16.6184 15.2047 16.5986 15.1854C16.5794 15.1658 16.5585 15.1472 16.5371 15.1293C16.5156 15.1124 16.493 15.0956 16.4698 15.0804C16.4469 15.0652 16.4232 15.0512 16.3988 15.0383C16.3744 15.0254 16.3491 15.0136 16.3236 15.003C16.2982 14.9924 16.2722 14.9832 16.2458 14.9755C16.193 14.9586 16.1385 14.9477 16.0832 14.9429C16.0003 14.935 15.9166 14.9389 15.8348 14.9547C15.8076 14.9602 15.7807 14.9672 15.7542 14.9755C15.7277 14.9832 15.7017 14.9924 15.6762 15.003C15.6508 15.0136 15.6254 15.0254 15.6012 15.0383C15.5769 15.0512 15.5532 15.0653 15.53 15.0804C15.5068 15.0956 15.4843 15.1124 15.4634 15.1293C15.4414 15.1472 15.4211 15.1658 15.4013 15.1854C15.3815 15.2047 15.3628 15.2251 15.3454 15.2466C15.3279 15.268 15.3115 15.2903 15.2963 15.3134C15.2808 15.3362 15.2665 15.3598 15.2534 15.3841C15.2404 15.4082 15.2287 15.4329 15.2184 15.4582C15.2077 15.4837 15.1982 15.5098 15.1901 15.5362C15.1823 15.5621 15.1755 15.589 15.1699 15.6159C15.1643 15.643 15.1601 15.6704 15.1574 15.6979C15.1546 15.7254 15.1535 15.7529 15.1535 15.7804C15.1535 15.8079 15.1546 15.836 15.1574 15.8635C15.1602 15.8908 15.1643 15.918 15.1699 15.9449C15.1755 15.9718 15.1823 15.9988 15.1901 16.0252C15.1982 16.0514 15.2077 16.0773 15.2184 16.1026C15.2287 16.1281 15.2404 16.153 15.2534 16.1773C15.2664 16.2014 15.2811 16.225 15.2963 16.248C15.3115 16.2709 15.3279 16.293 15.3454 16.3142C15.363 16.3358 15.3816 16.3564 15.4013 16.376C15.4211 16.3951 15.4414 16.4142 15.4634 16.4316C15.4847 16.4491 15.5069 16.4654 15.53 16.4804C15.5532 16.4956 15.5768 16.5102 15.6012 16.5231C15.6502 16.5485 15.7014 16.5695 15.7542 16.5859C15.7806 16.5938 15.8077 16.6005 15.8348 16.6061C15.8892 16.6172 15.9447 16.6227 16.0002 16.6224C16.2245 16.6218 16.4396 16.5333 16.5986 16.376C16.6376 16.3366 16.673 16.2938 16.7042 16.248C16.7194 16.225 16.7335 16.2014 16.7465 16.1773C16.7595 16.1531 16.7714 16.1279 16.7821 16.1026C16.7928 16.0774 16.8018 16.051 16.8097 16.0252C16.8181 15.9988 16.8249 15.972 16.8301 15.9449C16.8356 15.918 16.8397 15.8908 16.8424 15.8635C16.8453 15.8359 16.8468 15.8081 16.8468 15.7803L16.8469 15.7804ZM19.6695 15.7804C19.6695 15.5571 19.5803 15.3429 19.4215 15.185C19.2627 15.0271 19.0473 14.9384 18.8228 14.9384H18.8211C18.6537 14.9387 18.4902 14.9884 18.3511 15.0811C18.2121 15.1738 18.1038 15.3054 18.04 15.4593C17.9761 15.6132 17.9596 15.7825 17.9925 15.9457C18.0253 16.1089 18.1061 16.2588 18.2246 16.3764C18.3431 16.494 18.4939 16.574 18.6582 16.6064C18.8224 16.6387 18.9926 16.6219 19.1472 16.5582C19.3018 16.4944 19.434 16.3865 19.5269 16.248C19.6199 16.1096 19.6695 15.9469 19.6695 15.7804Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const IconEmergency = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        d="M29.3346 8C29.3346 10.2091 27.5438 12 25.3346 12C23.1255 12 21.3346 10.2091 21.3346 8C21.3346 5.79086 23.1255 4 25.3346 4C27.5438 4 29.3346 5.79086 29.3346 8Z"
        fill="#1C274C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.668 6.66667H13.3346C8.30632 6.66667 5.79216 6.66667 4.23007 8.22876C2.66797 9.79086 2.66797 12.305 2.66797 17.3333C2.66797 22.3616 2.66797 24.8758 4.23007 26.4379C5.79216 28 8.30632 28 13.3346 28H18.668C23.6963 28 26.2104 28 27.7725 26.4379C29.3346 24.8758 29.3346 22.3616 29.3346 17.3333C29.3346 15.3955 29.3346 13.8311 29.2452 12.5507C28.195 13.454 26.8286 14 25.3346 14C24.6964 14 24.0814 13.9003 23.5045 13.7157L21.7128 15.2088C20.531 16.1936 19.5732 16.9919 18.7277 17.5356C17.8471 18.102 16.9894 18.4598 16.0013 18.4598C15.0132 18.4598 14.1555 18.102 13.2749 17.5356C12.4295 16.9919 11.4716 16.1936 10.2898 15.2088L7.36112 12.7682C6.93684 12.4147 6.87952 11.7841 7.23308 11.3598C7.58664 10.9355 8.21721 10.8782 8.64149 11.2318L11.52 13.6306C12.764 14.6672 13.6276 15.3846 14.3567 15.8535C15.0626 16.3075 15.5412 16.4598 16.0013 16.4598C16.4614 16.4598 16.94 16.3075 17.6459 15.8535C18.375 15.3846 19.2386 14.6672 20.4826 13.6305L21.6019 12.6978C20.2203 11.5986 19.3346 9.90272 19.3346 8C19.3346 7.54184 19.386 7.09567 19.4833 6.66693C19.2191 6.66667 18.9474 6.66667 18.668 6.66667Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const IconClose = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clipPath="url(#clip0_14517_6157)">
        <path
          d="M16 0C7.16667 0 0 7.16667 0 16C0 24.8333 7.16667 32 16 32C24.8333 32 32 24.8333 32 16C32 7.16667 24.8333 0 16 0ZM15.5 25.3333C15.1704 25.3333 14.8481 25.2356 14.574 25.0525C14.3 24.8693 14.0863 24.609 13.9602 24.3045C13.8341 23.9999 13.801 23.6648 13.8654 23.3415C13.9297 23.0182 14.0884 22.7212 14.3215 22.4882C14.5546 22.2551 14.8515 22.0963 15.1748 22.032C15.4982 21.9677 15.8333 22.0007 16.1378 22.1269C16.4423 22.253 16.7026 22.4666 16.8858 22.7407C17.0689 23.0148 17.1667 23.337 17.1667 23.6667C17.1667 24.1087 16.9911 24.5326 16.6785 24.8452C16.366 25.1577 15.942 25.3333 15.5 25.3333ZM18.2867 16.8333C16.9358 17.74 16.75 18.5708 16.75 19.3333C16.75 19.6428 16.6271 19.9395 16.4083 20.1583C16.1895 20.3771 15.8928 20.5 15.5833 20.5C15.2739 20.5 14.9772 20.3771 14.7584 20.1583C14.5396 19.9395 14.4167 19.6428 14.4167 19.3333C14.4167 17.5075 15.2567 16.0558 16.985 14.895C18.5917 13.8167 19.5 13.1333 19.5 11.6308C19.5 10.6092 18.9167 9.83333 17.7092 9.25917C17.425 9.12417 16.7925 8.9925 16.0142 9.00167C15.0375 9.01417 14.2792 9.2475 13.695 9.7175C12.5933 10.6042 12.5 11.5692 12.5 11.5833C12.4926 11.7365 12.4551 11.8868 12.3897 12.0255C12.3242 12.1642 12.2321 12.2887 12.1185 12.3918C12.005 12.4949 11.8722 12.5747 11.7278 12.6265C11.5835 12.6783 11.4303 12.7011 11.2771 12.6938C11.1239 12.6864 10.9736 12.6489 10.8349 12.5834C10.6962 12.518 10.5717 12.4258 10.4686 12.3123C10.3655 12.1987 10.2858 12.066 10.2339 11.9216C10.1821 11.7772 10.1593 11.624 10.1667 11.4708C10.1758 11.2683 10.3167 9.44417 12.2308 7.90417C13.2233 7.10583 14.4858 6.69083 15.9808 6.6725C17.0392 6.66 18.0333 6.83917 18.7075 7.1575C20.725 8.11167 21.8333 9.7025 21.8333 11.6308C21.8333 14.45 19.9492 15.7158 18.2867 16.8333Z"
          fill="#33475B"
        />
      </g>
      <defs>
        <clipPath id="clip0_14517_6157">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconFAQ = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="28"
      viewBox="0 0 30 28"
      fill="none"
      className={className}
    >
      <path
        d="M11.4168 0.705914C4.90178 1.38767 0.110529 6.01943 0.339932 11.4243C0.418585 13.2025 1.01503 14.8612 2.12928 16.4286C2.62741 17.1174 3.7351 18.2419 4.40365 18.7339C4.79036 19.015 4.94766 19.1697 4.93456 19.247C4.70515 20.2521 3.92518 24.2723 3.92518 24.441C3.92518 25.1649 4.60028 25.7342 5.22295 25.5304C5.36059 25.4812 6.52727 24.5956 7.96268 23.45L10.4665 21.4539L12.6163 21.4188C14.9628 21.3766 15.474 21.3204 17.0077 20.8776C20.1932 19.9709 22.8673 17.9397 24.3093 15.3321C25.4498 13.2728 25.7251 10.7144 25.0369 8.5075C23.7915 4.53642 20.0096 1.5915 15.1332 0.81134C14.3008 0.677799 12.2427 0.621572 11.4168 0.705914ZM13.7109 4.74728C14.812 5.05653 15.6969 5.94211 16.0573 7.10181C16.2474 7.72031 16.2474 8.64104 16.0573 9.28766C15.8869 9.87102 15.4806 10.5317 15.0807 10.8831C14.2156 11.6422 14.0189 11.9796 13.9206 12.8722C13.8485 13.5891 13.4749 13.9897 12.8719 13.9897C12.4852 13.9897 12.1771 13.814 11.9871 13.4836C11.8888 13.3079 11.856 13.1252 11.856 12.7316C11.856 11.4524 12.4787 10.1873 13.5011 9.37903C14.2287 8.80972 14.3204 7.84682 13.7109 7.22832C13.2127 6.72227 12.3607 6.79256 11.9019 7.37592C11.8035 7.50946 11.7052 7.75546 11.6594 7.99442C11.62 8.21933 11.5741 8.47236 11.5545 8.5567C11.5414 8.64807 11.4365 8.82378 11.3251 8.96435C10.958 9.41417 10.3354 9.44931 9.90933 9.04869C9.62094 8.77458 9.54884 8.57778 9.5554 8.07174C9.5685 6.56765 10.6172 5.15493 12.0067 4.74728C12.459 4.62076 13.2455 4.61374 13.7109 4.74728ZM13.3635 15.3602C13.6322 15.5078 13.8747 15.8804 13.9272 16.2177C14.0124 16.8081 13.5667 17.4055 12.9833 17.4828C12.6884 17.518 12.223 17.286 12.033 16.9979C11.8298 16.7027 11.8101 16.1685 11.9871 15.8312C12.2558 15.3251 12.8981 15.1002 13.3635 15.3602Z"
        fill="currentColor"
      />
      <path
        d="M27.4978 11.7062C27.1766 16.6893 23.611 20.9626 18.2168 22.8322C17.7645 22.9868 17.0567 23.1907 16.6437 23.282C16.2308 23.3804 15.9227 23.4718 15.9555 23.4929C16.1194 23.5913 16.9387 23.8373 17.5286 23.9638C18.4396 24.1606 19.4424 24.252 20.6812 24.252H21.7299L23.611 25.756C24.9481 26.8314 25.5577 27.2812 25.7281 27.3164C26.2393 27.4218 26.7965 27.0423 26.9341 26.494C26.9997 26.241 26.9603 25.988 26.6392 24.3714C26.436 23.3593 26.259 22.4948 26.2459 22.4456C26.2328 22.4035 26.436 22.1926 26.6916 21.9818C29.7132 19.5429 30.5325 15.6913 28.6972 12.5496C28.5006 12.2192 28.1663 11.7343 27.9435 11.4742L27.5437 11.0103L27.4978 11.7062Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const LoadingIcon = ({
  loading,
  loadingPercentage,
  stroke,
}: {
  loading?: boolean
  loadingPercentage?: number
  stroke?: '#ffffff' | '#404041'
}) => {
  return (
    <svg
      className="loader-video absolute left-1/2 top-1/2 block -translate-x-1/2 -translate-y-1/2"
      xmlns="http://www.w3.org/2000/svg"
      width="85px"
      height="85px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke={stroke}
        strokeWidth="5"
        r="47"
        strokeDasharray="164.93361431346415 56.97787143782138"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="0.5s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        ></animateTransform>
      </circle>
      {loading && (
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          fill="#ffffff"
          fontSize="14"
          dy=".3em"
        >
          {loadingPercentage}%
        </text>
      )}
    </svg>
  )
}

export const IconAnnotationGuide = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99984 0.666992C4.39914 0.666992 0.666504 4.39963 0.666504 9.00033C0.666504 13.601 4.39914 17.3337 8.99984 17.3337C13.6005 17.3337 17.3332 13.601 17.3332 9.00033C17.3332 4.39963 13.6005 0.666992 8.99984 0.666992ZM9.45296 13.7746H8.14176C8.11226 13.7745 8.084 13.7627 8.06317 13.7418C8.04235 13.7209 8.03065 13.6926 8.03065 13.6631V12.3523C8.03065 12.3228 8.04235 12.2945 8.06317 12.2736C8.084 12.2527 8.11226 12.2409 8.14176 12.2408H9.45296C9.48247 12.2409 9.51073 12.2527 9.53156 12.2736C9.55238 12.2945 9.56407 12.3228 9.56407 12.3523V13.6631C9.56407 13.6926 9.55238 13.7209 9.53156 13.7418C9.51073 13.7627 9.48247 13.7745 9.45296 13.7746ZM10.1908 9.47776C9.48725 9.94998 9.39046 10.3827 9.39046 10.7798V11.2573C9.39046 11.2918 9.37674 11.3249 9.35232 11.3493C9.32791 11.3738 9.29479 11.3875 9.26025 11.3875H8.30539C8.27086 11.3875 8.23774 11.3738 8.21332 11.3493C8.1889 11.3249 8.17518 11.2918 8.17518 11.2573V10.7798C8.17518 9.82889 8.61269 9.07281 9.51286 8.46821C10.3497 7.90658 10.8228 7.55067 10.8228 6.76812C10.8228 6.236 10.5189 5.83192 9.89003 5.53288C9.74203 5.46257 9.4126 5.39399 9.00722 5.39876C8.49854 5.40527 8.10357 5.5268 7.79932 5.77159C7.22553 6.2334 7.17692 6.73644 7.17692 6.74338C7.15309 6.89092 7.1409 7.04011 7.14046 7.18956C7.14046 7.2241 7.12674 7.25721 7.10233 7.28163C7.07791 7.30605 7.04479 7.31977 7.01025 7.31977H6.08795C6.05562 7.31994 6.02439 7.30809 6.00032 7.28651C5.97626 7.26493 5.96108 7.23517 5.95774 7.20302C5.94211 7.02969 5.94342 6.85526 5.96164 6.68218C5.97119 6.57671 6.03977 5.62663 7.03673 4.82454C7.55366 4.40875 8.21121 4.1926 8.98985 4.18305C9.54107 4.17654 10.0589 4.26986 10.41 4.43566C11.4608 4.93522 12.038 5.76378 12.038 6.76812C12.038 8.23644 11.0567 8.89573 10.1908 9.47776Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const IconSend = ({ width, height, className }: ISVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1185 3.02577C14.1435 3.19921 12.829 3.6356 10.9843 4.25051L6.80821 5.64253C5.32485 6.13698 4.25045 6.49565 3.49158 6.81841C2.69819 7.15586 2.41596 7.39107 2.32429 7.54875C2.04196 8.0344 2.04196 8.63421 2.32429 9.11986C2.41596 9.27754 2.69819 9.51275 3.49158 9.8502C4.25045 10.173 5.32485 10.5316 6.80821 11.0261C6.83163 11.0339 6.85476 11.0416 6.8776 11.0492C7.28275 11.1839 7.59771 11.2887 7.86866 11.4701C8.12969 11.6449 8.35393 11.8691 8.52868 12.1301C8.71007 12.4011 8.81484 12.716 8.9496 13.1212C8.9572 13.144 8.96489 13.1672 8.9727 13.1906C9.46715 14.6739 9.82582 15.7483 10.1486 16.5072C10.486 17.3006 10.7212 17.5828 10.8789 17.6745C11.3646 17.9568 11.9644 17.9568 12.45 17.6745C12.6077 17.5828 12.8429 17.3006 13.1804 16.5072C13.5031 15.7483 13.8618 14.6739 14.3562 13.1906L15.7483 9.01451C16.3632 7.16978 16.7996 5.85531 16.973 4.88033C17.1473 3.9007 17.0141 3.48458 16.7641 3.23463C16.5142 2.98468 16.0981 2.85151 15.1185 3.02577ZM14.8942 1.76506C15.9793 1.57201 16.9567 1.61626 17.6696 2.32917C18.3825 3.04209 18.4268 4.01943 18.2337 5.1046C18.0418 6.18321 17.5739 7.58687 16.9816 9.36399L15.5608 13.6263C15.0787 15.0725 14.7042 16.1962 14.3587 17.0084C14.0255 17.7918 13.6556 18.4548 13.0936 18.7815C12.2101 19.2952 11.1189 19.2952 10.2353 18.7815C9.67339 18.4548 9.30342 17.7918 8.97022 17.0084C8.6248 16.1962 8.25023 15.0725 7.76818 13.6263L7.7579 13.5955C7.58902 13.0889 7.53754 12.9514 7.4646 12.8425C7.38298 12.7205 7.27824 12.6158 7.15631 12.5342C7.04736 12.4612 6.90993 12.4098 6.40328 12.2409L6.37241 12.2306C4.92625 11.7485 3.80256 11.374 2.9904 11.0286C2.207 10.6954 1.54395 10.3254 1.21726 9.76344C0.703621 8.87991 0.703621 7.7887 1.21726 6.90517C1.54396 6.34322 2.207 5.97325 2.9904 5.64006C3.80257 5.29463 4.92628 4.92006 6.37246 4.438L10.6348 3.01722C12.4119 2.42483 13.8156 1.95693 14.8942 1.76506ZM14.7326 5.27118C14.9813 5.5226 14.979 5.92798 14.7276 6.17662L11.3129 9.55368C11.0615 9.80232 10.6561 9.80008 10.4075 9.54866C10.1588 9.29724 10.1611 8.89186 10.4125 8.64322L13.8272 5.26616C14.0786 5.01752 14.484 5.01976 14.7326 5.27118Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const CameraIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.33332 3.73888C6.55568 2.64732 7.52704 1.875 8.63992 1.875H11.3627C12.4756 1.875 13.4469 2.64732 13.6693 3.73888C13.7206 3.99087 13.9489 4.17571 14.1863 4.17571H14.2L14.2136 4.17631C15.3831 4.22745 16.2814 4.37097 17.0314 4.86298C17.504 5.17297 17.9104 5.57181 18.2271 6.0372C18.6212 6.61622 18.795 7.28079 18.8783 8.08454C18.9596 8.86983 18.9596 9.85417 18.9596 11.1009V11.1719C18.9596 12.4186 18.9596 13.4029 18.8783 14.1882C18.795 14.9919 18.6212 15.6565 18.2271 16.2355C17.9104 16.7009 17.504 17.0998 17.0314 17.4097C16.4452 17.7943 15.7731 17.9639 14.958 18.0453C14.1599 18.125 13.1588 18.125 11.8875 18.125H8.11511C6.84379 18.125 5.84269 18.125 5.0446 18.0453C4.22946 17.9639 3.5574 17.7943 2.97118 17.4097C2.49865 17.0998 2.09218 16.7009 1.77546 16.2355C1.3814 15.6565 1.2076 14.9919 1.12432 14.1882C1.04296 13.4029 1.04296 12.4186 1.04297 11.1718V11.1009C1.04296 9.85417 1.04296 8.86983 1.12432 8.08454C1.2076 7.28079 1.3814 6.61622 1.77546 6.0372C2.09218 5.57181 2.49865 5.17297 2.97118 4.86298C3.72116 4.37097 4.61947 4.22745 5.789 4.17631L5.80264 4.17571H5.8163C6.0537 4.17571 6.28199 3.99087 6.33332 3.73888ZM8.63992 3.125C8.10565 3.125 7.65885 3.49416 7.55817 3.98839C7.39512 4.78883 6.68547 5.41822 5.83158 5.42565C4.70774 5.47558 4.10577 5.61363 3.65684 5.90815C3.32055 6.12876 3.03256 6.41175 2.80885 6.74047C2.57872 7.07862 2.44043 7.51104 2.36766 8.21337C2.29375 8.92672 2.29297 9.84633 2.29297 11.1364C2.29297 12.4264 2.29375 13.346 2.36766 14.0594C2.44043 14.7617 2.57872 15.1941 2.80885 15.5323C3.03256 15.861 3.32055 16.144 3.65684 16.3646C4.00477 16.5928 4.45 16.7297 5.16883 16.8015C5.89754 16.8743 6.83625 16.875 8.14945 16.875H11.8532C13.1664 16.875 14.1051 16.8743 14.8338 16.8015C15.5526 16.7297 15.9978 16.5928 16.3458 16.3646C16.6821 16.144 16.97 15.861 17.1938 15.5323C17.4239 15.1941 17.5622 14.7617 17.6349 14.0594C17.7089 13.346 17.7096 12.4264 17.7096 11.1364C17.7096 9.84633 17.7089 8.92672 17.6349 8.21337C17.5622 7.51104 17.4239 7.07862 17.1938 6.74047C16.97 6.41175 16.6821 6.12876 16.3458 5.90815C15.8968 5.61363 15.2949 5.47558 14.171 5.42565C13.3171 5.41822 12.6075 4.78883 12.4444 3.98839C12.3438 3.49416 11.897 3.125 11.3627 3.125H8.63992ZM10.0013 8.95833C8.96577 8.95833 8.1263 9.7978 8.1263 10.8333C8.1263 11.8689 8.96577 12.7083 10.0013 12.7083C11.0368 12.7083 11.8763 11.8689 11.8763 10.8333C11.8763 9.7978 11.0368 8.95833 10.0013 8.95833ZM6.8763 10.8333C6.8763 9.10744 8.27541 7.70833 10.0013 7.70833C11.7272 7.70833 13.1263 9.10744 13.1263 10.8333C13.1263 12.5592 11.7272 13.9583 10.0013 13.9583C8.27541 13.9583 6.8763 12.5592 6.8763 10.8333ZM14.3763 8.33333C14.3763 7.98816 14.6561 7.70833 15.0013 7.70833H15.8346C16.1798 7.70833 16.4596 7.98816 16.4596 8.33333C16.4596 8.67851 16.1798 8.95833 15.8346 8.95833H15.0013C14.6561 8.95833 14.3763 8.67851 14.3763 8.33333Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const IconDownArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
    >
      <path
        d="M0.667317 1.66657L5.00065 5.3999L9.33398 1.66657"
        stroke="#404041"
        strokeLinecap="square"
      />
    </svg>
  )
}

export const IconCalendar = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.54 3.43011V1.94011C17.5196 1.77015 17.4376 1.61356 17.3095 1.49996C17.1814 1.38636 17.0162 1.32363 16.845 1.32363C16.6738 1.32363 16.5086 1.38636 16.3805 1.49996C16.2524 1.61356 16.1704 1.77015 16.15 1.94011V3.21011H15.83H12.89V1.94011C12.89 1.75446 12.8162 1.57641 12.685 1.44514C12.5537 1.31386 12.3757 1.24011 12.19 1.24011C12.0043 1.24011 11.8263 1.31386 11.695 1.44514C11.5638 1.57641 11.49 1.75446 11.49 1.94011V3.19011H8.17H7.85V1.94011C7.82958 1.77015 7.74758 1.61356 7.61951 1.49996C7.49144 1.38636 7.32619 1.32363 7.155 1.32363C6.98381 1.32363 6.81856 1.38636 6.69049 1.49996C6.56242 1.61356 6.48042 1.77015 6.46 1.94011V3.43011C5.17564 3.80058 4.04634 4.57813 3.242 5.64577C2.43766 6.71341 2.0018 8.0134 2 9.35011V16.5901C2.0053 18.2274 2.66011 19.7957 3.82068 20.9506C4.98124 22.1056 6.55269 22.7528 8.19 22.7501H15.85C17.4804 22.7422 19.0416 22.0904 20.1935 20.9366C21.3454 19.7828 21.9947 18.2205 22 16.5901V9.35011C21.9982 8.0134 21.5623 6.71341 20.758 5.64577C19.9537 4.57813 18.8244 3.80058 17.54 3.43011ZM6.46 4.90011V5.71011C6.48042 5.88008 6.56242 6.03667 6.69049 6.15027C6.81856 6.26386 6.98381 6.3266 7.155 6.3266C7.32619 6.3266 7.49144 6.26386 7.61951 6.15027C7.74758 6.03667 7.82958 5.88008 7.85 5.71011V4.61011C7.96 4.61011 8.06 4.61011 8.17 4.61011H11.49V5.71011C11.49 5.89576 11.5638 6.07381 11.695 6.20509C11.8263 6.33636 12.0043 6.41011 12.19 6.41011C12.3757 6.41011 12.5537 6.33636 12.685 6.20509C12.8162 6.07381 12.89 5.89576 12.89 5.71011V4.58011H15.83C15.94 4.58011 16.04 4.58011 16.15 4.58011V5.68011C16.1704 5.85008 16.2524 6.00667 16.3805 6.12027C16.5086 6.23386 16.6738 6.2966 16.845 6.2966C17.0162 6.2966 17.1814 6.23386 17.3095 6.12027C17.4376 6.00667 17.5196 5.85008 17.54 5.68011V4.90011C18.3259 5.2058 19.0171 5.71353 19.5439 6.37199C20.0707 7.03045 20.4143 7.8163 20.54 8.65011H3.44C3.56754 7.81409 3.91414 7.02674 4.44458 6.36808C4.97502 5.70942 5.67039 5.20294 6.46 4.90011ZM15.83 21.3601H8.17C6.90134 21.3628 5.68344 20.862 4.78355 19.9678C3.88366 19.0735 3.37529 17.8588 3.37 16.5901V10.0001H20.63V16.5501C20.6326 17.1817 20.5104 17.8075 20.2702 18.3916C20.03 18.9757 19.6767 19.5066 19.2306 19.9536C18.7845 20.4007 18.2544 20.7551 17.6708 20.9965C17.0871 21.2379 16.4616 21.3614 15.83 21.3601ZM9.59 13.8401C9.59598 14.0133 9.55008 14.1844 9.45819 14.3314C9.36629 14.4783 9.2326 14.5945 9.07425 14.665C8.91589 14.7354 8.7401 14.757 8.56941 14.7269C8.39872 14.6968 8.24091 14.6164 8.11622 14.496C7.99153 14.3756 7.90564 14.2207 7.86957 14.0512C7.8335 13.8816 7.84888 13.7052 7.91376 13.5445C7.97863 13.3838 8.09003 13.2461 8.23368 13.1491C8.37733 13.0521 8.54667 13.0002 8.72 13.0001C8.94563 13 9.16249 13.0875 9.32481 13.2442C9.48714 13.401 9.58222 13.6146 9.59 13.8401ZM12.85 13.8401C12.8579 14.0169 12.8124 14.192 12.7193 14.3425C12.6262 14.493 12.4899 14.612 12.3282 14.6838C12.1665 14.7557 11.9868 14.7771 11.8128 14.7453C11.6387 14.7135 11.4782 14.63 11.3523 14.5056C11.2264 14.3812 11.141 14.2217 11.1071 14.048C11.0733 13.8743 11.0926 13.6944 11.1625 13.5319C11.2325 13.3693 11.3498 13.2316 11.4992 13.1367C11.6486 13.0419 11.8231 12.9943 12 13.0001C12.2222 13.0051 12.434 13.0949 12.592 13.2511C12.7501 13.4073 12.8424 13.618 12.85 13.8401ZM16.13 13.8401C16.134 14.0154 16.0855 14.1878 15.9908 14.3354C15.8961 14.4829 15.7595 14.5988 15.5985 14.6682C15.4375 14.7376 15.2595 14.7573 15.0872 14.7248C14.9149 14.6923 14.7563 14.6091 14.6316 14.4859C14.5069 14.3627 14.4219 14.205 14.3874 14.0331C14.3529 13.8612 14.3706 13.6829 14.4381 13.5211C14.5056 13.3593 14.6199 13.2214 14.7664 13.125C14.9128 13.0286 15.0847 12.9782 15.26 12.9801C15.489 12.9801 15.7088 13.0704 15.8717 13.2314C16.0345 13.3924 16.1274 13.6111 16.13 13.8401ZM9.58 17.0701C9.57869 17.1831 9.55515 17.2946 9.51073 17.3985C9.4663 17.5023 9.40185 17.5964 9.32106 17.6753C9.24027 17.7542 9.14472 17.8165 9.03988 17.8585C8.93503 17.9005 8.82294 17.9214 8.71 17.9201C8.53992 17.9181 8.37426 17.8657 8.23395 17.7696C8.09364 17.6735 7.98499 17.5379 7.92174 17.38C7.85848 17.2221 7.84347 17.049 7.87859 16.8826C7.91372 16.7162 7.9974 16.5639 8.11906 16.445C8.24072 16.3262 8.39489 16.246 8.56208 16.2148C8.72928 16.1836 8.90198 16.2026 9.05835 16.2695C9.21473 16.3364 9.34775 16.4482 9.4406 16.5907C9.53346 16.7332 9.58197 16.9 9.58 17.0701ZM12.84 17.0701C12.844 17.245 12.7958 17.417 12.7015 17.5643C12.6073 17.7117 12.4713 17.8276 12.3109 17.8972C12.1504 17.9669 11.9729 17.9872 11.8009 17.9556C11.6289 17.9239 11.4702 17.8417 11.3452 17.7195C11.2201 17.5972 11.1343 17.4405 11.0987 17.2693C11.0631 17.0981 11.0793 16.9201 11.1452 16.7581C11.2112 16.5962 11.324 16.4575 11.4691 16.3599C11.6142 16.2623 11.7851 16.2102 11.96 16.2101C12.0746 16.2074 12.1886 16.2277 12.2953 16.2697C12.4019 16.3118 12.4991 16.3747 12.5811 16.4548C12.6631 16.5349 12.7282 16.6307 12.7727 16.7363C12.8171 16.842 12.84 16.9555 12.84 17.0701ZM16.12 17.0701C16.124 17.245 16.0758 17.417 15.9815 17.5643C15.8873 17.7117 15.7513 17.8276 15.5909 17.8972C15.4304 17.9669 15.2529 17.9872 15.0809 17.9556C14.9089 17.9239 14.7502 17.8417 14.6252 17.7195C14.5001 17.5972 14.4143 17.4405 14.3787 17.2693C14.3431 17.0981 14.3593 16.9201 14.4252 16.7581C14.4912 16.5962 14.604 16.4575 14.7491 16.3599C14.8942 16.2623 15.0651 16.2102 15.24 16.2101C15.3546 16.2074 15.4686 16.2277 15.5753 16.2697C15.6819 16.3118 15.7791 16.3747 15.8611 16.4548C15.9431 16.5349 16.0082 16.6307 16.0527 16.7363C16.0971 16.842 16.12 16.9555 16.12 17.0701Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export const IconMinusSquared = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.92 2.65012C16.6331 2.65012 17.3392 2.79057 17.998 3.06346C18.6568 3.33634 19.2554 3.73631 19.7596 4.24053C20.2638 4.74475 20.6638 5.34335 20.9367 6.00215C21.2095 6.66095 21.35 7.36704 21.35 8.08012V15.9201C21.35 16.6332 21.2095 17.3393 20.9367 17.9981C20.6638 18.6569 20.2638 19.2555 19.7596 19.7597C19.2554 20.2639 18.6568 20.6639 17.998 20.9368C17.3392 21.2097 16.6331 21.3501 15.92 21.3501H8.08C6.63987 21.3501 5.25873 20.778 4.24041 19.7597C3.22209 18.7414 2.65 17.3602 2.65 15.9201V8.08012C2.65 6.64 3.22209 5.25885 4.24041 4.24053C5.25873 3.22221 6.63987 2.65012 8.08 2.65012H15.92ZM7.33 12.9301H16.67C16.9167 12.9301 17.1532 12.8321 17.3276 12.6577C17.502 12.4833 17.6 12.2468 17.6 12.0001C17.6 11.7535 17.502 11.5169 17.3276 11.3425C17.1532 11.1681 16.9167 11.0701 16.67 11.0701H7.33C7.08335 11.0701 6.8468 11.1681 6.67239 11.3425C6.49798 11.5169 6.4 11.7535 6.4 12.0001C6.4 12.2468 6.49798 12.4833 6.67239 12.6577C6.8468 12.8321 7.08335 12.9301 7.33 12.9301ZM15.92 1.25012H8.08C6.26857 1.25012 4.53133 1.96971 3.25046 3.25058C1.96959 4.53146 1.25 6.26869 1.25 8.08012V15.9201C1.25 17.7316 1.96959 19.4688 3.25046 20.7497C4.53133 22.0305 6.26857 22.7501 8.08 22.7501H15.92C17.7314 22.7501 19.4687 22.0305 20.7495 20.7497C22.0304 19.4688 22.75 17.7316 22.75 15.9201V8.08012C22.75 6.26869 22.0304 4.53146 20.7495 3.25058C19.4687 1.96971 17.7314 1.25012 15.92 1.25012Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export const IconPlusSquared = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.92 2.65012C16.6331 2.65012 17.3392 2.79057 17.998 3.06346C18.6568 3.33634 19.2554 3.73631 19.7596 4.24053C20.2638 4.74475 20.6638 5.34335 20.9367 6.00215C21.2095 6.66095 21.35 7.36704 21.35 8.08012V15.9201C21.35 16.6332 21.2095 17.3393 20.9367 17.9981C20.6638 18.6569 20.2638 19.2555 19.7596 19.7597C19.2554 20.2639 18.6568 20.6639 17.998 20.9368C17.3392 21.2097 16.6331 21.3501 15.92 21.3501H8.08C6.63987 21.3501 5.25873 20.778 4.24041 19.7597C3.22209 18.7414 2.65 17.3602 2.65 15.9201V8.08012C2.65 6.64 3.22209 5.25885 4.24041 4.24053C5.25873 3.22221 6.63987 2.65012 8.08 2.65012H15.92ZM7.33 12.9301H11.07V16.6701C11.07 16.9168 11.168 17.1533 11.3424 17.3277C11.5168 17.5021 11.7533 17.6001 12 17.6001C12.2467 17.6001 12.4832 17.5021 12.6576 17.3277C12.832 17.1533 12.93 16.9168 12.93 16.6701V12.9301H16.67C16.9167 12.9301 17.1532 12.8321 17.3276 12.6577C17.502 12.4833 17.6 12.2468 17.6 12.0001C17.6 11.7535 17.502 11.5169 17.3276 11.3425C17.1532 11.1681 16.9167 11.0701 16.67 11.0701H12.93V7.33012C12.93 7.08347 12.832 6.84692 12.6576 6.67251C12.4832 6.4981 12.2467 6.40012 12 6.40012C11.7533 6.40012 11.5168 6.4981 11.3424 6.67251C11.168 6.84692 11.07 7.08347 11.07 7.33012V11.0701H7.33C7.08335 11.0701 6.8468 11.1681 6.67239 11.3425C6.49798 11.5169 6.4 11.7535 6.4 12.0001C6.4 12.2468 6.49798 12.4833 6.67239 12.6577C6.8468 12.8321 7.08335 12.9301 7.33 12.9301ZM15.92 1.25012H8.08C6.26857 1.25012 4.53133 1.96971 3.25046 3.25058C1.96959 4.53146 1.25 6.26869 1.25 8.08012V15.9201C1.25 17.7316 1.96959 19.4688 3.25046 20.7497C4.53133 22.0305 6.26857 22.7501 8.08 22.7501H15.92C17.7314 22.7501 19.4687 22.0305 20.7495 20.7497C22.0304 19.4688 22.75 17.7316 22.75 15.9201V8.08012C22.75 6.26869 22.0304 4.53146 20.7495 3.25058C19.4687 1.96971 17.7314 1.25012 15.92 1.25012Z"
        fill="#FFB800"
      />
    </svg>
  )
}

export const CursorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22.6302 20.7021L20.2615 23.0709C19.9633 23.369 19.48 23.369 19.1818 23.0709L15.1873 19.0763L13.1105 21.1339C12.5199 21.7245 11.5102 21.515 11.2244 20.7338L6.80433 8.73106C6.46141 7.81661 7.35691 6.94017 8.27137 7.26402L20.0646 11.5317C20.8456 11.8175 21.0744 12.8273 20.4838 13.4179L18.4452 15.4374L22.6302 19.6224C22.9284 19.9206 22.9284 20.4039 22.6302 20.7021Z"
        fill="white"
      />
      <path
        d="M6.59248 6.13528C6.39771 6.13528 6.20555 6.04526 6.08236 5.87566L4.15742 3.22626C3.95296 2.94483 4.0154 2.55101 4.29683 2.34655C4.5779 2.14172 4.97228 2.20453 5.17655 2.48596L7.10148 5.13535C7.30594 5.41679 7.24351 5.81061 6.96207 6.01507C6.85043 6.09633 6.72071 6.13528 6.59248 6.13528Z"
        fill="white"
      />
      <path
        d="M4.89033 8.47796C4.82584 8.47796 4.76024 8.46808 4.69556 8.44702L1.58096 7.43497C1.25014 7.32743 1.06898 6.97219 1.17652 6.64137C1.28406 6.31054 1.63967 6.12975 1.97012 6.23692L5.08472 7.24897C5.41555 7.35651 5.59671 7.71175 5.48917 8.04257C5.40269 8.30872 5.15573 8.47796 4.89033 8.47796Z"
        fill="white"
      />
      <path
        d="M1.77536 12.386C1.50995 12.386 1.263 12.2167 1.17652 11.9506C1.06898 11.6197 1.25014 11.2645 1.58096 11.157L4.69556 10.1449C5.02601 10.037 5.38163 10.2185 5.48917 10.5494C5.59671 10.8802 5.41555 11.2354 5.08472 11.343L1.97012 12.355C1.90545 12.3761 1.83984 12.386 1.77536 12.386Z"
        fill="white"
      />
      <path
        d="M9.34658 5.2405C8.99879 5.2405 8.7168 4.95851 8.7168 4.61072V1.33583C8.7168 0.988048 8.99879 0.706055 9.34658 0.706055C9.69436 0.706055 9.97635 0.988048 9.97635 1.33583V4.61072C9.97635 4.95851 9.69436 5.2405 9.34658 5.2405Z"
        fill="white"
      />
    </svg>
  )
}

export const Plus = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12.6668C7.82319 12.6668 7.65362 12.5966 7.5286 12.4716C7.40357 12.3465 7.33333 12.177 7.33333 12.0002V4.00016C7.33333 3.82335 7.40357 3.65378 7.5286 3.52876C7.65362 3.40373 7.82319 3.3335 8 3.3335C8.17681 3.3335 8.34638 3.40373 8.47141 3.52876C8.59643 3.65378 8.66667 3.82335 8.66667 4.00016V12.0002C8.66667 12.177 8.59643 12.3465 8.47141 12.4716C8.34638 12.5966 8.17681 12.6668 8 12.6668Z"
      fill="white"
    />
    <path
      d="M4 8.66683C3.82319 8.66683 3.65362 8.59659 3.5286 8.47157C3.40357 8.34654 3.33333 8.17697 3.33333 8.00016C3.33333 7.82335 3.40357 7.65378 3.5286 7.52876C3.65362 7.40373 3.82319 7.3335 4 7.3335H12C12.1768 7.3335 12.3464 7.40373 12.4714 7.52876C12.5964 7.65378 12.6667 7.82335 12.6667 8.00016C12.6667 8.17697 12.5964 8.34654 12.4714 8.47157C12.3464 8.59659 12.1768 8.66683 12 8.66683H4Z"
      fill="white"
    />
  </svg>
)
export const PepIconsPencil = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3 18.2998C11.3 17.902 11.458 17.5204 11.7393 17.2391C12.0206 16.9578 12.4022 16.7998 12.8 16.7998C13.1978 16.7998 13.5794 16.9578 13.8607 17.2391C14.142 17.5204 14.3 17.902 14.3 18.2998C14.3 18.6976 14.142 19.0792 13.8607 19.3605C13.5794 19.6418 13.1978 19.7998 12.8 19.7998C12.4022 19.7998 12.0206 19.6418 11.7393 19.3605C11.458 19.0792 11.3 18.6976 11.3 18.2998ZM11.3 12.2998C11.3 11.902 11.458 11.5204 11.7393 11.2391C12.0206 10.9578 12.4022 10.7998 12.8 10.7998C13.1978 10.7998 13.5794 10.9578 13.8607 11.2391C14.142 11.5204 14.3 11.902 14.3 12.2998C14.3 12.6976 14.142 13.0792 13.8607 13.3605C13.5794 13.6418 13.1978 13.7998 12.8 13.7998C12.4022 13.7998 12.0206 13.6418 11.7393 13.3605C11.458 13.0792 11.3 12.6976 11.3 12.2998ZM11.3 6.2998C11.3 5.90198 11.458 5.52045 11.7393 5.23914C12.0206 4.95784 12.4022 4.7998 12.8 4.7998C13.1978 4.7998 13.5794 4.95784 13.8607 5.23914C14.142 5.52045 14.3 5.90198 14.3 6.2998C14.3 6.69763 14.142 7.07916 13.8607 7.36046C13.5794 7.64177 13.1978 7.7998 12.8 7.7998C12.4022 7.7998 12.0206 7.64177 11.7393 7.36046C11.458 7.07916 11.3 6.69763 11.3 6.2998Z"
      fill="#99A1B7"
    />
  </svg>
)
export const LockSectionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2487 34.1102V29.3333C19.2487 15.6643 30.3297 4.58334 43.9987 4.58334C57.6677 4.58334 68.7487 15.6643 68.7487 29.3333V34.1102C69.5804 34.1686 70.3643 34.2448 71.1018 34.3439C74.4022 34.7877 77.1811 35.7369 79.3881 37.944C81.5951 40.151 82.5444 42.9299 82.9881 46.2303C83.4155 49.4091 83.4154 53.451 83.4154 58.4655V58.8679C83.4154 63.8824 83.4155 67.9242 82.9881 71.1031C82.5444 74.4035 81.5951 77.1824 79.3881 79.3894C77.1811 81.5964 74.4022 82.5457 71.1018 82.9894C67.9229 83.4168 63.8811 83.4167 58.8666 83.4167H29.1308C24.1163 83.4167 20.0745 83.4168 16.8956 82.9894C13.5952 82.5457 10.8163 81.5964 8.60932 79.3894C6.40229 77.1824 5.45301 74.4035 5.00929 71.1031C4.5819 67.9242 4.58196 63.8824 4.58203 58.8679V58.4655C4.58196 53.451 4.5819 49.4091 5.00929 46.2303C5.45301 42.9299 6.40229 40.151 8.60932 37.944C10.8163 35.7369 13.5952 34.7877 16.8956 34.3439C17.6331 34.2448 18.417 34.1686 19.2487 34.1102ZM24.7487 29.3333C24.7487 18.7019 33.3672 10.0833 43.9987 10.0833C54.6302 10.0833 63.2487 18.7019 63.2487 29.3333V33.9293C61.8791 33.9166 60.4195 33.9167 58.8666 33.9167H29.1308C27.5779 33.9167 26.1183 33.9166 24.7487 33.9293V29.3333ZM12.4984 41.833C13.5132 40.8182 14.938 40.1566 17.6285 39.7949C20.3981 39.4225 24.0688 39.4167 29.332 39.4167H58.6654C63.9286 39.4167 67.5993 39.4225 70.3689 39.7949C73.0594 40.1566 74.4842 40.8182 75.499 41.833C76.5138 42.8478 77.1754 44.2726 77.5372 46.9631C77.9095 49.7327 77.9154 53.4035 77.9154 58.6667C77.9154 63.9299 77.9095 67.6006 77.5372 70.3702C77.1754 73.0607 76.5138 74.4855 75.499 75.5003C74.4842 76.5151 73.0594 77.1767 70.3689 77.5385C67.5993 77.9108 63.9286 77.9167 58.6654 77.9167H29.332C24.0688 77.9167 20.3981 77.9108 17.6285 77.5385C14.938 77.1767 13.5132 76.5151 12.4984 75.5003C11.4836 74.4855 10.822 73.0607 10.4602 70.3702C10.0879 67.6006 10.082 63.9299 10.082 58.6667C10.082 53.4035 10.0879 49.7327 10.4602 46.9631C10.822 44.2726 11.4836 42.8478 12.4984 41.833Z"
        fill="#FFB700"
      />
    </svg>
  )
}

export const UnlockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7487 29.3333C24.7487 18.7018 33.3672 10.0833 43.9987 10.0833C52.9647 10.0833 60.5053 16.2155 62.6424 24.5188C63.021 25.9896 64.5202 26.8751 65.9911 26.4965C67.4619 26.1179 68.3474 24.6187 67.9688 23.1479C65.2214 12.4736 55.535 4.58331 43.9987 4.58331C30.3297 4.58331 19.2487 15.6643 19.2487 29.3333V34.1101C18.417 34.1686 17.6331 34.2447 16.8956 34.3439C13.5952 34.7876 10.8163 35.7369 8.60932 37.9439C6.40229 40.151 5.45301 42.9298 5.00929 46.2302C4.5819 49.4091 4.58196 53.4509 4.58203 58.4654V58.8679C4.58196 63.8823 4.5819 67.9242 5.00929 71.1031C5.45301 74.4035 6.40229 77.1823 8.60932 79.3894C10.8163 81.5964 13.5952 82.5457 16.8956 82.9894C20.0745 83.4168 24.1163 83.4167 29.1308 83.4166H58.8666C63.8811 83.4167 67.9229 83.4168 71.1018 82.9894C74.4022 82.5457 77.1811 81.5964 79.3881 79.3894C81.5951 77.1823 82.5444 74.4035 82.9881 71.1031C83.4155 67.9242 83.4154 63.8823 83.4154 58.8678V58.4655C83.4154 53.451 83.4155 49.4091 82.9881 46.2302C82.5444 42.9298 81.5951 40.151 79.3881 37.9439C77.1811 35.7369 74.4022 34.7876 71.1018 34.3439C67.9229 33.9165 63.8811 33.9166 58.8666 33.9166H29.1308C27.5779 33.9166 26.1183 33.9166 24.7487 33.9293V29.3333ZM12.4984 41.833C13.5132 40.8182 14.938 40.1566 17.6285 39.7949C20.3981 39.4225 24.0688 39.4166 29.332 39.4166H58.6654C63.9286 39.4166 67.5993 39.4225 70.3689 39.7949C73.0594 40.1566 74.4842 40.8182 75.499 41.833C76.5138 42.8478 77.1754 44.2726 77.5372 46.9631C77.9095 49.7327 77.9154 53.4035 77.9154 58.6666C77.9154 63.9298 77.9095 67.6006 77.5372 70.3702C77.1754 73.0607 76.5138 74.4855 75.499 75.5003C74.4842 76.5151 73.0594 77.1767 70.3689 77.5384C67.5993 77.9108 63.9286 77.9166 58.6654 77.9166H29.332C24.0688 77.9166 20.3981 77.9108 17.6285 77.5384C14.938 77.1767 13.5132 76.5151 12.4984 75.5003C11.4836 74.4855 10.822 73.0607 10.4602 70.3702C10.0879 67.6006 10.082 63.9298 10.082 58.6666C10.082 53.4035 10.0879 49.7327 10.4602 46.9631C10.822 44.2726 11.4836 42.8478 12.4984 41.833Z"
        fill="#FFB700"
      />
    </svg>
  )
}

export const ThankYouIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6213 16.2221C14.5384 19.0026 10.082 25.6162 10.082 33.5027C10.082 41.5598 13.3792 47.7702 18.1057 53.0925C22.0014 57.4791 26.7171 61.1146 31.3162 64.6602C32.4085 65.5024 33.4942 66.3394 34.5609 67.1803C36.4896 68.7008 38.2102 70.0353 39.8686 71.0044C41.5279 71.974 42.8635 72.4167 43.9987 72.4167C45.1339 72.4167 46.4695 71.974 48.1288 71.0044C49.7872 70.0353 51.5077 68.7007 53.4365 67.1803C54.5031 66.3394 55.5889 65.5024 56.6812 64.6602C61.2803 61.1146 65.996 57.4791 69.8916 53.0925C74.6182 47.7702 77.9154 41.5598 77.9154 33.5027C77.9154 25.6162 73.459 19.0026 67.3761 16.2221C61.4664 13.5208 53.5259 14.2361 45.98 22.076C45.4616 22.6147 44.7463 22.919 43.9987 22.919C43.2511 22.919 42.5358 22.6147 42.0174 22.076C34.4715 14.2361 26.5309 13.5208 20.6213 16.2221ZM43.9987 16.349C35.5212 8.76423 26.0282 7.7032 18.3348 11.2199C10.2093 14.9341 4.58203 23.5585 4.58203 33.5027C4.58203 43.2763 8.65385 50.7322 13.9933 56.7446C18.2692 61.5594 23.5028 65.5892 28.1251 69.1481C29.1728 69.9549 30.1892 70.7375 31.1559 71.4995C33.0341 72.9802 35.0504 74.559 37.0937 75.753C39.1362 76.9466 41.4672 77.9167 43.9987 77.9167C46.5302 77.9167 48.8612 76.9466 50.9037 75.753C52.947 74.559 54.9633 72.9802 56.8415 71.4995C57.8082 70.7375 58.8245 69.9549 59.8723 69.1481C64.4945 65.5892 69.7282 61.5594 74.0041 56.7446C79.3435 50.7322 83.4154 43.2763 83.4154 33.5027C83.4154 23.5585 77.7881 14.9341 69.6626 11.2199C61.9692 7.7032 52.4762 8.76423 43.9987 16.349Z"
        fill="#FFB700"
      />
    </svg>
  )
}
export const IconBuildingModify = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
    >
      <path
        d="M83.5824 67.3506L78.8009 62.5357C81.2753 59.2923 82.6128 55.2799 82.6128 51.1671C82.6128 40.8351 74.1866 32.3755 63.8212 32.3755C53.4557 32.3755 45.063 40.8351 45.063 51.1671C45.063 60.8638 52.4526 68.8887 61.8818 69.8584C61.5474 70.4603 61.1462 70.9618 60.6781 71.4299C59.2403 72.8343 57.3344 73.7037 53.9572 74.1383C50.5132 74.6064 45.9992 74.6064 39.6128 74.6064H32.9254C26.5389 74.6064 22.0249 74.6064 18.5809 74.1383C15.2037 73.7037 13.2978 72.8343 11.86 71.4299C10.4557 69.9921 9.61976 68.0862 9.15164 64.7091C8.68352 61.2651 8.68352 56.7511 8.68352 50.3646V36.9898C8.68352 30.6033 8.68352 26.0893 9.15164 22.6453C9.61976 19.2682 10.4557 17.3623 11.86 15.9245C13.2978 14.5201 15.2037 13.6842 18.5809 13.2161C22.0249 12.748 26.5389 12.748 32.9254 12.748H39.6128C45.9992 12.748 50.5132 12.748 53.9572 13.2161C57.3344 13.6842 59.2403 14.5201 60.6781 15.9245C61.6477 16.8942 63.2527 16.8942 64.2224 15.9245C65.1921 14.9548 65.1921 13.3498 64.2224 12.3802C61.7146 9.87239 58.5381 8.76897 54.626 8.23398C50.8142 7.73242 45.9324 7.73242 39.8134 7.73242H32.7247C26.6058 7.73242 21.724 7.73242 17.9121 8.23398C14 8.76897 10.8235 9.87239 8.31571 12.3802C5.80794 14.8879 4.70452 18.0645 4.16952 21.9766C3.66797 25.7884 3.66797 30.6702 3.66797 36.7892V50.5652C3.66797 56.6842 3.66797 61.566 4.16952 65.3778C4.70452 69.29 5.80794 72.4665 8.31571 74.9743C10.8235 77.482 14 78.5854 17.9121 79.1204C21.724 79.622 26.6058 79.622 32.7247 79.622H39.8134C45.9324 79.622 50.8142 79.622 54.626 79.1204C58.5381 78.5854 61.7146 77.482 64.2224 74.9743C65.7271 73.4361 66.7636 71.664 67.4324 69.5909C70.2411 69.0559 72.916 67.8856 75.1897 66.1469L80.0047 70.9284C80.4728 71.4299 81.1081 71.664 81.8103 71.664C82.5124 71.664 83.1143 71.4299 83.5824 70.9284C84.5855 69.9587 84.5855 68.3537 83.5824 67.3506ZM68.5023 64.0738C67.0311 64.6088 65.4596 64.9097 63.8212 64.9097C63.654 64.9097 63.5202 64.9097 63.353 64.8763C55.9969 64.6422 50.112 58.5901 50.112 51.1671C50.112 43.7441 56.2644 37.4579 63.8212 37.4579C71.3779 37.4579 77.5638 43.6103 77.5638 51.1671C77.5638 57.1189 73.7854 62.1679 68.5023 64.0738Z"
        fill="#FFB700"
      />
      <path
        d="M47.1361 33.646C47.1361 32.2751 45.9992 31.1382 44.6283 31.1382H22.8943C21.5234 31.1382 20.3865 32.2751 20.3865 33.646C20.3865 35.0169 21.5234 36.1538 22.8943 36.1538H44.6283C45.9992 36.1538 47.1361 35.0169 47.1361 33.646Z"
        fill="#FFB700"
      />
      <path
        d="M33.7613 47.0208C33.7613 45.6499 32.6244 44.513 31.2535 44.513H22.8943C21.5234 44.513 20.3865 45.6499 20.3865 47.0208C20.3865 48.3917 21.5234 49.5286 22.8943 49.5286H31.2535C32.6244 49.5286 33.7613 48.3917 33.7613 47.0208Z"
        fill="#FFB700"
      />
      <path
        d="M22.8943 57.888C21.5234 57.888 20.3865 59.0249 20.3865 60.3958C20.3865 61.7667 21.5234 62.9036 22.8943 62.9036H27.9098C29.2807 62.9036 30.4176 61.7667 30.4176 60.3958C30.4176 59.0249 29.2807 57.888 27.9098 57.888H22.8943Z"
        fill="#FFB700"
      />
    </svg>
  )
}

export const HomeMenuIcon = ({ selected }: { selected?: boolean }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 18.1706V10.354C21 9.14308 20.4604 7.9962 19.5301 7.23023L14.5301 3.11305C13.0577 1.90059 10.9423 1.90059 9.46986 3.11305L4.46986 7.23023C3.53964 7.9962 3 9.14308 3 10.354V18.1706C3 20.398 4.79086 22.2037 7 22.2037H17C19.2091 22.2037 21 20.398 21 18.1706Z"
        stroke={selected ? '#FFB800' : '#9CA3AF'}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M10 18.2037H14"
        stroke={selected ? '#FFB800' : '#9CA3AF'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const BookMenuIcon = ({ selected }: { selected?: boolean }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 4.58179C9.13095 3.12598 6.18953 2.46303 3.99433 2.21498C2.89642 2.09091 2 3.00773 2 4.13888V15.4037C2 16.5348 2.89642 17.452 3.99433 17.576C6.18953 17.8241 9.13095 18.487 11.25 19.9428V4.58179ZM12.75 19.9428C14.8691 18.487 17.8105 17.8241 20.0057 17.576C21.1036 17.452 22 16.5348 22 15.4037V4.13888C22 3.00773 21.1036 2.09091 20.0057 2.21498C17.8105 2.46303 14.8691 3.12598 12.75 4.58179V19.9428ZM4.25882 7.34367C4.32221 6.93433 4.70543 6.65389 5.11477 6.71729C6.41754 6.91904 7.88469 7.25628 9.27049 7.79217C9.65682 7.94156 9.8489 8.37586 9.6995 8.76219C9.55011 9.14852 9.11581 9.3406 8.72948 9.1912C7.47083 8.70448 6.11398 8.38991 4.8852 8.19961C4.47587 8.13622 4.19543 7.753 4.25882 7.34367ZM5.11477 10.7173C4.70543 10.6539 4.32221 10.9343 4.25882 11.3437C4.19543 11.753 4.47587 12.1362 4.8852 12.1996C5.50445 12.2955 6.15812 12.4233 6.81651 12.5894C7.21814 12.6907 7.62587 12.4473 7.7272 12.0456C7.82853 11.644 7.58509 11.2363 7.18346 11.135C6.47445 10.9561 5.7745 10.8195 5.11477 10.7173Z"
        fill={selected ? '#FFB800' : '#9CA3AF'}
      />
    </svg>
  )
}

export const FileMenuIcon = ({ selected }: { selected?: boolean }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.89998 3.2037C6.07155 3.2037 5.39998 3.87527 5.39998 4.7037V19.7037C5.39998 20.5321 6.07155 21.2037 6.89998 21.2037H17.1C17.9284 21.2037 18.6 20.5321 18.6 19.7037V9.2037H13.5C13.0029 9.2037 12.6 8.80076 12.6 8.3037V3.2037H6.89998ZM14.4 4.47649L17.3272 7.4037H14.4V4.47649ZM3.59998 4.7037C3.59998 2.88116 5.07744 1.4037 6.89998 1.4037H13.5C13.7387 1.4037 13.9676 1.49852 14.1364 1.66731L20.1364 7.6673C20.3052 7.83609 20.4 8.06501 20.4 8.3037V19.7037C20.4 21.5262 18.9225 23.0037 17.1 23.0037H6.89998C5.07744 23.0037 3.59998 21.5262 3.59998 19.7037V4.7037Z"
        fill={selected ? '#FFB800' : '#9CA3AF'}
      />
    </svg>
  )
}
export const BellIcon = ({ selected }: { selected?: boolean }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.4724 6.41462C5.76764 3.44709 8.3083 1.40372 11.2398 1.40372H12.7603C15.6917 1.40372 18.2324 3.44709 18.5276 6.41462L18.5281 6.41935L19.0361 11.8146C19.0361 11.8154 19.0362 11.8162 19.0363 11.817C19.2031 13.4886 19.9248 15.1762 21.0645 16.3868C21.6872 17.0484 21.6926 17.9649 21.451 18.6211C21.2087 19.2793 20.587 20.0037 19.6091 20.0037H15.5502C15.2646 21.7063 13.7838 23.0037 12 23.0037C10.2162 23.0037 8.73544 21.7063 8.44979 20.0037H4.39088C3.41301 20.0037 2.79133 19.2793 2.54899 18.6211C2.30737 17.9649 2.31278 17.0484 2.93555 16.3868C4.07523 15.1761 4.79691 13.4885 4.96373 11.8169L5.4724 6.41462ZM19.6091 18.2037C19.6137 18.2037 19.6149 18.2032 19.6163 18.2027C19.6189 18.2017 19.6287 18.1974 19.6442 18.1843C19.6784 18.1554 19.7268 18.0945 19.7619 17.9992C19.7967 17.9046 19.806 17.8092 19.7965 17.7347C19.7874 17.6635 19.7649 17.6324 19.7538 17.6206C18.3186 16.096 17.4472 14.0261 17.2449 11.9928L17.2444 11.9881L16.7365 6.59282C16.7364 6.59204 16.7363 6.59126 16.7362 6.59047C16.5411 4.64164 14.8665 3.20372 12.7603 3.20372H11.2398C9.13344 3.20372 7.45886 4.64169 7.26378 6.59057C7.26371 6.59132 7.26364 6.59207 7.26356 6.59282L6.75513 11.9928C6.55283 14.0261 5.68137 16.096 4.24621 17.6206C4.23511 17.6324 4.21266 17.6635 4.20354 17.7347C4.19399 17.8092 4.20331 17.9046 4.23813 17.9992C4.27324 18.0945 4.3216 18.1554 4.35579 18.1843C4.37134 18.1974 4.38101 18.2016 4.38355 18.2026C4.38505 18.2032 4.38621 18.2037 4.39088 18.2037H19.6091ZM10.3024 20.0037C10.5495 20.7028 11.2163 21.2037 12 21.2037C12.7837 21.2037 13.4505 20.7028 13.6976 20.0037H10.3024Z"
        fill={selected ? '#FFB800' : '#9CA3AF'}
      />
    </svg>
  )
}

export const CalenderMenuIcon = ({ selected }: { selected?: boolean }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.09995 1.4037C8.59701 1.4037 8.99995 1.80665 8.99995 2.3037V3.8037H15V2.3037C15 1.80665 15.4029 1.4037 15.9 1.4037C16.397 1.4037 16.8 1.80665 16.8 2.3037V3.8037H19.5C21.3225 3.8037 22.7999 5.28116 22.7999 7.1037V19.7037C22.7999 21.5262 21.3225 23.0037 19.5 23.0037H4.49995C2.67741 23.0037 1.19995 21.5262 1.19995 19.7037V7.1037C1.19995 5.28116 2.67741 3.8037 4.49995 3.8037H7.19995V2.3037C7.19995 1.80665 7.60289 1.4037 8.09995 1.4037ZM7.19995 5.6037H4.49995C3.67152 5.6037 2.99995 6.27527 2.99995 7.1037V9.8037H21V7.1037C21 6.27527 20.3284 5.6037 19.5 5.6037H16.8V6.5037C16.8 7.00076 16.397 7.4037 15.9 7.4037C15.4029 7.4037 15 7.00076 15 6.5037V5.6037H8.99995V6.5037C8.99995 7.00076 8.59701 7.4037 8.09995 7.4037C7.60289 7.4037 7.19995 7.00076 7.19995 6.5037V5.6037ZM21 11.6037H2.99995V19.7037C2.99995 20.5321 3.67152 21.2037 4.49995 21.2037H19.5C20.3284 21.2037 21 20.5321 21 19.7037V11.6037Z"
        fill={selected ? '#FFB800' : '#9CA3AF'}
      />
    </svg>
  )
}

export const MyCalendarMenuIcon = ({ selected }: { selected?: boolean }) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 6.20355C22.5 5.4079 22.1839 4.64483 21.6213 4.08222C21.0587 3.51962 20.2956 3.20354 19.5 3.20354H18.75V2.47464C18.75 2.07104 18.4397 1.72464 18.0361 1.70448C17.9347 1.6996 17.8333 1.71535 17.7382 1.75079C17.6431 1.78623 17.5561 1.84061 17.4826 1.91065C17.4091 1.98069 17.3506 2.06492 17.3106 2.15823C17.2706 2.25155 17.25 2.35202 17.25 2.45354V3.20354H6.75V2.47464C6.75 2.07104 6.43969 1.72464 6.03609 1.70448C5.93469 1.6996 5.83334 1.71535 5.7382 1.75079C5.64307 1.78623 5.55611 1.84061 5.48261 1.91065C5.40911 1.98069 5.3506 2.06492 5.31062 2.15823C5.27063 2.25155 5.25001 2.35202 5.25 2.45354V3.20354H4.5C3.70435 3.20354 2.94129 3.51962 2.37868 4.08222C1.81607 4.64483 1.5 5.4079 1.5 6.20355V6.76605C1.5 6.81577 1.51975 6.86346 1.55492 6.89863C1.59008 6.93379 1.63777 6.95355 1.6875 6.95355H22.3125C22.3622 6.95355 22.4099 6.93379 22.4451 6.89863C22.4802 6.86346 22.5 6.81577 22.5 6.76605V6.20355Z"
      fill={selected ? '#FFB800' : '#9CA3AF'}
    />
    <path
      d="M1.5 19.7036C1.5 20.4993 1.81607 21.2623 2.37868 21.8249C2.94129 22.3875 3.70435 22.7036 4.5 22.7036H19.5C20.2956 22.7036 21.0587 22.3875 21.6213 21.8249C22.1839 21.2623 22.5 20.4993 22.5 19.7036V8.64111C22.5 8.59139 22.4802 8.54369 22.4451 8.50853C22.4099 8.47337 22.3622 8.45361 22.3125 8.45361H1.6875C1.63777 8.45361 1.59008 8.47337 1.55492 8.50853C1.51975 8.54369 1.5 8.59139 1.5 8.64111V19.7036Z"
      fill={selected ? '#FFB800' : '#9CA3AF'}
    />
  </svg>
)

export const HelpMenuIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.00001C7.02939 3.00001 2.99995 7.02945 2.99995 12C2.99995 16.9706 7.02939 21 12 21C16.9705 21 21 16.9706 21 12C21 7.02945 16.9705 3.00001 12 3.00001ZM1.19995 12C1.19995 6.03534 6.03528 1.20001 12 1.20001C17.9646 1.20001 22.7999 6.03534 22.7999 12C22.7999 17.9647 17.9646 22.8 12 22.8C6.03528 22.8 1.19995 17.9647 1.19995 12ZM12 7.80001C11.0058 7.80001 10.2 8.6059 10.2 9.60001C10.2 10.0971 9.79701 10.5 9.29995 10.5C8.80289 10.5 8.39995 10.0971 8.39995 9.60001C8.39995 7.61179 10.0117 6.00001 12 6.00001C13.9882 6.00001 15.6 7.61179 15.6 9.60001C15.6 11.2775 14.4527 12.687 12.9 13.0866V13.5C12.9 13.9971 12.497 14.4 12 14.4C11.5029 14.4 11.1 13.9971 11.1 13.5V12.3C11.1 11.803 11.5029 11.4 12 11.4C12.9941 11.4 13.8 10.5941 13.8 9.60001C13.8 8.6059 12.9941 7.80001 12 7.80001ZM12 15.6C12.497 15.6 12.9 16.003 12.9 16.5V17.1C12.9 17.5971 12.497 18 12 18C11.5029 18 11.1 17.5971 11.1 17.1V16.5C11.1 16.003 11.5029 15.6 12 15.6Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export const LogOutMenuIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3613 12.6104C21.6795 12.2657 21.6795 11.7343 21.3613 11.3895L17.7613 7.48954C17.4242 7.1243 16.8548 7.10152 16.4895 7.43866C16.1243 7.77581 16.1015 8.3452 16.4387 8.71044L18.6444 11.1L10.5 11.1C10.0029 11.1 9.59998 11.5029 9.59998 12C9.59998 12.497 10.0029 12.9 10.5 12.9L18.6444 12.9L16.4387 15.2895C16.1015 15.6548 16.1243 16.2242 16.4895 16.5613C16.8548 16.8985 17.4242 16.8757 17.7613 16.5104L21.3613 12.6104ZM12 21.9C12 21.4029 11.597 21 11.1 21L5.69997 21C4.87155 21 4.19997 20.3284 4.19997 19.5L4.19997 4.49999C4.19997 3.67156 4.87155 2.99999 5.69997 2.99999L11.1 2.99999C11.597 2.99999 12 2.59704 12 2.09999C12 1.60293 11.597 1.19999 11.1 1.19999L5.69997 1.19999C3.87744 1.19999 2.39997 2.67745 2.39997 4.49999L2.39997 19.5C2.39997 21.3225 3.87743 22.8 5.69998 22.8L11.1 22.8C11.597 22.8 12 22.397 12 21.9Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}
export const BookInClassIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7575 1.94083C12.506 1.72936 12.193 1.60458 11.865 1.585C11.7971 1.57903 11.7288 1.57903 11.6608 1.585H11.5383C10.0331 1.84755 8.5858 2.37277 7.26251 3.13666C7.19063 3.17554 7.11082 3.19748 7.02918 3.20083C6.93785 3.2026 6.84821 3.17611 6.77251 3.125C5.43458 2.37504 3.96881 1.88052 2.45001 1.66666C2.23807 1.6327 2.02128 1.64539 1.81474 1.70382C1.60821 1.76225 1.41691 1.86503 1.25418 2.005C1.0857 2.14842 0.951208 2.32749 0.860412 2.52926C0.769617 2.73103 0.724791 2.95045 0.729175 3.17166V10.3467C0.7253 10.6988 0.848973 11.0404 1.07735 11.3085C1.30574 11.5765 1.6234 11.7529 1.97168 11.805C3.49975 12.0768 4.97842 12.5762 6.35834 13.2867C6.67013 13.4332 7.02437 13.4622 7.35584 13.3683C7.4681 13.3449 7.57759 13.3097 7.68251 13.2633C9.05729 12.5591 10.5333 12.073 12.0575 11.8225C12.3994 11.7619 12.7088 11.5822 12.9309 11.3153C13.153 11.0483 13.2734 10.7114 13.2708 10.3642V3.06083C13.2714 2.84812 13.2258 2.63782 13.1372 2.44446C13.0485 2.25109 12.919 2.07926 12.7575 1.94083ZM2.10584 10.9417C1.96568 10.9219 1.8375 10.8517 1.74521 10.7444C1.65291 10.6371 1.60278 10.4999 1.60418 10.3583V3.1075C1.60444 3.01734 1.62442 2.92833 1.66271 2.84671C1.701 2.76509 1.75668 2.69283 1.82584 2.635C1.93219 2.54121 2.06905 2.48937 2.21084 2.48916H2.33334C3.74284 2.70569 5.09979 3.1824 6.33501 3.895C6.41569 3.94089 6.50196 3.97618 6.59168 4V12.4175C5.17645 11.7092 3.66514 11.212 2.10584 10.9417ZM12.3958 10.3583C12.3979 10.4973 12.3502 10.6324 12.2614 10.7394C12.1727 10.8463 12.0486 10.918 11.9117 10.9417C11.4975 11.0117 11.0892 11.0992 10.6867 11.1983L10.3367 11.2975C10.0625 11.3675 9.78834 11.4433 9.52001 11.5308C9.37418 11.5775 9.23418 11.6358 9.09418 11.6883C8.86084 11.77 8.63334 11.8517 8.40584 11.945C8.17834 12.0383 8.12001 12.0733 7.97418 12.1433C7.82834 12.2133 7.61251 12.295 7.43751 12.3825V4C7.52478 3.96952 7.60881 3.93044 7.68834 3.88333C8.64202 3.35367 9.65673 2.9423 10.71 2.65833C11.0367 2.57666 11.3517 2.5125 11.6725 2.46C11.7635 2.44526 11.8567 2.45068 11.9454 2.47588C12.0341 2.50107 12.1162 2.54544 12.1858 2.60583C12.2525 2.6613 12.3059 2.73092 12.3422 2.80963C12.3785 2.88834 12.3968 2.97415 12.3958 3.06083V10.3583ZM2.75334 5.31833C2.75629 5.20323 2.80334 5.09365 2.88475 5.01224C2.96617 4.93082 3.07574 4.88378 3.19084 4.88083H4.51501C4.63104 4.88083 4.74232 4.92692 4.82437 5.00897C4.90641 5.09102 4.95251 5.2023 4.95251 5.31833C4.95251 5.43436 4.90641 5.54564 4.82437 5.62769C4.74232 5.70973 4.63104 5.75583 4.51501 5.75583H3.19084C3.07528 5.75432 2.96488 5.70774 2.88315 5.62602C2.80143 5.5443 2.75485 5.43389 2.75334 5.31833ZM5.39584 7.06833C5.39284 7.18287 5.3456 7.2918 5.26403 7.37228C5.18247 7.45276 5.07292 7.49853 4.95834 7.5H3.20834C3.09231 7.5 2.98103 7.4539 2.89898 7.37185C2.81694 7.28981 2.77084 7.17853 2.77084 7.0625C2.77084 6.94646 2.81694 6.83518 2.89898 6.75314C2.98103 6.67109 3.09231 6.625 3.20834 6.625H4.95834C5.01656 6.62576 5.07406 6.63798 5.12756 6.66096C5.18106 6.68395 5.2295 6.71725 5.27013 6.75896C5.31076 6.80067 5.34277 6.84997 5.36434 6.90406C5.38591 6.95814 5.39661 7.01594 5.39584 7.07416V7.06833Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}
export const ClockInClassIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99996 1.22917C5.75971 1.22917 4.54731 1.59695 3.51607 2.286C2.48484 2.97505 1.68109 3.95442 1.20647 5.10026C0.731843 6.24611 0.60766 7.50696 0.849621 8.72338C1.09158 9.93981 1.68882 11.0572 2.56581 11.9342C3.44281 12.8111 4.56016 13.4084 5.77658 13.6503C6.99301 13.8923 8.25386 13.7681 9.39971 13.2935C10.5456 12.8189 11.5249 12.0151 12.214 10.9839C12.903 9.95266 13.2708 8.74026 13.2708 7.5C13.2708 5.83688 12.6101 4.24187 11.4341 3.06586C10.2581 1.88985 8.66309 1.22917 6.99996 1.22917ZM6.99996 12.8958C5.92996 12.8958 4.88402 12.5784 3.99451 11.9837C3.105 11.389 2.41191 10.5438 2.00298 9.555C1.59404 8.56622 1.48764 7.47836 1.69724 6.42909C1.90683 5.37982 2.42301 4.41632 3.18043 3.66053C3.93785 2.90475 4.90246 2.39065 5.95218 2.18332C7.0019 1.97599 8.08953 2.08475 9.07742 2.49582C10.0653 2.90689 10.909 3.60179 11.5018 4.49259C12.0946 5.38338 12.4098 6.43001 12.4075 7.5C12.4059 8.93369 11.8357 10.3082 10.8219 11.322C9.80817 12.3357 8.43365 12.906 6.99996 12.9075V12.8958ZM9.91663 7.5C9.91663 7.61449 9.87115 7.72429 9.7902 7.80524C9.70924 7.88619 9.59945 7.93167 9.48496 7.93167H6.99996C6.88548 7.93167 6.77568 7.88619 6.69473 7.80524C6.61377 7.72429 6.5683 7.61449 6.5683 7.5V3.95334C6.5683 3.83885 6.61377 3.72906 6.69473 3.6481C6.77568 3.56715 6.88548 3.52167 6.99996 3.52167C7.11445 3.52167 7.22424 3.56715 7.3052 3.6481C7.38615 3.72906 7.43163 3.83885 7.43163 3.95334V7.06834H9.50246C9.61389 7.07286 9.71924 7.12033 9.79644 7.20079C9.87365 7.28126 9.91672 7.38849 9.91663 7.5Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}
export const GeoLocationIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16667 1.71676C7.87162 1.86812 6.64305 2.37236 5.61506 3.17442C4.58708 3.97648 3.79919 5.04554 3.33742 6.26489C2.87565 7.48424 2.75774 8.80702 2.99656 10.0888C3.23538 11.3706 3.82175 12.5622 4.69167 13.5334L8.33333 17.5751C8.54424 17.8077 8.80149 17.9935 9.08853 18.1207C9.37557 18.2479 9.68605 18.3136 10 18.3136C10.314 18.3136 10.6244 18.2479 10.9115 18.1207C11.1985 17.9935 11.4558 17.8077 11.6667 17.5751L15.2917 13.5334C16.2507 12.4559 16.8601 11.1127 17.0393 9.68145C17.2184 8.25016 16.959 6.79819 16.2952 5.51754C15.6314 4.2369 14.5945 3.18789 13.3216 2.50923C12.0488 1.83058 10.5999 1.55424 9.16667 1.71676ZM10 11.5334C9.44291 11.5334 8.89834 11.3682 8.43514 11.0587C7.97194 10.7492 7.61092 10.3093 7.39774 9.79465C7.18455 9.27997 7.12877 8.71364 7.23745 8.16726C7.34614 7.62088 7.6144 7.11899 8.00831 6.72508C8.40223 6.33116 8.90411 6.0629 9.45049 5.95422C9.99687 5.84553 10.5632 5.90131 11.0779 6.1145C11.5926 6.32769 12.0325 6.68871 12.342 7.1519C12.6515 7.6151 12.8167 8.15968 12.8167 8.71676C12.8167 9.46379 12.5199 10.1802 11.9917 10.7084C11.4635 11.2367 10.747 11.5334 10 11.5334Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}
export const CalendarIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8917 8.39994H3.10836C2.93446 8.40645 2.77001 8.48069 2.65011 8.60682C2.53022 8.73294 2.46439 8.90094 2.46669 9.07494V13.7999C2.45898 14.3904 2.56821 14.9765 2.78809 15.5246C3.00796 16.0726 3.33413 16.5717 3.74779 16.9932C4.16145 17.4146 4.65443 17.7499 5.1983 17.9799C5.74217 18.2099 6.32619 18.33 6.91669 18.3333H13.125C14.3039 18.3049 15.4241 17.8131 16.243 16.9646C17.0619 16.1161 17.5135 14.9791 17.5 13.7999V9.07494C17.5028 8.90636 17.4415 8.74299 17.3287 8.61774C17.2158 8.4925 17.0597 8.41467 16.8917 8.39994ZM7.33336 14.8999C7.19435 14.8999 7.05843 14.8589 6.94255 14.7821C6.82667 14.7053 6.73594 14.5961 6.68167 14.4681C6.6274 14.3402 6.61199 14.199 6.63736 14.0624C6.66272 13.9257 6.72775 13.7995 6.82432 13.6995C6.9209 13.5995 7.04476 13.5302 7.18048 13.5001C7.31619 13.47 7.45776 13.4805 7.58755 13.5303C7.71734 13.5801 7.8296 13.667 7.91035 13.7801C7.99111 13.8933 8.03678 14.0277 8.04169 14.1666C8.0395 14.353 7.9639 14.5311 7.8313 14.6621C7.6987 14.7931 7.51978 14.8666 7.33336 14.8666V14.8999ZM7.33336 12.2416C7.19326 12.2416 7.05631 12.2001 6.93983 12.1222C6.82334 12.0444 6.73255 11.9338 6.67894 11.8043C6.62533 11.6749 6.6113 11.5325 6.63863 11.3951C6.66597 11.2577 6.73343 11.1315 6.83249 11.0324C6.93155 10.9333 7.05777 10.8659 7.19517 10.8385C7.33257 10.8112 7.47499 10.8252 7.60442 10.8789C7.73386 10.9325 7.84448 11.0233 7.92231 11.1397C8.00015 11.2562 8.04169 11.3932 8.04169 11.5333C8.04281 11.6266 8.02525 11.7192 7.99005 11.8057C7.95485 11.8921 7.90271 11.9706 7.83672 12.0366C7.77072 12.1026 7.69219 12.1548 7.60574 12.19C7.5193 12.2252 7.42669 12.2427 7.33336 12.2416ZM10 14.8999C9.81361 14.8956 9.63645 14.8179 9.50696 14.6837C9.37747 14.5495 9.30611 14.3697 9.30836 14.1833C9.30836 13.9976 9.38211 13.8196 9.51338 13.6883C9.64466 13.557 9.82271 13.4833 10.0084 13.4833C10.194 13.4833 10.3721 13.557 10.5033 13.6883C10.6346 13.8196 10.7084 13.9976 10.7084 14.1833C10.7062 14.3697 10.6306 14.5477 10.498 14.6788C10.3654 14.8098 10.1865 14.8833 10 14.8833V14.8999ZM10 12.2416C9.81361 12.2372 9.63645 12.1595 9.50696 12.0254C9.37747 11.8912 9.30611 11.7114 9.30836 11.5249C9.30836 11.3393 9.38211 11.1612 9.51338 11.03C9.64466 10.8987 9.82271 10.8249 10.0084 10.8249C10.194 10.8249 10.3721 10.8987 10.5033 11.03C10.6346 11.1612 10.7084 11.3393 10.7084 11.5249C10.7084 11.7114 10.6349 11.8903 10.5038 12.0229C10.3728 12.1555 10.1948 12.2311 10.0084 12.2333L10 12.2416ZM12.65 14.8999C12.4622 14.8999 12.282 14.8253 12.1492 14.6925C12.0163 14.5596 11.9417 14.3795 11.9417 14.1916C11.9417 14.0037 12.0163 13.8236 12.1492 13.6907C12.282 13.5579 12.4622 13.4833 12.65 13.4833C12.8379 13.4833 13.0181 13.5579 13.1509 13.6907C13.2837 13.8236 13.3584 14.0037 13.3584 14.1916C13.3584 14.3795 13.2837 14.5596 13.1509 14.6925C13.0181 14.8253 12.8379 14.8999 12.65 14.8999ZM12.65 12.2416C12.4622 12.2416 12.282 12.167 12.1492 12.0341C12.0163 11.9013 11.9417 11.7211 11.9417 11.5333C11.9417 11.3454 12.0163 11.1652 12.1492 11.0324C12.282 10.8996 12.4622 10.8249 12.65 10.8249C12.8379 10.8249 13.0181 10.8996 13.1509 11.0324C13.2837 11.1652 13.3584 11.3454 13.3584 11.5333C13.3584 11.7211 13.2837 11.9013 13.1509 12.0341C13.0181 12.167 12.8379 12.2416 12.65 12.2416ZM17.275 6.33327C17.3348 6.50472 17.3257 6.69269 17.2495 6.8575C17.1733 7.02232 17.036 7.15108 16.8667 7.21661C16.7944 7.24246 16.7184 7.25652 16.6417 7.25827H3.51669C3.29568 7.25827 3.08371 7.17048 2.92743 7.01419C2.77115 6.85791 2.68336 6.64595 2.68336 6.42494C2.681 6.32191 2.7009 6.21958 2.74169 6.12494C2.98601 5.52672 3.35676 4.98838 3.82853 4.54681C4.30031 4.10524 4.86197 3.77087 5.47502 3.56661V2.26661C5.47502 2.11632 5.53473 1.97218 5.641 1.86591C5.74727 1.75964 5.8914 1.69994 6.04169 1.69994C6.19198 1.69994 6.33611 1.75964 6.44238 1.86591C6.54865 1.97218 6.60836 2.11632 6.60836 2.26661V3.33327H9.56669V2.26661C9.55698 2.18699 9.56429 2.10622 9.58812 2.02964C9.61195 1.95305 9.65177 1.8824 9.70494 1.82235C9.75811 1.7623 9.82342 1.71423 9.89656 1.6813C9.96969 1.64837 10.049 1.63135 10.1292 1.63135C10.2094 1.63135 10.2887 1.64837 10.3618 1.6813C10.435 1.71423 10.5003 1.7623 10.5534 1.82235C10.6066 1.8824 10.6464 1.95305 10.6703 2.02964C10.6941 2.10622 10.7014 2.18699 10.6917 2.26661V3.33327H13.3334V2.26661C13.3236 2.18699 13.331 2.10622 13.3548 2.02964C13.3786 1.95305 13.4184 1.8824 13.4716 1.82235C13.5248 1.7623 13.5901 1.71423 13.6632 1.6813C13.7364 1.64837 13.8157 1.63135 13.8959 1.63135C13.9761 1.63135 14.0554 1.64837 14.1285 1.6813C14.2016 1.71423 14.2669 1.7623 14.3201 1.82235C14.3733 1.8824 14.4131 1.95305 14.4369 2.02964C14.4608 2.10622 14.4681 2.18699 14.4584 2.26661V3.56661C15.1076 3.78276 15.6988 4.14438 16.187 4.62387C16.6751 5.10336 17.0473 5.68803 17.275 6.33327Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}
export const SearchIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.5 2.75C6.66751 2.75 2.75 6.66751 2.75 11.5C2.75 16.3325 6.66751 20.25 11.5 20.25C16.3325 20.25 20.25 16.3325 20.25 11.5C20.25 6.66751 16.3325 2.75 11.5 2.75ZM1.25 11.5C1.25 5.83908 5.83908 1.25 11.5 1.25C17.1609 1.25 21.75 5.83908 21.75 11.5C21.75 14.0605 20.8111 16.4017 19.2589 18.1982L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L18.1982 19.2589C16.4017 20.8111 14.0605 21.75 11.5 21.75C5.83908 21.75 1.25 17.1609 1.25 11.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const MessageDialogIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.98899 5.30778C10.169 2.90545 12.6404 1.25 15.5 1.25C19.5041 1.25 22.75 4.49594 22.75 8.5C22.75 9.57209 22.5168 10.5918 22.0977 11.5093C21.9883 11.7488 21.967 11.975 22.0156 12.1568L22.143 12.6328C22.5507 14.1566 21.1566 15.5507 19.6328 15.143L19.1568 15.0156C19.0215 14.9794 18.8616 14.982 18.6899 15.0307C18.1798 19.3775 14.4838 22.75 10 22.75C8.65003 22.75 7.36949 22.4438 6.2259 21.8963C5.99951 21.7879 5.7766 21.7659 5.59324 21.815L4.3672 22.143C2.84337 22.5507 1.44927 21.1566 1.857 19.6328L2.18504 18.4068C2.2341 18.2234 2.21211 18.0005 2.10373 17.7741C1.55623 16.6305 1.25 15.35 1.25 14C1.25 9.50945 4.63273 5.80897 8.98899 5.30778ZM10.735 5.28043C15.0598 5.64011 18.4914 9.14511 18.736 13.5016C18.9986 13.4766 19.2714 13.4935 19.5445 13.5666L20.0205 13.694C20.4293 13.8034 20.8034 13.4293 20.694 13.0205L20.5666 12.5445C20.4095 11.9571 20.5119 11.3708 20.7333 10.8861C21.0649 10.1602 21.25 9.35275 21.25 8.5C21.25 5.32436 18.6756 2.75 15.5 2.75C13.5181 2.75 11.7692 3.75284 10.735 5.28043ZM10 6.75C5.99594 6.75 2.75 9.99594 2.75 14C2.75 15.121 3.00392 16.1807 3.45667 17.1264C3.69207 17.6181 3.79079 18.2087 3.63407 18.7945L3.30602 20.0205C3.19664 20.4293 3.57066 20.8034 3.97949 20.694L5.20553 20.3659C5.79126 20.2092 6.38191 20.3079 6.87362 20.5433C7.81932 20.9961 8.87896 21.25 10 21.25C14.0041 21.25 17.25 18.0041 17.25 14C17.25 9.99594 14.0041 6.75 10 6.75Z"
        fill="currentColor"
      />
      <path
        d="M7.5 14C7.5 14.5523 7.05228 15 6.5 15C5.94772 15 5.5 14.5523 5.5 14C5.5 13.4477 5.94772 13 6.5 13C7.05228 13 7.5 13.4477 7.5 14Z"
        fill="currentColor"
      />
      <path
        d="M11 14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13C10.5523 13 11 13.4477 11 14Z"
        fill="currentColor"
      />
      <path
        d="M14.5 14C14.5 14.5523 14.0523 15 13.5 15C12.9477 15 12.5 14.5523 12.5 14C12.5 13.4477 12.9477 13 13.5 13C14.0523 13 14.5 13.4477 14.5 14Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const ArrowActionIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        d="M15.4444 1.25C14.0768 1.24998 12.9745 1.24996 12.1075 1.36652C11.2074 1.48754 10.4495 1.74643 9.84759 2.34835C9.32266 2.87328 9.05742 3.51836 8.91818 4.27635C8.78289 5.01291 8.75701 5.9143 8.75099 6.99583C8.74868 7.41003 9.08259 7.74768 9.4968 7.74999C9.91101 7.7523 10.2487 7.41838 10.251 7.00418C10.2571 5.91068 10.2854 5.1356 10.3935 4.54735C10.4976 3.98054 10.6648 3.65246 10.9082 3.40901C11.185 3.13225 11.5736 2.9518 12.3074 2.85315C13.0627 2.75159 14.0638 2.75 15.4992 2.75H16.4992C17.9347 2.75 18.9358 2.75159 19.6911 2.85315C20.4249 2.9518 20.8135 3.13225 21.0902 3.40901C21.367 3.68577 21.5474 4.07435 21.6461 4.80812C21.7476 5.56347 21.7492 6.56459 21.7492 8V16C21.7492 17.4354 21.7476 18.4365 21.6461 19.1919C21.5474 19.9257 21.367 20.3142 21.0902 20.591C20.8135 20.8678 20.4249 21.0482 19.6911 21.1469C18.9358 21.2484 17.9347 21.25 16.4992 21.25H15.4992C14.0638 21.25 13.0627 21.2484 12.3074 21.1469C11.5736 21.0482 11.185 20.8678 10.9082 20.591C10.6648 20.3475 10.4976 20.0195 10.3935 19.4527C10.2854 18.8644 10.2571 18.0893 10.251 16.9958C10.2487 16.5816 9.91101 16.2477 9.4968 16.25C9.08259 16.2523 8.74868 16.59 8.75099 17.0042C8.75701 18.0857 8.78289 18.9871 8.91818 19.7236C9.05742 20.4816 9.32266 21.1267 9.84759 21.6517C10.4495 22.2536 11.2074 22.5125 12.1075 22.6335C12.9745 22.75 14.0768 22.75 15.4444 22.75H16.5541C17.9217 22.75 19.024 22.75 19.891 22.6335C20.7911 22.5125 21.549 22.2536 22.1509 21.6517C22.7528 21.0497 23.0117 20.2919 23.1327 19.3918C23.2493 18.5248 23.2493 17.4225 23.2492 16.0549V7.94513C23.2493 6.57754 23.2493 5.47522 23.1327 4.60825C23.0117 3.70814 22.7528 2.95027 22.1509 2.34835C21.549 1.74643 20.7911 1.48754 19.891 1.36652C19.024 1.24996 17.9217 1.24998 16.5541 1.25H15.4444Z"
        fill="currentColor"
      />
      <path
        d="M2.5 11.249C2.08579 11.249 1.75 11.5848 1.75 11.999C1.75 12.4132 2.08579 12.749 2.5 12.749L14.4726 12.749L12.5119 14.4296C12.1974 14.6991 12.161 15.1726 12.4306 15.4871C12.7001 15.8016 13.1736 15.838 13.4881 15.5685L16.9881 12.5685C17.1543 12.426 17.25 12.218 17.25 11.999C17.25 11.7801 17.1543 11.5721 16.9881 11.4296L13.4881 8.42958C13.1736 8.16002 12.7001 8.19644 12.4306 8.51093C12.161 8.82543 12.1974 9.2989 12.5119 9.56847L14.4726 11.249L2.5 11.249Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const OutgoingCallIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6925 4.95112C9.52266 2.855 6.68752 2.72728 5.00745 4.40735C4.10879 5.30601 3.3103 6.50092 3.25706 7.90512C3.17818 9.98605 3.71556 13.4413 7.13735 16.8631C10.5591 20.2849 14.0144 20.8222 16.0953 20.7434C17.4995 20.6901 18.6944 19.8916 19.5931 18.993C21.2731 17.3129 21.1454 14.4778 19.0493 13.3079L17.8864 12.6589C16.5176 11.895 14.7905 12.2205 13.6585 13.3388C13.6381 13.3538 13.5231 13.4327 13.3221 13.4425C13.0656 13.455 12.4729 13.3637 11.5548 12.4456C10.6364 11.5272 10.5454 10.9344 10.5579 10.6781C10.5677 10.4773 10.6467 10.3623 10.6616 10.3419C11.7799 9.20995 12.1054 7.48287 11.3415 6.11405L10.6925 4.95112ZM6.06811 5.46801C7.17394 4.36218 8.78363 4.60877 9.38265 5.68211L10.0317 6.84504C10.4354 7.56846 10.2977 8.5846 9.58435 9.29792C9.51471 9.36757 9.09846 9.8132 9.0597 10.6047C9.02003 11.415 9.38395 12.3961 10.4942 13.5063C11.604 14.6161 12.5847 14.9802 13.395 14.9407C14.1864 14.9022 14.6322 14.4863 14.7023 14.4163C15.4156 13.703 16.432 13.565 17.1554 13.9688L18.3183 14.6178C19.3916 15.2168 19.6382 16.8265 18.5324 17.9323C17.7571 18.7077 16.9013 19.2117 16.0385 19.2444C14.3031 19.3102 11.2774 18.8818 8.19801 15.8024C5.11864 12.723 4.6902 9.69729 4.75599 7.96195C4.7887 7.09917 5.29276 6.24335 6.06811 5.46801Z"
        fill="currentColor"
      />
      <path
        d="M16 4.25045C15.5858 4.25045 15.25 4.58623 15.25 5.00045C15.25 5.41466 15.5858 5.75045 16 5.75045H17.1893L14.4696 8.47012C14.1768 8.76301 14.1768 9.23788 14.4696 9.53078C14.7625 9.82367 15.2374 9.82367 15.5303 9.53078L18.25 6.81111V8.00045C18.25 8.41466 18.5858 8.75045 19 8.75045C19.4142 8.75045 19.75 8.41466 19.75 8.00045V5.00045C19.75 4.58623 19.4142 4.25045 19 4.25045H16Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const MessageLetterIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.4436 3.25H14.5564C16.3942 3.24998 17.8498 3.24997 18.989 3.40314C20.1614 3.56076 21.1104 3.89288 21.8588 4.64124C22.6071 5.38961 22.9392 6.33856 23.0969 7.51098C23.25 8.65019 23.25 10.1058 23.25 11.9436V12.0564C23.25 13.8942 23.25 15.3498 23.0969 16.489C22.9392 17.6614 22.6071 18.6104 21.8588 19.3588C21.1104 20.1071 20.1614 20.4392 18.989 20.5969C17.8498 20.75 16.3942 20.75 14.5564 20.75H10.4436C8.60583 20.75 7.15019 20.75 6.01098 20.5969C4.83856 20.4392 3.88961 20.1071 3.14124 19.3588C2.39288 18.6104 2.06076 17.6614 1.90314 16.489C1.74997 15.3498 1.74998 13.8942 1.75 12.0564V11.9436C1.74998 10.1058 1.74997 8.65019 1.90314 7.51098C2.06076 6.33856 2.39288 5.38961 3.14124 4.64124C3.88961 3.89288 4.83856 3.56076 6.01098 3.40314C7.15019 3.24997 8.60582 3.24998 10.4436 3.25ZM6.21085 4.88976C5.20476 5.02502 4.62511 5.27869 4.2019 5.7019C3.77869 6.12511 3.52502 6.70476 3.38976 7.71085C3.25159 8.73851 3.25 10.0932 3.25 12C3.25 13.9068 3.25159 15.2615 3.38976 16.2892C3.52502 17.2952 3.77869 17.8749 4.2019 18.2981C4.62511 18.7213 5.20476 18.975 6.21085 19.1102C7.23851 19.2484 8.59318 19.25 10.5 19.25H14.5C16.4068 19.25 17.7615 19.2484 18.7892 19.1102C19.7952 18.975 20.3749 18.7213 20.7981 18.2981C21.2213 17.8749 21.475 17.2952 21.6102 16.2892C21.7484 15.2615 21.75 13.9068 21.75 12C21.75 10.0932 21.7484 8.73851 21.6102 7.71085C21.475 6.70476 21.2213 6.12511 20.7981 5.7019C20.3749 5.27869 19.7952 5.02502 18.7892 4.88976C17.7615 4.75159 16.4068 4.75 14.5 4.75H10.5C8.59318 4.75 7.23851 4.75159 6.21085 4.88976ZM5.92383 7.51986C6.18901 7.20165 6.66193 7.15866 6.98014 7.42383L9.13903 9.22291C10.072 10.0004 10.7197 10.5384 11.2666 10.8901C11.7959 11.2306 12.1549 11.3449 12.5 11.3449C12.8451 11.3449 13.2041 11.2306 13.7334 10.8901C14.2803 10.5384 14.928 10.0004 15.861 9.22291L18.0199 7.42383C18.3381 7.15866 18.811 7.20165 19.0762 7.51986C19.3413 7.83807 19.2983 8.31099 18.9801 8.57617L16.7836 10.4066C15.8973 11.1452 15.1789 11.7439 14.5448 12.1517C13.8843 12.5765 13.2411 12.8449 12.5 12.8449C11.7589 12.8449 11.1157 12.5765 10.4552 12.1517C9.82112 11.7439 9.10272 11.1452 8.21636 10.4066L6.01986 8.57617C5.70165 8.31099 5.65866 7.83807 5.92383 7.51986Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ArrowIcon = ({ color }: { color?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2703_2922)">
        <path
          d="M14.94 8.69997C14.9 8.65997 14.88 8.61997 14.88 8.57997L14.76 8.45997L10.26 3.95997C10.14 3.79997 9.98 3.71997 9.78 3.71997C9.58 3.71997 9.4 3.79997 9.24 3.95997C9.08 4.11997 9 4.29997 9 4.49997C9 4.69997 9.08 4.87997 9.24 5.03997L12.48 8.21997H0.78C0.54 8.21997 0.35 8.28997 0.21 8.42997C0.07 8.56997 0 8.75997 0 8.99997C0 9.23997 0.07 9.41997 0.21 9.53997C0.35 9.65997 0.54 9.71997 0.78 9.71997H12.48L9.24 12.96C9.08 13.12 9 13.3 9 13.5C9 13.7 9.07 13.87 9.21 14.01C9.35 14.15 9.53 14.22 9.75 14.22C9.97 14.22 10.14 14.16 10.26 14.04L14.76 9.53997C14.88 9.41997 14.94 9.33997 14.94 9.29997C14.98 9.09997 14.98 8.89997 14.94 8.69997Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2703_2922">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="matrix(1 0 0 -1 0 18)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const LogoSappIcon = () => {
  return (
    <svg
      width="36"
      height="45"
      viewBox="0 0 36 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.1303 35.2298C28.7336 33.2054 31.7194 30.4893 34.9069 26.8657C34.9069 26.8657 36.2742 29.6317 34.8188 31.1585C32.5671 33.4542 30.1646 35.5744 27.6297 37.5029C25.0823 39.4124 22.4105 41.1244 19.6346 42.6259C17.803 43.5806 15.8242 41.2782 15.8242 41.2782C20.083 39.2765 23.4758 37.1759 26.1303 35.2298Z"
        fill="white"
      />
      <path
        d="M28.3304 38.3655C30.1496 36.9519 32.2368 35.0519 34.4648 32.5225C34.4648 32.5225 35.4207 34.4554 34.404 35.5231C32.8308 37.1272 31.1526 38.6094 29.3823 39.9582C27.6011 41.2924 25.7334 42.4892 23.7932 43.5394C22.5131 44.2067 21.1299 42.597 21.1299 42.597C24.1024 41.1947 26.475 39.7264 28.3304 38.3655Z"
        fill="white"
      />
      <path
        d="M31.0126 42.5977C31.7782 42.0191 32.3931 41.3726 32.7807 40.7873L32.8433 40.7393L32.549 45L28.6973 43.8691L28.8259 43.7748C29.4734 43.576 30.247 43.1726 31.0126 42.5977Z"
        fill="white"
      />
      <path
        d="M9.58622 20.4677C9.7492 23.5683 10.765 27.2833 11.668 30.1295C10.6989 30.4895 9.77828 30.7892 8.89198 31.1002C6.32384 31.9926 4.63319 32.4629 3.37775 33.41C3.19098 33.5505 2.70554 33.8737 2.55489 34.0217C1.35407 30.8825 0.495972 26.0883 0.221978 21.0313C-0.112805 14.4908 0.236955 9.17085 1.92937 5.7866C2.65709 4.33527 11.8037 -0.645453 12.15 0.0698482C13.4486 2.75293 9.13866 11.9604 9.58622 20.4677Z"
        fill="url(#paint0_linear_10824_34983)"
      />
      <path
        d="M11.9427 7.6669C12.6845 4.4881 13.14 1.93318 12.836 0.236816C15.9848 0.794733 20.359 2.71728 24.5534 5.17419C27.6907 7.02417 30.954 9.0485 32.9979 10.923C32.8605 11.005 32.4349 11.2792 32.2931 11.3867C31.0377 12.3347 29.8457 13.9859 28.1991 16.2741C27.6044 17.1025 26.9374 18.174 26.2608 19.0712C24.4988 17.3155 22.173 15.2214 20.0356 13.9642C17.4631 12.4535 14.0897 11.3094 11.3242 10.6186C11.5533 9.54139 11.7154 8.64137 11.9427 7.6669Z"
        fill="url(#paint1_linear_10824_34983)"
      />
      <path
        d="M2.73682 34.8701C4.17639 32.2709 13.7591 31.3021 20.2689 26.3883C26.7787 21.4745 30.841 12.1388 33.6091 11.5583C34.3483 11.4037 36.3913 22.1615 35.779 23.6751C34.3509 27.1969 30.6727 30.797 25.6756 34.5874C20.6671 38.3571 16.2656 40.8593 12.6843 41.1175C11.146 41.2249 2.3527 35.5638 2.73682 34.8701Z"
        fill="url(#paint2_linear_10824_34983)"
      />
      <path
        d="M25.2785 19.5583C25.3833 20.334 21.9941 24.0735 19.7924 25.5804C17.5503 27.1147 13.2994 29.5556 12.392 29.0109C11.7999 28.6575 10.3454 22.5147 10.2423 20.0691C10.141 17.6386 10.6511 12.0679 11.4026 11.6014C11.9426 11.2659 16.6516 12.8351 19.2013 14.3448C21.6267 15.782 25.1128 18.3351 25.2785 19.5583Z"
        fill="url(#paint3_linear_10824_34983)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10824_34983"
          x1="6.2516"
          y1="0.000108707"
          x2="6.2516"
          y2="34.0255"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFD316" />
          <stop offset="1" stop-color="#F9A31F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10824_34983"
          x1="28.0942"
          y1="17.1175"
          x2="11.5301"
          y2="1.63382"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFD316" />
          <stop offset="1" stop-color="#F9A31F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10824_34983"
          x1="8.59112"
          y1="41.3324"
          x2="36.8309"
          y2="14.933"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFD316" />
          <stop offset="1" stop-color="#F9A31F" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10824_34983"
          x1="10.2264"
          y1="20.3226"
          x2="25.2811"
          y2="20.3226"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFD316" />
          <stop offset="1" stop-color="#F9A31F" />
        </linearGradient>
      </defs>
    </svg>
  )
}
export const CollapseArrowIcon = ({
  selected,
  className,
}: {
  selected?: boolean
  className?: string
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className, {
        '-rotate-180': selected,
      })}
    >
      <path
        d="M11.9999 17.1999C11.8683 17.2007 11.7379 17.1754 11.616 17.1257C11.4942 17.0759 11.3834 17.0026 11.2899 16.9099L5.28994 10.9099C5.1967 10.8167 5.12274 10.706 5.07228 10.5841C5.02182 10.4623 4.99585 10.3318 4.99585 10.1999C4.99585 9.93359 5.10164 9.6782 5.28994 9.48989C5.47825 9.30159 5.73364 9.1958 5.99994 9.1958C6.26624 9.1958 6.52164 9.30159 6.70994 9.48989L11.9999 14.7799L17.2899 9.48989C17.3832 9.39665 17.4939 9.32269 17.6157 9.27223C17.7375 9.22177 17.8681 9.1958 17.9999 9.1958C18.1318 9.1958 18.2624 9.22177 18.3842 9.27223C18.506 9.32269 18.6167 9.39665 18.7099 9.48989C18.8032 9.58313 18.8771 9.69382 18.9276 9.81564C18.9781 9.93747 19.004 10.068 19.004 10.1999C19.004 10.3318 18.9781 10.4623 18.9276 10.5841C18.8771 10.706 18.8032 10.8167 18.7099 10.9099L12.7099 16.9099C12.6165 17.0026 12.5057 17.0759 12.3838 17.1257C12.262 17.1754 12.1315 17.2007 11.9999 17.1999Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const ArrowCollapseIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="arrows">
        <g id="to-ight">
          <path
            id="Vector"
            d="M10.0001 3.99999L3.48012 0.279993C3.21538 0.127143 2.91504 0.0467387 2.60934 0.0468752C2.30364 0.0470117 2.00337 0.127684 1.73877 0.28077C1.47416 0.433856 1.25456 0.653953 1.10207 0.9189C0.949573 1.18385 0.869572 1.48429 0.87012 1.78999V10.21C0.869572 10.5157 0.949573 10.8161 1.10207 11.0811C1.25456 11.346 1.47416 11.5661 1.73877 11.7192C2.00337 11.8723 2.30364 11.953 2.60934 11.9531C2.91504 11.9532 3.21538 11.8728 3.48012 11.72L10.0001 7.99999C10.3645 7.80825 10.6696 7.52061 10.8824 7.16814C11.0952 6.81566 11.2077 6.41174 11.2077 5.99999C11.2077 5.58825 11.0952 5.18433 10.8824 4.83185C10.6696 4.47937 10.3645 4.19173 10.0001 3.99999Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export const LockClosedIcon = ({ className }: IIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 10.0546V8C5.25 4.27208 8.27208 1.25 12 1.25C15.7279 1.25 18.75 4.27208 18.75 8V10.0546C19.8648 10.1379 20.5907 10.348 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.40931 10.348 4.13525 10.1379 5.25 10.0546ZM6.75 8C6.75 5.10051 9.10051 2.75 12 2.75C14.8995 2.75 17.25 5.10051 17.25 8V10.0036C16.867 10 16.4515 10 16 10H8C7.54849 10 7.13301 10 6.75 10.0036V8Z"
        fill="#F80903"
      />
    </svg>
  )
}

export const InfoIcon = ({
  bgColor = '#000',
  color = '#000',
  width = '16',
  height = '16',
}: {
  bgColor?: string
  color?: string
  width?: string
  height?: string
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 14 15`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M6.99967 14.1666C10.6816 14.1666 13.6663 11.1818 13.6663 7.49992C13.6663 3.81802 10.6816 0.833252 6.99967 0.833252C3.31778 0.833252 0.333008 3.81802 0.333008 7.49992C0.333008 11.1818 3.31778 14.1666 6.99967 14.1666Z"
        fill={bgColor}
      />
      <path
        d="M6.99967 6.56665C7.17649 6.56665 7.34605 6.63689 7.47108 6.76191C7.5961 6.88694 7.66634 7.05651 7.66634 7.23332V10.34C7.66634 10.5168 7.5961 10.6864 7.47108 10.8114C7.34605 10.9364 7.17649 11.0067 6.99967 11.0067C6.82286 11.0067 6.65329 10.9364 6.52827 10.8114C6.40325 10.6864 6.33301 10.5168 6.33301 10.34V7.23332C6.33301 7.05651 6.40325 6.88694 6.52827 6.76191C6.65329 6.63689 6.82286 6.56665 6.99967 6.56665Z"
        fill={color}
      />
      <path
        d="M6.99935 5.65983C7.45959 5.65983 7.83268 5.28673 7.83268 4.8265C7.83268 4.36626 7.45959 3.99316 6.99935 3.99316C6.53911 3.99316 6.16602 4.36626 6.16602 4.8265C6.16602 5.28673 6.53911 5.65983 6.99935 5.65983Z"
        fill={color}
      />
    </svg>
  )
}
export const CheckIcon = ({
  width = '68',
  height = '68',
  color = '#07AF17',
}: {
  width?: string
  height?: string
  color?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 68 68"
      fill="none"
    >
      <path
        d="M31.167 46.4667L17.8503 33.15L21.817 29.1834L31.167 38.5334L54.967 14.7334C49.5837 9.35002 42.217 5.66669 34.0003 5.66669C18.417 5.66669 5.66699 18.4167 5.66699 34C5.66699 49.5834 18.417 62.3334 34.0003 62.3334C49.5837 62.3334 62.3337 49.5834 62.3337 34C62.3337 28.6167 60.917 23.8 58.367 19.55L31.167 46.4667Z"
        fill={color}
      />
    </svg>
  )
}
export const ActionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M11.2998 18.2998C11.2998 17.902 11.4578 17.5204 11.7391 17.2391C12.0204 16.9578 12.402 16.7998 12.7998 16.7998C13.1976 16.7998 13.5792 16.9578 13.8605 17.2391C14.1418 17.5204 14.2998 17.902 14.2998 18.2998C14.2998 18.6976 14.1418 19.0792 13.8605 19.3605C13.5792 19.6418 13.1976 19.7998 12.7998 19.7998C12.402 19.7998 12.0204 19.6418 11.7391 19.3605C11.4578 19.0792 11.2998 18.6976 11.2998 18.2998ZM11.2998 12.2998C11.2998 11.902 11.4578 11.5204 11.7391 11.2391C12.0204 10.9578 12.402 10.7998 12.7998 10.7998C13.1976 10.7998 13.5792 10.9578 13.8605 11.2391C14.1418 11.5204 14.2998 11.902 14.2998 12.2998C14.2998 12.6976 14.1418 13.0792 13.8605 13.3605C13.5792 13.6418 13.1976 13.7998 12.7998 13.7998C12.402 13.7998 12.0204 13.6418 11.7391 13.3605C11.4578 13.0792 11.2998 12.6976 11.2998 12.2998ZM11.2998 6.2998C11.2998 5.90198 11.4578 5.52045 11.7391 5.23914C12.0204 4.95784 12.402 4.7998 12.7998 4.7998C13.1976 4.7998 13.5792 4.95784 13.8605 5.23914C14.1418 5.52045 14.2998 5.90198 14.2998 6.2998C14.2998 6.69763 14.1418 7.07916 13.8605 7.36046C13.5792 7.64177 13.1976 7.7998 12.7998 7.7998C12.402 7.7998 12.0204 7.64177 11.7391 7.36046C11.4578 7.07916 11.2998 6.69763 11.2998 6.2998Z"
        fill="#99A1B7"
      />
    </svg>
  )
}

export const CalculatorIconV2 = ({
  isActive = false,
  className,
}: {
  isActive?: boolean
  className?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9209 1.66699H16.0739C19.1518 1.66698 21.5638 1.66696 23.4458 1.91999C25.3721 2.17897 26.8921 2.71943 28.0852 3.91251C29.2783 5.10559 29.8187 6.62562 30.0777 8.55193C30.3308 10.4339 30.3307 12.846 30.3307 15.9238V16.0768C30.3307 19.1547 30.3308 21.5667 30.0777 23.4487C29.8187 25.375 29.2783 26.8951 28.0852 28.0881C26.8921 29.2812 25.3721 29.8217 23.4458 30.0807C21.5638 30.3337 19.1518 30.3337 16.0739 30.3337H15.9209C12.843 30.3337 10.431 30.3337 8.549 30.0807C6.62269 29.8217 5.10266 29.2812 3.90958 28.0881C2.7165 26.8951 2.17604 25.375 1.91706 23.4487C1.66403 21.5667 1.66405 19.1547 1.66406 16.0768V15.9238C1.66405 12.846 1.66403 10.4339 1.91706 8.55193C2.17604 6.62562 2.7165 5.10559 3.90958 3.91251C5.10266 2.71943 6.62269 2.17897 8.549 1.91999C10.431 1.66696 12.843 1.66698 15.9209 1.66699ZM8.8155 3.90215C7.11096 4.13132 6.08333 4.56718 5.32379 5.32672C4.56425 6.08626 4.12839 7.11389 3.89922 8.81843C3.66619 10.5517 3.66406 12.8294 3.66406 16.0003C3.66406 19.1713 3.66619 21.4489 3.89922 23.1822C4.12839 24.8868 4.56425 25.9144 5.32379 26.6739C6.08333 27.4335 7.11096 27.8693 8.8155 28.0985C10.5488 28.3315 12.8264 28.3337 15.9974 28.3337C19.1684 28.3337 21.446 28.3315 23.1793 28.0985C24.8838 27.8693 25.9115 27.4335 26.671 26.6739C27.4305 25.9144 27.8664 24.8868 28.0956 23.1822C28.3286 21.4489 28.3307 19.1713 28.3307 16.0003C28.3307 12.8294 28.3286 10.5517 28.0956 8.81843C27.8664 7.11389 27.4305 6.08626 26.671 5.32672C25.9115 4.56718 24.8838 4.13132 23.1793 3.90215C21.446 3.66912 19.1684 3.66699 15.9974 3.66699C12.8264 3.66699 10.5488 3.66912 8.8155 3.90215Z"
        fill={isActive ? '#FFF' : '#FFB800'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6641 7.66696C11.2163 7.66696 11.6641 8.11468 11.6641 8.66696L11.6641 10.3336H13.3307C13.883 10.3336 14.3307 10.7814 14.3307 11.3336C14.3307 11.8859 13.883 12.3336 13.3307 12.3336H11.6641V14.0003C11.6641 14.5526 11.2163 15.0003 10.6641 15.0003C10.1118 15.0003 9.66406 14.5526 9.66406 14.0003V12.3336H7.9974C7.44511 12.3336 6.9974 11.8859 6.9974 11.3336C6.9974 10.7814 7.44511 10.3336 7.9974 10.3336H9.66406L9.66406 8.66696C9.66406 8.11468 10.1118 7.66696 10.6641 7.66696ZM17.6641 11.3336C17.6641 10.7813 18.1118 10.3336 18.6641 10.3336H23.9974C24.5497 10.3336 24.9974 10.7813 24.9974 11.3336C24.9974 11.8859 24.5497 12.3336 23.9974 12.3336H18.6641C18.1118 12.3336 17.6641 11.8859 17.6641 11.3336ZM17.6641 19.3336C17.6641 18.7813 18.1118 18.3336 18.6641 18.3336H23.9974C24.5497 18.3336 24.9974 18.7813 24.9974 19.3336C24.9974 19.8859 24.5497 20.3336 23.9974 20.3336H18.6641C18.1118 20.3336 17.6641 19.8859 17.6641 19.3336ZM7.95696 18.6266C8.34748 18.236 8.98065 18.236 9.37117 18.6266L10.6641 19.9195L11.957 18.6266C12.3475 18.236 12.9806 18.236 13.3712 18.6266C13.7617 19.0171 13.7617 19.6503 13.3712 20.0408L12.0783 21.3337L13.3712 22.6265C13.7617 23.0171 13.7617 23.6502 13.3712 24.0408C12.9806 24.4313 12.3475 24.4313 11.9569 24.0407L10.6641 22.7479L9.37119 24.0408C8.98066 24.4313 8.3475 24.4313 7.95697 24.0408C7.56645 23.6502 7.56645 23.0171 7.95697 22.6266L9.24986 21.3337L7.95696 20.0408C7.56643 19.6502 7.56643 19.0171 7.95696 18.6266ZM17.6641 23.3336C17.6641 22.7813 18.1118 22.3336 18.6641 22.3336H23.9974C24.5497 22.3336 24.9974 22.7813 24.9974 23.3336C24.9974 23.8859 24.5497 24.3336 23.9974 24.3336H18.6641C18.1118 24.3336 17.6641 23.8859 17.6641 23.3336Z"
        fill={isActive ? '#FFF' : '#FFB800'}
      />
    </svg>
  )
}

export const ScratchPadIconV2 = ({
  isActive = false,
  className,
}: {
  isActive?: boolean
  className?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5914 1.66699H17.4086C19.8589 1.66697 21.7997 1.66695 23.3187 1.87117C24.8819 2.08134 26.1472 2.52417 27.145 3.52198C27.5355 3.91251 27.5355 4.54567 27.145 4.9362C26.7545 5.32672 26.1213 5.32672 25.7308 4.9362C25.1665 4.37192 24.3937 4.03369 23.0522 3.85334C21.682 3.66912 19.8758 3.66699 17.3333 3.66699H14.6667C12.1242 3.66699 10.318 3.66912 8.9478 3.85334C7.60635 4.03369 6.83348 4.37192 6.2692 4.9362C5.70493 5.50048 5.3667 6.27334 5.18635 7.61479C5.00212 8.98501 5 10.7912 5 13.3337V18.667C5 21.2094 5.00212 23.0156 5.18635 24.3859C5.3667 25.7273 5.70493 26.5002 6.26921 27.0645C6.83348 27.6287 7.60635 27.967 8.9478 28.1473C10.318 28.3315 12.1242 28.3337 14.6667 28.3337H17.3333C19.8758 28.3337 21.682 28.3315 23.0522 28.1473C24.3937 27.967 25.1665 27.6287 25.7308 27.0645C26.6587 26.1365 26.9397 24.6947 26.9885 21.3192C26.9965 20.767 27.4506 20.3258 28.0029 20.3338C28.5551 20.3418 28.9963 20.7959 28.9883 21.3481C28.9415 24.5848 28.732 26.8917 27.145 28.4787C26.1472 29.4765 24.8819 29.9193 23.3187 30.1295C21.7997 30.3337 19.8589 30.3337 17.4085 30.3337H14.5915C12.1411 30.3337 10.2003 30.3337 8.6813 30.1295C7.11807 29.9193 5.85281 29.4765 4.85499 28.4787C3.85717 27.4809 3.41435 26.2156 3.20418 24.6524C2.99996 23.1334 2.99998 21.1926 3 18.7422V13.2584C2.99998 10.8081 2.99996 8.86725 3.20418 7.3483C3.41435 5.78507 3.85717 4.5198 4.85499 3.52198C5.85281 2.52417 7.11807 2.08134 8.6813 1.87117C10.2003 1.66695 12.1411 1.66697 14.5914 1.66699ZM24.1509 9.3944C25.5652 7.98008 27.8583 7.98008 29.2726 9.3944C30.6869 10.8087 30.6869 13.1018 29.2726 14.5161L22.9322 20.8566C22.5872 21.2016 22.3539 21.435 22.0925 21.6389C21.785 21.8787 21.4522 22.0844 21.1002 22.2522C20.801 22.3948 20.4878 22.4991 20.025 22.6533L17.2468 23.5794C16.6334 23.7838 15.9572 23.6242 15.5 23.167C15.0428 22.7098 14.8832 22.0336 15.0876 21.4202L15.995 18.698C16.0013 18.6791 16.0075 18.6605 16.0137 18.6421C16.1679 18.1792 16.2722 17.866 16.4148 17.5668C16.5826 17.2147 16.7882 16.882 17.0281 16.5745C17.232 16.3132 17.4654 16.0798 17.8104 15.7349C17.8241 15.7212 17.838 15.7072 17.8521 15.6932L24.1509 9.3944ZM27.8584 10.8086C27.2251 10.1753 26.1983 10.1753 25.5651 10.8086L25.3227 11.051C25.3358 11.0956 25.3509 11.1431 25.3682 11.193C25.4937 11.5545 25.7317 12.0327 26.183 12.484C26.6343 12.9353 27.1125 13.1733 27.474 13.2987C27.5239 13.3161 27.5714 13.3312 27.616 13.3443L27.8584 13.1019C28.4917 12.4686 28.4917 11.4419 27.8584 10.8086ZM26.0886 14.8717C25.6647 14.6491 25.2071 14.3365 24.7688 13.8982C24.3305 13.4599 24.0179 13.0023 23.7953 12.5784L19.2663 17.1074C18.8649 17.5088 18.724 17.6521 18.6051 17.8046C18.4546 17.9975 18.3256 18.2063 18.2203 18.4272C18.1371 18.6018 18.0719 18.7918 17.8924 19.3304L17.3587 20.9316L17.7354 21.3083L19.3366 20.7746C19.8752 20.5951 20.0652 20.5299 20.2398 20.4467C20.4607 20.3414 20.6695 20.2124 20.8624 20.0619C21.0149 19.943 21.1582 19.8021 21.5596 19.4007L26.0886 14.8717ZM9.66667 12.0003C9.66667 11.448 10.1144 11.0003 10.6667 11.0003H19.3333C19.8856 11.0003 20.3333 11.448 20.3333 12.0003C20.3333 12.5526 19.8856 13.0003 19.3333 13.0003H10.6667C10.1144 13.0003 9.66667 12.5526 9.66667 12.0003ZM9.66667 17.3337C9.66667 16.7814 10.1144 16.3337 10.6667 16.3337H14C14.5523 16.3337 15 16.7814 15 17.3337C15 17.8859 14.5523 18.3337 14 18.3337H10.6667C10.1144 18.3337 9.66667 17.8859 9.66667 17.3337ZM9.66667 22.667C9.66667 22.1147 10.1144 21.667 10.6667 21.667H12.6667C13.219 21.667 13.6667 22.1147 13.6667 22.667C13.6667 23.2193 13.219 23.667 12.6667 23.667H10.6667C10.1144 23.667 9.66667 23.2193 9.66667 22.667Z"
        fill={isActive ? '#FFF' : '#FFB800'}
      />
    </svg>
  )
}

export const ResizeIcon = () => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M10.5303 9.53033C10.8232 9.23744 10.8232 8.76256 10.5303 8.46967C10.2374 8.17678 9.76256 8.17678 9.46967 8.46967L10.5303 9.53033ZM7 12L6.46967 11.4697C6.17678 11.7626 6.17678 12.2374 6.46967 12.5303L7 12ZM9.46967 15.5303C9.76256 15.8232 10.2374 15.8232 10.5303 15.5303C10.8232 15.2374 10.8232 14.7626 10.5303 14.4697L9.46967 15.5303ZM13.4697 14.4697C13.1768 14.7626 13.1768 15.2374 13.4697 15.5303C13.7626 15.8232 14.2374 15.8232 14.5303 15.5303L13.4697 14.4697ZM17 12L17.5303 12.5303C17.8232 12.2374 17.8232 11.7626 17.5303 11.4697L17 12ZM14.5303 8.46967C14.2374 8.17678 13.7626 8.17678 13.4697 8.46967C13.1768 8.76256 13.1768 9.23744 13.4697 9.53033L14.5303 8.46967ZM9.46967 8.46967L6.46967 11.4697L7.53033 12.5303L10.5303 9.53033L9.46967 8.46967ZM6.46967 12.5303L9.46967 15.5303L10.5303 14.4697L7.53033 11.4697L6.46967 12.5303ZM14.5303 15.5303L17.5303 12.5303L16.4697 11.4697L13.4697 14.4697L14.5303 15.5303ZM17.5303 11.4697L14.5303 8.46967L13.4697 9.53033L16.4697 12.5303L17.5303 11.4697ZM20.25 12C20.25 16.5563 16.5563 20.25 12 20.25V21.75C17.3848 21.75 21.75 17.3848 21.75 12H20.25ZM12 20.25C7.44365 20.25 3.75 16.5563 3.75 12H2.25C2.25 17.3848 6.61522 21.75 12 21.75V20.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75V2.25C6.61522 2.25 2.25 6.61522 2.25 12H3.75ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3.75Z"
          fill="#9ca3af"
        ></path>{' '}
      </g>
    </svg>
  )
}

export const PreviousIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 1.75C5.89137 1.75 1.75 5.89137 1.75 11C1.75 16.1086 5.89137 20.25 11 20.25C16.1086 20.25 20.25 16.1086 20.25 11C20.25 5.89137 16.1086 1.75 11 1.75ZM0.25 11C0.25 5.06294 5.06294 0.25 11 0.25C16.9371 0.25 21.75 5.06294 21.75 11C21.75 16.9371 16.9371 21.75 11 21.75C5.06294 21.75 0.25 16.9371 0.25 11ZM13.0303 7.46967C13.3232 7.76256 13.3232 8.23744 13.0303 8.53033L10.5607 11L13.0303 13.4697C13.3232 13.7626 13.3232 14.2374 13.0303 14.5303C12.7374 14.8232 12.2626 14.8232 11.9697 14.5303L8.96967 11.5303C8.67678 11.2374 8.67678 10.7626 8.96967 10.4697L11.9697 7.46967C12.2626 7.17678 12.7374 7.17678 13.0303 7.46967Z"
        fill="#1C274C"
      />
    </svg>
  )
}

export const NextIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM9.96967 8.46967C10.2626 8.17678 10.7374 8.17678 11.0303 8.46967L14.0303 11.4697C14.3232 11.7626 14.3232 12.2374 14.0303 12.5303L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303C9.67678 15.2374 9.67678 14.7626 9.96967 14.4697L12.4393 12L9.96967 9.53033C9.67678 9.23744 9.67678 8.76256 9.96967 8.46967Z"
        fill="#1C274C"
      />
    </svg>
  )
}

export const DownloadMinimalistic = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5535 14.5061C10.4114 14.6615 10.2106 14.75 10 14.75C9.78943 14.75 9.58857 14.6615 9.44648 14.5061L5.44648 10.1311C5.16698 9.82538 5.18822 9.35098 5.49392 9.07148C5.79963 8.79198 6.27402 8.81322 6.55352 9.11892L9.25 12.0682V1C9.25 0.585787 9.58579 0.25 10 0.25C10.4142 0.25 10.75 0.585787 10.75 1V12.0682L13.4465 9.11892C13.726 8.81322 14.2004 8.79198 14.5061 9.07148C14.8118 9.35098 14.833 9.82537 14.5535 10.1311L10.5535 14.5061Z"
      fill="currentColor"
    />
    <path
      d="M1.75 13C1.75 12.5858 1.41422 12.25 1 12.25C0.585788 12.25 0.250001 12.5858 0.250001 13V13.0549C0.24998 14.4225 0.249964 15.5248 0.366524 16.3918C0.487541 17.2919 0.746434 18.0497 1.34835 18.6516C1.95027 19.2536 2.70814 19.5125 3.60825 19.6335C4.47522 19.75 5.57754 19.75 6.94513 19.75H13.0549C14.4225 19.75 15.5248 19.75 16.3918 19.6335C17.2919 19.5125 18.0497 19.2536 18.6517 18.6516C19.2536 18.0497 19.5125 17.2919 19.6335 16.3918C19.75 15.5248 19.75 14.4225 19.75 13.0549V13C19.75 12.5858 19.4142 12.25 19 12.25C18.5858 12.25 18.25 12.5858 18.25 13C18.25 14.4354 18.2484 15.4365 18.1469 16.1919C18.0482 16.9257 17.8678 17.3142 17.591 17.591C17.3142 17.8678 16.9257 18.0482 16.1919 18.1469C15.4365 18.2484 14.4354 18.25 13 18.25H7C5.56459 18.25 4.56347 18.2484 3.80812 18.1469C3.07435 18.0482 2.68577 17.8678 2.40901 17.591C2.13225 17.3142 1.9518 16.9257 1.85315 16.1919C1.75159 15.4365 1.75 14.4354 1.75 13Z"
      fill="currentColor"
    />
  </svg>
)

export const CloseNone = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 18L6 6"
      stroke="#404041"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 18L18 6"
      stroke="#404041"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const ShowMoreIcon = ({
  size = 20,
  color = '#1C274C',
}: {
  size?: number
  color?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.5303 9.96967C15.8232 10.2626 15.8232 10.7374 15.5303 11.0303L12.5303 14.0303C12.3897 14.171 12.1989 14.25 12 14.25C11.8011 14.25 11.6103 14.171 11.4697 14.0303L8.46967 11.0303C8.17678 10.7374 8.17678 10.2626 8.46967 9.96967C8.76256 9.67678 9.23744 9.67678 9.53033 9.96967L12 12.4393L14.4697 9.96967C14.7626 9.67678 15.2374 9.67678 15.5303 9.96967Z"
        fill={color}
      />
    </svg>
  )
}

export const OutlineText = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.29315 5.20817C7.93493 5.20811 7.60004 5.20806 7.32644 5.24893C7.01736 5.2951 6.69983 5.40425 6.44602 5.68626C6.2007 5.95885 6.11408 6.28368 6.07654 6.59395C6.04145 6.88397 6.04147 7.24349 6.0415 7.64946L6.0415 8.12484C6.0415 8.47002 6.32133 8.74984 6.6665 8.74984C7.01168 8.74984 7.2915 8.47002 7.2915 8.12484V7.68502C7.2915 7.23259 7.29258 6.94993 7.31749 6.74411C7.32917 6.64755 7.34378 6.5919 7.35559 6.56002C7.36555 6.53311 7.37266 6.52522 7.37503 6.5226L7.3757 6.52182C7.37684 6.52045 7.37767 6.51944 7.38519 6.51601C7.39904 6.50968 7.43457 6.49665 7.51112 6.48521C7.68121 6.4598 7.92076 6.45817 8.33317 6.45817H9.37484V13.5415H7.9165C7.57133 13.5415 7.2915 13.8213 7.2915 14.1665C7.2915 14.5117 7.57133 14.7915 7.9165 14.7915H12.4998C12.845 14.7915 13.1248 14.5117 13.1248 14.1665C13.1248 13.8213 12.845 13.5415 12.4998 13.5415H10.6248V6.45817H11.6665C12.0789 6.45817 12.3185 6.4598 12.4886 6.48521C12.5651 6.49665 12.6006 6.50968 12.6145 6.51601C12.622 6.51944 12.6228 6.52045 12.624 6.52182L12.6245 6.52247C12.6269 6.52509 12.6341 6.53311 12.6441 6.56002C12.6559 6.5919 12.6705 6.64755 12.6822 6.74411C12.7071 6.94993 12.7082 7.23259 12.7082 7.68502V8.12484C12.7082 8.47002 12.988 8.74984 13.3332 8.74984C13.6783 8.74984 13.9582 8.47002 13.9582 8.12484L13.9582 7.64945C13.9582 7.24349 13.9582 6.88397 13.9231 6.59395C13.8856 6.28368 13.799 5.95885 13.5537 5.68626C13.2998 5.40425 12.9823 5.2951 12.6732 5.24893C12.3996 5.20806 12.0647 5.20811 11.7065 5.20817H8.29315Z"
      fill="#1C274C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.95202 1.0415C8.02836 1.04149 6.52083 1.04148 5.34459 1.19963C4.14065 1.36149 3.19063 1.69928 2.44495 2.44495C1.69928 3.19063 1.36149 4.14065 1.19963 5.34459C1.04148 6.52083 1.04149 8.02836 1.0415 9.95202V10.0477C1.04149 11.9713 1.04148 13.4788 1.19963 14.6551C1.36149 15.859 1.69928 16.8091 2.44495 17.5547C3.19063 18.3004 4.14065 18.6382 5.34459 18.8C6.52083 18.9582 8.02836 18.9582 9.95203 18.9582H10.0476C11.9713 18.9582 13.4788 18.9582 14.6551 18.8C15.859 18.6382 16.8091 18.3004 17.5547 17.5547C18.3004 16.8091 18.6382 15.859 18.8 14.6551C18.9582 13.4788 18.9582 11.9713 18.9582 10.0476V9.95203C18.9582 8.02836 18.9582 6.52083 18.8 5.34459C18.6382 4.14065 18.3004 3.19063 17.5547 2.44495C16.8091 1.69928 15.859 1.36149 14.6551 1.19963C13.4788 1.04148 11.9713 1.04149 10.0477 1.0415H9.95202ZM3.32883 3.32883C3.80355 2.85412 4.44582 2.58171 5.51115 2.43848C6.59447 2.29283 8.01798 2.2915 9.99984 2.2915C11.9817 2.2915 13.4052 2.29283 14.4885 2.43848C15.5539 2.58171 16.1961 2.85412 16.6708 3.32883C17.1456 3.80355 17.418 4.44582 17.5612 5.51115C17.7068 6.59447 17.7082 8.01798 17.7082 9.99984C17.7082 11.9817 17.7068 13.4052 17.5612 14.4885C17.418 15.5539 17.1456 16.1961 16.6708 16.6708C16.1961 17.1456 15.5539 17.418 14.4885 17.5612C13.4052 17.7068 11.9817 17.7082 9.99984 17.7082C8.01798 17.7082 6.59447 17.7068 5.51115 17.5612C4.44582 17.418 3.80355 17.1456 3.32883 16.6708C2.85412 16.1961 2.58171 15.5539 2.43848 14.4885C2.29283 13.4052 2.2915 11.9817 2.2915 9.99984C2.2915 8.01798 2.29283 6.59447 2.43848 5.51115C2.58171 4.44582 2.85412 3.80355 3.32883 3.32883Z"
      fill="#1C274C"
    />
  </svg>
)

export const ShowLessIcon = ({
  size = 20,
  color = '#1C274C',
}: {
  size?: number
  color?: string
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 9.75C12.1989 9.75 12.3897 9.82902 12.5303 9.96967L15.5303 12.9697C15.8232 13.2626 15.8232 13.7374 15.5303 14.0303C15.2374 14.3232 14.7626 14.3232 14.4697 14.0303L12 11.5607L9.53033 14.0303C9.23744 14.3232 8.76256 14.3232 8.46967 14.0303C8.17678 13.7374 8.17678 13.2626 8.46967 12.9697L11.4697 9.96967C11.6103 9.82902 11.8011 9.75 12 9.75Z"
        fill={color}
      />
    </svg>
  )
}

export const SwitcherExpanded = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16C11.6066 16 11.2361 15.8024 11 15.4667L7.25001 10.1333C6.96593 9.72931 6.92023 9.18876 7.13197 8.73705C7.34371 8.28534 7.77654 8 8.25001 8H15.75C16.2235 8 16.6563 8.28534 16.868 8.73705C17.0798 9.18876 17.0341 9.72931 16.75 10.1333L13 15.4667C12.7639 15.8024 12.3934 16 12 16Z"
        fill="#FFB800"
      />
    </svg>
  )
}

export const SwitcherClosed = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.73705 7.13197C9.18876 6.92023 9.72931 6.96593 10.1333 7.25001L15.4667 11C15.8024 11.2361 16 11.6066 16 12C16 12.3934 15.8024 12.7639 15.4667 13L10.1333 16.75C9.72931 17.0341 9.18876 17.0798 8.73705 16.868C8.28534 16.6563 8 16.2235 8 15.75V8.25001C8 7.77654 8.28534 7.34371 8.73705 7.13197Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}
export const ClockIcon = ({ color = 'black', size = 24 }: IProps) => {
  return (
    <svg
      fill={'currentColor'}
      width={size}
      height={size}
      viewBox="0 0 256 256"
      id="Flat"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path d="M136,80v43.38116l37.56934,21.69062a8,8,0,1,1-8,13.85644l-41.56934-24c-.064-.03692-.12109-.0805-.18359-.11889-.13575-.08362-.271-.16779-.40088-.2591-.10352-.07232-.20215-.14892-.30127-.22534-.10205-.0788-.20362-.15765-.30127-.24115-.11182-.09479-.21778-.19342-.32276-.29333-.0791-.07532-.15771-.15064-.23388-.22913-.10694-.11017-.2085-.22351-.30811-.339-.06933-.08026-.13769-.16083-.2041-.24377-.0918-.1156-.1792-.23352-.26416-.35352-.06738-.09473-.1333-.19019-.19629-.2879-.07226-.11194-.14062-.22547-.207-.34058-.06592-.11438-.12988-.22986-.19043-.34778-.05322-.10418-.10352-.20941-.15186-.31561-.061-.13287-.11914-.26685-.17333-.4035-.03907-.09986-.0752-.20063-.11036-.30194-.0498-.14252-.09668-.28589-.13818-.432-.03027-.10687-.05664-.21454-.083-.32257-.0332-.13928-.06543-.27881-.09131-.42084-.02392-.12842-.0415-.25757-.05908-.38714-.0166-.12226-.0332-.244-.04394-.368-.01416-.16015-.01954-.3208-.02442-.48187C120.00879,128.14313,120,128.07269,120,128V80a8,8,0,0,1,16,0Zm91.228-27.67529a7.99962,7.99962,0,0,0-8.71826,1.73437L204.1665,68.40222l-8.28466-8.28454a95.9551,95.9551,0,1,0,0,135.76464,7.99983,7.99983,0,1,0-11.31348-11.31347,80.00009,80.00009,0,1,1,0-113.1377l8.28467,8.28467L178.50977,94.05908a7.99981,7.99981,0,0,0,5.65673,13.65674h40a7.99977,7.99977,0,0,0,8-8v-40A8.00014,8.00014,0,0,0,227.228,52.32471Z"></path>{' '}
      </g>
    </svg>
  )
}

export const AlertCircleSharp = () => (
  <svg
    width="68"
    height="68"
    viewBox="0 0 68 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34 6.375C18.7677 6.375 6.375 18.7677 6.375 34C6.375 49.2323 18.7677 61.625 34 61.625C49.2323 61.625 61.625 49.2323 61.625 34C61.625 18.7677 49.2323 6.375 34 6.375ZM36.6562 48.863H31.3438V43.5505H36.6562V48.863ZM36.125 40.375H31.875L31.0781 19.125H36.9219L36.125 40.375Z"
      fill="#FFB800"
    />
  </svg>
)
export const AlertInfoIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        opacity="0.3"
        d="M12.0007 23.6666C18.444 23.6666 23.6673 18.4432 23.6673 11.9999C23.6673 5.5566 18.444 0.333252 12.0007 0.333252C5.55733 0.333252 0.333984 5.5566 0.333984 11.9999C0.333984 18.4432 5.55733 23.6666 12.0007 23.6666Z"
        fill="currentColor"
      />
      <path
        d="M12.0007 10.3667C12.3101 10.3667 12.6068 10.4896 12.8256 10.7084C13.0444 10.9272 13.1673 11.2239 13.1673 11.5334V16.97C13.1673 17.2795 13.0444 17.5762 12.8256 17.795C12.6068 18.0138 12.3101 18.1367 12.0007 18.1367C11.6912 18.1367 11.3945 18.0138 11.1757 17.795C10.9569 17.5762 10.834 17.2795 10.834 16.97V11.5334C10.834 11.2239 10.9569 10.9272 11.1757 10.7084C11.3945 10.4896 11.6912 10.3667 12.0007 10.3667Z"
        fill="currentColor"
      />
      <path
        d="M12.0013 8.77995C12.8067 8.77995 13.4596 8.12703 13.4596 7.32161C13.4596 6.5162 12.8067 5.86328 12.0013 5.86328C11.1959 5.86328 10.543 6.5162 10.543 7.32161C10.543 8.12703 11.1959 8.77995 12.0013 8.77995Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const HourglassIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <path
        d="M3.89869 2.47439C4.35035 1.5 5.90023 1.5 9 1.5C12.0998 1.5 13.6497 1.5 14.1013 2.47439C14.1401 2.55814 14.1729 2.64514 14.1993 2.73457C14.5061 3.77497 13.4101 4.98083 11.2183 7.39256L9.75 9L11.2183 10.6074C13.4101 13.0192 14.5061 14.225 14.1993 15.2654C14.1729 15.3549 14.1401 15.4419 14.1013 15.5256C13.6497 16.5 12.0998 16.5 9 16.5C5.90023 16.5 4.35035 16.5 3.89869 15.5256C3.85986 15.4419 3.82711 15.3549 3.80074 15.2654C3.49392 14.225 4.58986 13.0192 6.78173 10.6074L8.25 9L6.78173 7.39256C4.58986 4.98083 3.49392 3.77497 3.80074 2.73457C3.82711 2.64514 3.85986 2.55814 3.89869 2.47439Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const StarCircleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.8613 9.36335L10.7302 9.59849C10.5862 9.85677 10.5142 9.98591 10.402 10.0711C10.2897 10.1563 10.1499 10.188 9.87035 10.2512L9.61581 10.3088C8.63195 10.5314 8.14001 10.6427 8.02297 11.0191C7.90593 11.3955 8.2413 11.7876 8.91204 12.572L9.08557 12.7749C9.27617 12.9978 9.37147 13.1092 9.41435 13.2471C9.45722 13.385 9.44281 13.5336 9.41399 13.831L9.38776 14.1018C9.28635 15.1482 9.23565 15.6715 9.54206 15.9041C9.84847 16.1367 10.3091 15.9246 11.2303 15.5005L11.4686 15.3907C11.7304 15.2702 11.8613 15.2099 12 15.2099C12.1387 15.2099 12.2696 15.2702 12.5314 15.3907L12.7697 15.5005C13.6909 15.9246 14.1515 16.1367 14.4579 15.9041C14.7644 15.6715 14.7136 15.1482 14.6122 14.1018L14.586 13.831C14.5572 13.5336 14.5428 13.385 14.5857 13.2471C14.6285 13.1092 14.7238 12.9978 14.9144 12.7749L15.088 12.572C15.7587 11.7876 16.0941 11.3955 15.977 11.0191C15.86 10.6427 15.3681 10.5314 14.3842 10.3088L14.1296 10.2512C13.8501 10.188 13.7103 10.1563 13.598 10.0711C13.4858 9.98592 13.4138 9.85678 13.2698 9.5985L13.1387 9.36335C12.6321 8.45445 12.3787 8 12 8C11.6213 8 11.3679 8.45446 10.8613 9.36335Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const TimeLineIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9426 1.75H12.0574C14.3658 1.74999 16.1748 1.74998 17.5863 1.93975C19.031 2.13399 20.1711 2.53933 21.0659 3.43414C21.9607 4.32895 22.366 5.46897 22.5603 6.91371C22.75 8.32519 22.75 10.1342 22.75 12.4426V12.5574C22.75 14.8658 22.75 16.6748 22.5603 18.0863C22.366 19.531 21.9607 20.6711 21.0659 21.5659C20.1711 22.4607 19.031 22.866 17.5863 23.0603C16.1748 23.25 14.3658 23.25 12.0574 23.25H11.9426C9.63423 23.25 7.82519 23.25 6.41371 23.0603C4.96897 22.866 3.82895 22.4607 2.93414 21.5659C2.03933 20.6711 1.63399 19.531 1.43975 18.0863C1.24998 16.6748 1.24999 14.8658 1.25 12.5574V12.4426C1.24999 10.1342 1.24998 8.32519 1.43975 6.91371C1.63399 5.46897 2.03933 4.32895 2.93414 3.43414C3.82895 2.53933 4.96897 2.13399 6.41371 1.93975C7.82519 1.74998 9.63423 1.74999 11.9426 1.75ZM6.61358 3.42637C5.33517 3.59825 4.56445 3.92514 3.9948 4.4948C3.42514 5.06445 3.09825 5.83517 2.92637 7.11358C2.75159 8.41356 2.75 10.1218 2.75 12.5C2.75 14.8782 2.75159 16.5864 2.92637 17.8864C3.09825 19.1648 3.42514 19.9355 3.9948 20.5052C4.56445 21.0749 5.33517 21.4018 6.61358 21.5736C7.91356 21.7484 9.62177 21.75 12 21.75C14.3782 21.75 16.0864 21.7484 17.3864 21.5736C18.6648 21.4018 19.4355 21.0749 20.0052 20.5052C20.5749 19.9355 20.9018 19.1648 21.0736 17.8864C21.2484 16.5864 21.25 14.8782 21.25 12.5C21.25 10.1218 21.2484 8.41356 21.0736 7.11358C20.9018 5.83517 20.5749 5.06445 20.0052 4.4948C19.4355 3.92514 18.6648 3.59825 17.3864 3.42637C16.0864 3.25159 14.3782 3.25 12 3.25C9.62177 3.25 7.91356 3.25159 6.61358 3.42637Z"
        fill="currentColor"
      />
      <path
        d="M6 8.5H18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8 12.5L16 12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10 16.5H14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const MaximumContentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.9425 1.25H12.0573C14.3657 1.24999 16.1747 1.24998 17.5862 1.43975C19.0309 1.63399 20.171 2.03933 21.0658 2.93414C21.9606 3.82895 22.3659 4.96897 22.5602 6.41371C22.7499 7.82519 22.7499 9.63423 22.7499 11.9426V12.0574C22.7499 14.3658 22.7499 16.1748 22.5602 17.5863C22.3659 19.031 21.9606 20.1711 21.0658 21.0659C20.2374 21.8943 19.198 22.3038 17.8993 22.514C16.6225 22.7207 15.0164 22.7458 13.0013 22.7494C12.5871 22.7502 12.2507 22.415 12.2499 22.0008C12.2492 21.5866 12.5843 21.2502 12.9986 21.2494C15.0385 21.2457 16.5216 21.2175 17.6596 21.0333C18.7756 20.8526 19.4765 20.5338 20.0051 20.0052C20.5748 19.4355 20.9017 18.6648 21.0735 17.3864C21.2483 16.0864 21.2499 14.3782 21.2499 12C21.2499 9.62178 21.2483 7.91356 21.0735 6.61358C20.9017 5.33517 20.5748 4.56445 20.0051 3.9948C19.4355 3.42514 18.6647 3.09825 17.3863 2.92637C16.0864 2.75159 14.3781 2.75 11.9999 2.75C9.62169 2.75 7.91347 2.75159 6.61349 2.92637C5.33509 3.09825 4.56437 3.42514 3.99471 3.9948C3.46609 4.52341 3.1473 5.22427 2.96665 6.34031C2.78246 7.47827 2.75416 8.96143 2.75049 11.0014C2.74974 11.4156 2.41335 11.7507 1.99914 11.75C1.58493 11.7493 1.24975 11.4129 1.25049 10.9986C1.25412 8.9835 1.27926 7.37741 1.48592 6.10063C1.69614 4.80193 2.10563 3.76255 2.93405 2.93414C3.82886 2.03933 4.96888 1.63399 6.41362 1.43975C7.82511 1.24998 9.63414 1.24999 11.9425 1.25Z"
        fill="currentColor"
      />
      <path
        d="M12.5 7C12.5 6.58579 12.8358 6.25 13.25 6.25H17C17.4142 6.25 17.75 6.58579 17.75 7V10.75C17.75 11.1642 17.4142 11.5 17 11.5C16.5858 11.5 16.25 11.1642 16.25 10.75V8.81066L12.5303 12.5303C12.2374 12.8232 11.7626 12.8232 11.4697 12.5303C11.1768 12.2374 11.1768 11.7626 11.4697 11.4697L15.1893 7.75H13.25C12.8358 7.75 12.5 7.41421 12.5 7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.948 13.25C5.04952 13.25 4.3003 13.2499 3.70552 13.3299C3.07773 13.4143 2.51093 13.6 2.05546 14.0555C1.59999 14.5109 1.41432 15.0777 1.32991 15.7055C1.24995 16.3003 1.24997 17.0495 1.25 17.948V18.052C1.24997 18.9505 1.24995 19.6997 1.32991 20.2945C1.41432 20.9223 1.59999 21.4891 2.05546 21.9445C2.51093 22.4 3.07773 22.5857 3.70552 22.6701C4.3003 22.7501 5.04951 22.75 5.94798 22.75H6.052C6.95047 22.75 7.69971 22.7501 8.29448 22.6701C8.92228 22.5857 9.48908 22.4 9.94455 21.9445C10.4 21.4891 10.5857 20.9223 10.6701 20.2945C10.7501 19.6997 10.75 18.9505 10.75 18.052V17.948C10.75 17.0495 10.7501 16.3003 10.6701 15.7055C10.5857 15.0777 10.4 14.5109 9.94455 14.0555C9.48908 13.6 8.92228 13.4143 8.29448 13.3299C7.6997 13.2499 6.95048 13.25 6.052 13.25H5.948ZM3.11612 15.1161C3.24644 14.9858 3.44393 14.8786 3.9054 14.8165C4.38843 14.7516 5.03599 14.75 6 14.75C6.96401 14.75 7.61157 14.7516 8.09461 14.8165C8.55607 14.8786 8.75357 14.9858 8.88389 15.1161C9.0142 15.2464 9.12143 15.4439 9.18347 15.9054C9.24841 16.3884 9.25 17.036 9.25 18C9.25 18.964 9.24841 19.6116 9.18347 20.0946C9.12143 20.5561 9.0142 20.7536 8.88389 20.8839C8.75357 21.0142 8.55607 21.1214 8.09461 21.1835C7.61157 21.2484 6.96401 21.25 6 21.25C5.03599 21.25 4.38843 21.2484 3.9054 21.1835C3.44393 21.1214 3.24644 21.0142 3.11612 20.8839C2.9858 20.7536 2.87858 20.5561 2.81654 20.0946C2.7516 19.6116 2.75 18.964 2.75 18C2.75 17.036 2.7516 16.3884 2.81654 15.9054C2.87858 15.4439 2.9858 15.2464 3.11612 15.1161Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const MinimumContentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.9425 1.25H12.0573C14.3657 1.24999 16.1747 1.24998 17.5862 1.43975C19.0309 1.63399 20.171 2.03933 21.0658 2.93414C21.9606 3.82895 22.3659 4.96897 22.5602 6.41371C22.7499 7.82519 22.7499 9.63423 22.7499 11.9426V12.0574C22.7499 14.3658 22.7499 16.1748 22.5602 17.5863C22.3659 19.031 21.9606 20.1711 21.0658 21.0659C20.2374 21.8943 19.198 22.3038 17.8993 22.514C16.6225 22.7207 15.0164 22.7458 13.0013 22.7494C12.5871 22.7502 12.2507 22.415 12.2499 22.0008C12.2492 21.5866 12.5843 21.2502 12.9986 21.2494C15.0385 21.2457 16.5216 21.2175 17.6596 21.0333C18.7756 20.8526 19.4765 20.5338 20.0051 20.0052C20.5748 19.4355 20.9017 18.6648 21.0735 17.3864C21.2483 16.0864 21.2499 14.3782 21.2499 12C21.2499 9.62178 21.2483 7.91356 21.0735 6.61358C20.9017 5.33517 20.5748 4.56445 20.0051 3.9948C19.4355 3.42514 18.6647 3.09825 17.3863 2.92637C16.0864 2.75159 14.3781 2.75 11.9999 2.75C9.62169 2.75 7.91347 2.75159 6.61349 2.92637C5.33509 3.09825 4.56437 3.42514 3.99471 3.9948C3.46609 4.52341 3.1473 5.22427 2.96665 6.34031C2.78246 7.47827 2.75416 8.96143 2.75049 11.0014C2.74974 11.4156 2.41335 11.7507 1.99914 11.75C1.58493 11.7493 1.24975 11.4129 1.25049 10.9986C1.25412 8.9835 1.27926 7.37741 1.48592 6.10063C1.69614 4.80193 2.10563 3.76255 2.93405 2.93414C3.82886 2.03933 4.96888 1.63399 6.41362 1.43975C7.82511 1.24998 9.63414 1.24999 11.9425 1.25Z"
        fill="currentColor"
      />
      <path
        d="M16.5 12C16.5 12.4142 16.1642 12.75 15.75 12.75H12C11.5858 12.75 11.25 12.4142 11.25 12V8.25C11.25 7.83579 11.5858 7.5 12 7.5C12.4142 7.5 12.75 7.83579 12.75 8.25V10.1893L16.4697 6.46967C16.7626 6.17678 17.2374 6.17678 17.5303 6.46967C17.8232 6.76256 17.8232 7.23744 17.5303 7.53033L13.8107 11.25H15.75C16.1642 11.25 16.5 11.5858 16.5 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.948 13.25C5.04952 13.25 4.3003 13.2499 3.70552 13.3299C3.07773 13.4143 2.51093 13.6 2.05546 14.0555C1.59999 14.5109 1.41432 15.0777 1.32991 15.7055C1.24995 16.3003 1.24997 17.0495 1.25 17.948V18.052C1.24997 18.9505 1.24995 19.6997 1.32991 20.2945C1.41432 20.9223 1.59999 21.4891 2.05546 21.9445C2.51093 22.4 3.07773 22.5857 3.70552 22.6701C4.3003 22.7501 5.04951 22.75 5.94798 22.75H6.052C6.95047 22.75 7.69971 22.7501 8.29448 22.6701C8.92228 22.5857 9.48908 22.4 9.94455 21.9445C10.4 21.4891 10.5857 20.9223 10.6701 20.2945C10.7501 19.6997 10.75 18.9505 10.75 18.052V17.948C10.75 17.0495 10.7501 16.3003 10.6701 15.7055C10.5857 15.0777 10.4 14.5109 9.94455 14.0555C9.48908 13.6 8.92228 13.4143 8.29448 13.3299C7.6997 13.2499 6.95048 13.25 6.052 13.25H5.948ZM3.11612 15.1161C3.24644 14.9858 3.44393 14.8786 3.9054 14.8165C4.38843 14.7516 5.03599 14.75 6 14.75C6.96401 14.75 7.61157 14.7516 8.09461 14.8165C8.55607 14.8786 8.75357 14.9858 8.88389 15.1161C9.0142 15.2464 9.12143 15.4439 9.18347 15.9054C9.24841 16.3884 9.25 17.036 9.25 18C9.25 18.964 9.24841 19.6116 9.18347 20.0946C9.12143 20.5561 9.0142 20.7536 8.88389 20.8839C8.75357 21.0142 8.55607 21.1214 8.09461 21.1835C7.61157 21.2484 6.96401 21.25 6 21.25C5.03599 21.25 4.38843 21.2484 3.9054 21.1835C3.44393 21.1214 3.24644 21.0142 3.11612 20.8839C2.9858 20.7536 2.87858 20.5561 2.81654 20.0946C2.7516 19.6116 2.75 18.964 2.75 18C2.75 17.036 2.7516 16.3884 2.81654 15.9054C2.87858 15.4439 2.9858 15.2464 3.11612 15.1161Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CircleArrowRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM9.96967 8.46967C10.2626 8.17678 10.7374 8.17678 11.0303 8.46967L14.0303 11.4697C14.3232 11.7626 14.3232 12.2374 14.0303 12.5303L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303C9.67678 15.2374 9.67678 14.7626 9.96967 14.4697L12.4393 12L9.96967 9.53033C9.67678 9.23744 9.67678 8.76256 9.96967 8.46967Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const CircleArrowLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM14.0303 8.46967C14.3232 8.76256 14.3232 9.23744 14.0303 9.53033L11.5607 12L14.0303 14.4697C14.3232 14.7626 14.3232 15.2374 14.0303 15.5303C13.7374 15.8232 13.2626 15.8232 12.9697 15.5303L9.96967 12.5303C9.67678 12.2374 9.67678 11.7626 9.96967 11.4697L12.9697 8.46967C13.2626 8.17678 13.7374 8.17678 14.0303 8.46967Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const PiPIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8459 2.45215H14.9588C16.7965 2.45213 18.2522 2.45212 19.3914 2.60528C20.5638 2.76291 21.5127 3.09503 22.2611 3.84339C23.0095 4.59175 23.3416 5.5407 23.4992 6.71313C23.6524 7.85234 23.6524 9.30798 23.6523 11.1457V11.2021C23.6523 11.6164 23.3166 11.9521 22.9023 11.9521C22.4881 11.9521 22.1523 11.6164 22.1523 11.2021C22.1523 9.29533 22.1508 7.94066 22.0126 6.913C21.8773 5.90691 21.6236 5.32726 21.2004 4.90405C20.7772 4.48084 20.1976 4.22717 19.1915 4.09191C18.1638 3.95374 16.8092 3.95215 14.9023 3.95215H10.9023C8.99552 3.95215 7.64086 3.95374 6.61319 4.09191C5.6071 4.22717 5.02746 4.48084 4.60425 4.90405C4.18104 5.32726 3.92737 5.90691 3.7921 6.913C3.65394 7.94066 3.65234 9.29533 3.65234 11.2021V13.2021C3.65234 15.109 3.65394 16.4636 3.7921 17.4913C3.92737 18.4974 4.18104 19.077 4.60425 19.5002C5.02746 19.9235 5.6071 20.1771 6.61319 20.3124C7.64086 20.4506 8.99552 20.4521 10.9023 20.4521H11.9023C12.3166 20.4521 12.6523 20.7879 12.6523 21.2021C12.6523 21.6164 12.3166 21.9521 11.9023 21.9521H10.8459C9.00817 21.9522 7.55254 21.9522 6.41332 21.799C5.2409 21.6414 4.29195 21.3093 3.54359 20.5609C2.79522 19.8125 2.46311 18.8636 2.30548 17.6912C2.15232 16.552 2.15233 15.0963 2.15234 13.2586V11.1457C2.15233 9.30797 2.15232 7.85234 2.30548 6.71313C2.46311 5.5407 2.79522 4.59176 3.54359 3.84339C4.29195 3.09503 5.2409 2.76291 6.41332 2.60528C7.55254 2.45212 9.00817 2.45213 10.8459 2.45215ZM7.87201 7.17182C8.16491 6.87893 8.63978 6.87893 8.93267 7.17182L11.6523 9.89149V8.70215C11.6523 8.28794 11.9881 7.95215 12.4023 7.95215C12.8166 7.95215 13.1523 8.28794 13.1523 8.70215V11.7021C13.1523 12.1164 12.8166 12.4521 12.4023 12.4521H9.40234C8.98813 12.4521 8.65234 12.1164 8.65234 11.7021C8.65234 11.2879 8.98813 10.9521 9.40234 10.9521H10.5917L7.87201 8.23248C7.57912 7.93959 7.57912 7.46471 7.87201 7.17182ZM17.8504 12.4521H18.9543C19.8528 12.4521 20.602 12.4521 21.1968 12.5321C21.8246 12.6165 22.3914 12.8021 22.8469 13.2576C23.3024 13.7131 23.488 14.2799 23.5724 14.9077C23.6524 15.5025 23.6524 16.2517 23.6523 17.1502V17.2541C23.6524 18.1526 23.6524 18.9018 23.5724 19.4966C23.488 20.1244 23.3024 20.6912 22.8469 21.1467C22.3914 21.6022 21.8246 21.7878 21.1968 21.8722C20.602 21.9522 19.8528 21.9522 18.9543 21.9521H17.8504C16.9519 21.9522 16.2026 21.9522 15.6079 21.8722C14.9801 21.7878 14.4133 21.6022 13.9578 21.1467C13.5023 20.6912 13.3167 20.1244 13.2323 19.4966C13.1523 18.9018 13.1523 18.1526 13.1523 17.2541V17.1502C13.1523 16.2517 13.1523 15.5025 13.2323 14.9077C13.3167 14.2799 13.5023 13.7131 13.9578 13.2576C14.4133 12.8021 14.9801 12.6165 15.6079 12.5321C16.2026 12.4521 16.9519 12.4521 17.8504 12.4521ZM15.8077 14.0187C15.3463 14.0807 15.1488 14.188 15.0185 14.3183C14.8881 14.4486 14.7809 14.6461 14.7189 15.1075C14.6539 15.5906 14.6523 16.2381 14.6523 17.2021C14.6523 18.1662 14.6539 18.8137 14.7189 19.2968C14.7809 19.7582 14.8881 19.9557 15.0185 20.086C15.1488 20.2163 15.3463 20.3236 15.8077 20.3856C16.2908 20.4506 16.9383 20.4521 17.9023 20.4521H18.9023C19.8664 20.4521 20.5139 20.4506 20.997 20.3856C21.4584 20.3236 21.6559 20.2163 21.7862 20.086C21.9165 19.9557 22.0238 19.7582 22.0858 19.2968C22.1508 18.8137 22.1523 18.1662 22.1523 17.2021C22.1523 16.2381 22.1508 15.5906 22.0858 15.1075C22.0238 14.6461 21.9165 14.4486 21.7862 14.3183C21.6559 14.188 21.4584 14.0807 20.997 14.0187C20.5139 13.9537 19.8664 13.9521 18.9023 13.9521H17.9023C16.9383 13.9521 16.2908 13.9537 15.8077 14.0187Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ArrowLeft = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        d="M9.94727 5.32129C10.2909 5.04071 10.7987 5.06041 11.1191 5.38086L11.1787 5.44727C11.4407 5.76815 11.4407 6.23185 11.1787 6.55273L11.1191 6.61914L6.61328 11.125H20.5C20.9832 11.125 21.375 11.5168 21.375 12C21.375 12.4832 20.9832 12.875 20.5 12.875H6.61328L11.1191 17.3809L11.1787 17.4473C11.4407 17.7681 11.4407 18.2319 11.1787 18.5527L11.1191 18.6191C10.7987 18.9396 10.2909 18.9593 9.94727 18.6787L9.88086 18.6191L3.88086 12.6191C3.53915 12.2774 3.53915 11.7226 3.88086 11.3809L9.88086 5.38086L9.94727 5.32129Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.25"
      />
    </svg>
  )
}

export const ArrowRight = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        d="M13.9473 5.32129C14.2909 5.04071 14.7987 5.06041 15.1191 5.38086L21.1191 11.3809L21.1787 11.4473C21.4407 11.7681 21.4407 12.2319 21.1787 12.5527L21.1191 12.6191L15.1191 18.6191C14.7987 18.9396 14.2909 18.9593 13.9473 18.6787L13.8809 18.6191C13.5392 18.2774 13.5392 17.7226 13.8809 17.3809L18.3867 12.875H4.5C4.01675 12.875 3.625 12.4832 3.625 12C3.625 11.5168 4.01675 11.125 4.5 11.125H18.3867L13.8809 6.61914C13.5392 6.27743 13.5392 5.72257 13.8809 5.38086L13.9473 5.32129Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.25"
      />
    </svg>
  )
}

export const PaginationDotIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <circle cx="8" cy="8" r="7.5" fill="currentColor" />
    </svg>
  )
}

export const FileTextIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 14.5C5.25 14.0858 5.58579 13.75 6 13.75H14C14.4142 13.75 14.75 14.0858 14.75 14.5C14.75 14.9142 14.4142 15.25 14 15.25H6C5.58579 15.25 5.25 14.9142 5.25 14.5Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 18C5.25 17.5858 5.58579 17.25 6 17.25H11.5C11.9142 17.25 12.25 17.5858 12.25 18C12.25 18.4142 11.9142 18.75 11.5 18.75H6C5.58579 18.75 5.25 18.4142 5.25 18Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 2.83416C11.7896 2.75592 11.162 2.74999 10.0298 2.74999C8.11311 2.74999 6.75075 2.75157 5.71785 2.88981C4.70596 3.02524 4.12453 3.27927 3.7019 3.70189C3.27869 4.1251 3.02502 4.70475 2.88976 5.71084C2.75159 6.7385 2.75 8.09317 2.75 9.99999V14C2.75 15.9068 2.75159 17.2615 2.88976 18.2891C3.02502 19.2952 3.27869 19.8749 3.7019 20.2981C4.12511 20.7213 4.70476 20.975 5.71085 21.1102C6.73851 21.2484 8.09318 21.25 10 21.25H14C15.9068 21.25 17.2615 21.2484 18.2892 21.1102C19.2952 20.975 19.8749 20.7213 20.2981 20.2981C20.7213 19.8749 20.975 19.2952 21.1102 18.2891C21.2484 17.2615 21.25 15.9068 21.25 14V13.5629C21.25 12.0269 21.2392 11.2987 21.0762 10.75H17.9463C16.8135 10.75 15.8877 10.75 15.1569 10.6518C14.3929 10.5491 13.7306 10.3268 13.2019 9.79809C12.6732 9.26939 12.4509 8.60706 12.3482 7.8431C12.25 7.11224 12.25 6.18651 12.25 5.05368V2.83416ZM13.75 3.60944V4.99999C13.75 6.1997 13.7516 7.02404 13.8348 7.64323C13.9152 8.24085 14.059 8.53389 14.2626 8.73743C14.4661 8.94097 14.7591 9.0848 15.3568 9.16515C15.976 9.2484 16.8003 9.24999 18 9.24999H20.0195C19.723 8.96244 19.3432 8.61791 18.85 8.17401L14.8912 4.61111C14.4058 4.17427 14.0446 3.85181 13.75 3.60944ZM10.1755 1.24996C11.5601 1.24959 12.4546 1.24935 13.2779 1.56529C14.1012 1.88123 14.7632 2.47728 15.7873 3.39949C15.8226 3.43133 15.8584 3.46355 15.8947 3.49617L19.8534 7.05906C19.8956 7.09699 19.9372 7.13444 19.9783 7.17143C21.162 8.23608 21.9274 8.92452 22.3391 9.84896C22.7508 10.7734 22.7505 11.8029 22.75 13.3949C22.75 13.4502 22.75 13.5062 22.75 13.5629V14.0564C22.75 15.8942 22.75 17.3498 22.5969 18.489C22.4392 19.6614 22.1071 20.6104 21.3588 21.3587C20.6104 22.1071 19.6614 22.4392 18.489 22.5969C17.3498 22.75 15.8942 22.75 14.0564 22.75H9.94359C8.10583 22.75 6.65019 22.75 5.51098 22.5969C4.33856 22.4392 3.38961 22.1071 2.64124 21.3587C1.89288 20.6104 1.56076 19.6614 1.40314 18.489C1.24997 17.3498 1.24998 15.8942 1.25 14.0564V9.94357C1.24998 8.10581 1.24997 6.65018 1.40314 5.51097C1.56076 4.33854 1.89288 3.3896 2.64124 2.64123C3.39019 1.89228 4.34232 1.56053 5.51887 1.40306C6.66283 1.24996 8.1257 1.24997 9.97352 1.24999L10.0298 1.24999C10.0789 1.24999 10.1275 1.24998 10.1755 1.24996Z"
        fill="#fff"
      />
    </svg>
  )
}

export const CircleCloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.35989 7.4747C8.11581 7.23062 7.72008 7.23062 7.476 7.4747C7.23192 7.71878 7.23192 8.11451 7.476 8.35859L9.1174 9.99999L7.47602 11.6414C7.23194 11.8854 7.23194 12.2812 7.47602 12.5253C7.7201 12.7693 8.11583 12.7693 8.3599 12.5253L10.0013 10.8839L11.6427 12.5252C11.8867 12.7693 12.2825 12.7693 12.5265 12.5252C12.7706 12.2812 12.7706 11.8854 12.5265 11.6414L10.8852 9.99999L12.5266 8.3586C12.7706 8.11453 12.7706 7.7188 12.5266 7.47472C12.2825 7.23064 11.8867 7.23064 11.6427 7.47472L10.0013 9.1161L8.35989 7.4747Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0013 1.04166C5.05375 1.04166 1.04297 5.05244 1.04297 9.99999C1.04297 14.9475 5.05375 18.9583 10.0013 18.9583C14.9489 18.9583 18.9596 14.9475 18.9596 9.99999C18.9596 5.05244 14.9489 1.04166 10.0013 1.04166ZM2.29297 9.99999C2.29297 5.74279 5.74411 2.29166 10.0013 2.29166C14.2585 2.29166 17.7096 5.74279 17.7096 9.99999C17.7096 14.2572 14.2585 17.7083 10.0013 17.7083C5.74411 17.7083 2.29297 14.2572 2.29297 9.99999Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CircleInfoIcon = ({ className }: IIconProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6654 8.00004C14.6654 11.6819 11.6806 14.6667 7.9987 14.6667C4.3168 14.6667 1.33203 11.6819 1.33203 8.00004C1.33203 4.31814 4.3168 1.33337 7.9987 1.33337C11.6806 1.33337 14.6654 4.31814 14.6654 8.00004ZM7.9987 11.8334C8.27484 11.8334 8.4987 11.6095 8.4987 11.3334V7.33337C8.4987 7.05723 8.27484 6.83337 7.9987 6.83337C7.72256 6.83337 7.4987 7.05723 7.4987 7.33337V11.3334C7.4987 11.6095 7.72256 11.8334 7.9987 11.8334ZM7.9987 4.66671C8.36689 4.66671 8.66536 4.96518 8.66536 5.33337C8.66536 5.70156 8.36689 6.00004 7.9987 6.00004C7.63051 6.00004 7.33203 5.70156 7.33203 5.33337C7.33203 4.96518 7.63051 4.66671 7.9987 4.66671Z"
        fill="#E68200"
      />
    </svg>
  )
}

export const CircleCheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6654 7.99998C14.6654 11.6819 11.6806 14.6666 7.9987 14.6666C4.3168 14.6666 1.33203 11.6819 1.33203 7.99998C1.33203 4.31808 4.3168 1.33331 7.9987 1.33331C11.6806 1.33331 14.6654 4.31808 14.6654 7.99998ZM10.6856 5.97976C10.8808 6.17502 10.8808 6.4916 10.6856 6.68687L7.35225 10.0202C7.15699 10.2155 6.84041 10.2155 6.64514 10.0202L5.31181 8.68687C5.11655 8.4916 5.11655 8.17502 5.31181 7.97976C5.50707 7.7845 5.82366 7.7845 6.01892 7.97976L6.9987 8.95954L8.48859 7.46965L9.97848 5.97976C10.1737 5.7845 10.4903 5.7845 10.6856 5.97976Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ReplyMessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_4782_13794)">
        <path
          d="M5.9987 7.99992C5.9987 8.36811 5.70022 8.66659 5.33203 8.66659C4.96384 8.66659 4.66536 8.36811 4.66536 7.99992C4.66536 7.63173 4.96384 7.33325 5.33203 7.33325C5.70022 7.33325 5.9987 7.63173 5.9987 7.99992Z"
          fill="currentColor"
        />
        <path
          d="M8.66536 7.99992C8.66536 8.36811 8.36689 8.66659 7.9987 8.66659C7.63051 8.66659 7.33203 8.36811 7.33203 7.99992C7.33203 7.63173 7.63051 7.33325 7.9987 7.33325C8.36689 7.33325 8.66536 7.63173 8.66536 7.99992Z"
          fill="currentColor"
        />
        <path
          d="M11.332 7.99992C11.332 8.36811 11.0336 8.66659 10.6654 8.66659C10.2972 8.66659 9.9987 8.36811 9.9987 7.99992C9.9987 7.63173 10.2972 7.33325 10.6654 7.33325C11.0336 7.33325 11.332 7.63173 11.332 7.99992Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1654 7.99992C15.1654 4.04188 11.9567 0.833252 7.9987 0.833252C4.04066 0.833252 0.832031 4.04188 0.832031 7.99992C0.832031 9.14546 1.10117 10.2296 1.58012 11.1912C1.65159 11.3346 1.66675 11.4812 1.63377 11.6044L1.2367 13.0885C0.964881 14.1043 1.89428 15.0337 2.91017 14.7619L4.39419 14.3648C4.51745 14.3319 4.66397 14.347 4.80746 14.4185C5.76905 14.8974 6.85316 15.1666 7.9987 15.1666C11.9567 15.1666 15.1654 11.958 15.1654 7.99992ZM7.9987 1.83325C11.4045 1.83325 14.1654 4.59416 14.1654 7.99992C14.1654 11.4057 11.4045 14.1666 7.9987 14.1666C7.01133 14.1666 6.0795 13.9349 5.2533 13.5234C4.9217 13.3582 4.52518 13.2946 4.13572 13.3988L2.65169 13.7959C2.37914 13.8688 2.12979 13.6195 2.20271 13.3469L2.59979 11.8629C2.70399 11.4734 2.64039 11.0769 2.47523 10.7453C2.06371 9.91912 1.83203 8.98729 1.83203 7.99992C1.83203 4.59416 4.59294 1.83325 7.9987 1.83325Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4782_13794">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const EditMessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_4782_13813)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.96045 0.833252L8.9987 0.833252C9.27484 0.833252 9.4987 1.05711 9.4987 1.33325C9.4987 1.60939 9.27484 1.83325 8.9987 1.83325H7.9987C6.41321 1.83325 5.2744 1.83431 4.40775 1.95083C3.55548 2.06542 3.04167 2.28335 2.6619 2.66312C2.28212 3.04289 2.0642 3.5567 1.94961 4.40897C1.83309 5.27562 1.83203 6.41443 1.83203 7.99992C1.83203 9.5854 1.83309 10.7242 1.94961 11.5909C2.0642 12.4431 2.28212 12.9569 2.6619 13.3367C3.04167 13.7165 3.55548 13.9344 4.40775 14.049C5.2744 14.1655 6.41321 14.1666 7.9987 14.1666C9.58418 14.1666 10.723 14.1655 11.5896 14.049C12.4419 13.9344 12.9557 13.7165 13.3355 13.3367C13.7153 12.9569 13.9332 12.4431 14.0478 11.5909C14.1643 10.7242 14.1654 9.5854 14.1654 7.99992V6.99992C14.1654 6.72378 14.3892 6.49992 14.6654 6.49992C14.9415 6.49992 15.1654 6.72378 15.1654 6.99992V8.03817C15.1654 9.5771 15.1654 10.7831 15.0389 11.7241C14.9094 12.6873 14.6391 13.4473 14.0426 14.0438C13.4461 14.6404 12.6861 14.9106 11.7229 15.0401C10.7819 15.1666 9.57588 15.1666 8.03695 15.1666H7.96045C6.42152 15.1666 5.21549 15.1666 4.2745 15.0401C3.31134 14.9106 2.55133 14.6404 1.95479 14.0438C1.35825 13.4473 1.08802 12.6873 0.958529 11.7241C0.832016 10.7831 0.832023 9.5771 0.832031 8.03817V7.96167C0.832023 6.42274 0.832016 5.21671 0.958529 4.27572C1.08802 3.31257 1.35825 2.55255 1.95479 1.95601C2.55133 1.35947 3.31134 1.08924 4.2745 0.95975C5.21549 0.833237 6.42152 0.833244 7.96045 0.833252ZM11.1791 1.5172C12.091 0.605271 13.5695 0.605271 14.4814 1.5172C15.3933 2.42912 15.3933 3.90764 14.4814 4.81956L10.0494 9.25163C9.80184 9.49919 9.64678 9.65426 9.47375 9.78922C9.26996 9.94818 9.04945 10.0845 8.81613 10.1957C8.61804 10.2901 8.41 10.3594 8.07789 10.4701L6.14154 11.1155C5.78404 11.2347 5.3899 11.1416 5.12344 10.8752C4.85698 10.6087 4.76393 10.2146 4.8831 9.85708L5.52854 7.92074C5.63922 7.58862 5.70856 7.38058 5.80296 7.18249C5.91416 6.94917 6.05044 6.72866 6.2094 6.52486C6.34436 6.35183 6.49943 6.19678 6.747 5.94925L11.1791 1.5172ZM13.7743 2.2243C13.2529 1.7029 12.4076 1.7029 11.8862 2.2243L11.6351 2.47538C11.6502 2.53929 11.6714 2.61543 11.7009 2.70036C11.7964 2.97573 11.9772 3.33839 12.3187 3.67991C12.6602 4.02143 13.0229 4.20223 13.2983 4.29777C13.3832 4.32723 13.4593 4.3484 13.5232 4.36354L13.7743 4.11246C14.2957 3.59106 14.2957 2.7457 13.7743 2.2243ZM12.7355 5.15131C12.3915 5.00338 11.9908 4.76622 11.6116 4.38702C11.2324 4.00782 10.9952 3.60713 10.8473 3.26316L7.47704 6.63342C7.19936 6.9111 7.09046 7.02122 6.99791 7.13988C6.88362 7.28641 6.78563 7.44495 6.70569 7.61271C6.64094 7.74856 6.59115 7.89521 6.46697 8.26775L6.17904 9.13154L6.86708 9.81958L7.73087 9.53165C8.10341 9.40747 8.25006 9.35767 8.38591 9.29293C8.55366 9.21298 8.7122 9.115 8.85873 9.00071C8.9774 8.90815 9.08751 8.79926 9.36519 8.52158L12.7355 5.15131Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4782_13813">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const DeleteMessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99872 1.83325C7.34639 1.83325 6.7901 2.24994 6.58394 2.83321C6.49192 3.09357 6.20626 3.23003 5.9459 3.13801C5.68554 3.04598 5.54908 2.76032 5.6411 2.49996C5.98406 1.52964 6.90942 0.833252 7.99872 0.833252C9.08802 0.833252 10.0134 1.52964 10.3563 2.49996C10.4484 2.76032 10.3119 3.04598 10.0515 3.13801C9.79118 3.23003 9.50552 3.09357 9.4135 2.83321C9.20734 2.24994 8.65105 1.83325 7.99872 1.83325Z"
        fill="currentColor"
      />
      <path
        d="M1.83203 3.99992C1.83203 3.72378 2.05589 3.49992 2.33203 3.49992H13.6654C13.9416 3.49992 14.1654 3.72378 14.1654 3.99992C14.1654 4.27606 13.9416 4.49992 13.6654 4.49992H2.33203C2.05589 4.49992 1.83203 4.27606 1.83203 3.99992Z"
        fill="currentColor"
      />
      <path
        d="M3.94209 5.63332C3.92372 5.35779 3.68547 5.14932 3.40994 5.16769C3.13441 5.18606 2.92593 5.42431 2.9443 5.69984L3.25327 10.3343C3.31027 11.1895 3.35631 11.8803 3.46429 12.4223C3.57655 12.9858 3.7675 13.4566 4.1619 13.8255C4.55629 14.1945 5.03866 14.3537 5.60843 14.4283C6.15645 14.4999 6.84875 14.4999 7.70581 14.4999H8.2917C9.14875 14.4999 9.84105 14.4999 10.3891 14.4283C10.9588 14.3537 11.4412 14.1945 11.8356 13.8255C12.23 13.4566 12.4209 12.9858 12.5332 12.4223C12.6412 11.8803 12.6872 11.1895 12.7442 10.3343L13.0532 5.69984C13.0716 5.42431 12.8631 5.18606 12.5876 5.16769C12.312 5.14932 12.0738 5.35779 12.0554 5.63332L11.7488 10.2327C11.6889 11.1313 11.6462 11.7565 11.5525 12.2269C11.4616 12.6832 11.3347 12.9248 11.1524 13.0953C10.9701 13.2658 10.7207 13.3764 10.2594 13.4367C9.78377 13.4989 9.1571 13.4999 8.25654 13.4999H7.74096C6.8404 13.4999 6.21373 13.4989 5.73813 13.4367C5.27679 13.3764 5.02736 13.2658 4.84508 13.0953C4.66281 12.9248 4.53592 12.6832 4.44502 12.2269C4.35131 11.7565 4.30862 11.1313 4.24872 10.2327L3.94209 5.63332Z"
        fill="currentColor"
      />
      <path
        d="M6.28234 6.83573C6.55711 6.80826 6.80213 7.00873 6.82961 7.2835L7.16294 10.6168C7.19042 10.8916 6.98995 11.1366 6.71517 11.1641C6.4404 11.1916 6.19538 10.9911 6.1679 10.7163L5.83457 7.383C5.80709 7.10823 6.00757 6.86321 6.28234 6.83573Z"
        fill="currentColor"
      />
      <path
        d="M10.1629 7.383C10.1904 7.10823 9.98995 6.86321 9.71517 6.83573C9.4404 6.80826 9.19538 7.00873 9.1679 7.2835L8.83457 10.6168C8.80709 10.8916 9.00757 11.1366 9.28234 11.1641C9.55711 11.1916 9.80213 10.9911 9.82961 10.7163L10.1629 7.383Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CloseCircleIcon = ({ color = 'black', size = 16 }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6693 7.99967C14.6693 11.6816 11.6845 14.6663 8.0026 14.6663C4.32071 14.6663 1.33594 11.6816 1.33594 7.99967C1.33594 4.31778 4.32071 1.33301 8.0026 1.33301C11.6845 1.33301 14.6693 4.31778 14.6693 7.99967ZM5.98236 5.97944C6.17762 5.78418 6.4942 5.78418 6.68946 5.97944L8.00258 7.29256L9.31569 5.97945C9.51095 5.78419 9.82753 5.78419 10.0228 5.97945C10.2181 6.17472 10.2181 6.4913 10.0228 6.68656L8.70969 7.99967L10.0228 9.31276C10.218 9.50802 10.218 9.82461 10.0228 10.0199C9.82752 10.2151 9.51094 10.2151 9.31568 10.0199L8.00258 8.70678L6.68948 10.0199C6.49422 10.2151 6.17763 10.2151 5.98237 10.0199C5.78711 9.82462 5.78711 9.50804 5.98237 9.31277L7.29548 7.99967L5.98236 6.68655C5.78709 6.49129 5.78709 6.1747 5.98236 5.97944Z"
        fill={color}
      />
    </svg>
  )
}

export const ArrowRightIcon = ({ color = 'black', size = 16 }: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.71069 18.2929C10.1012 18.6834 10.7344 18.6834 11.1249 18.2929L16.0123 13.4006C16.7927 12.6195 16.7924 11.3537 16.0117 10.5729L11.1213 5.68254C10.7308 5.29202 10.0976 5.29202 9.70708 5.68254C9.31655 6.07307 9.31655 6.70623 9.70708 7.09676L13.8927 11.2824C14.2833 11.6729 14.2833 12.3061 13.8927 12.6966L9.71069 16.8787C9.32016 17.2692 9.32016 17.9023 9.71069 18.2929Z"
        fill={color}
      />
    </svg>
  )
}

export const ShowCommentIcon = ({ className }: IIconProps) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 -0.5 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M9.0001 8.517C8.58589 8.517 8.2501 8.85279 8.2501 9.267C8.2501 9.68121 8.58589 10.017 9.0001 10.017V8.517ZM16.0001 10.017C16.4143 10.017 16.7501 9.68121 16.7501 9.267C16.7501 8.85279 16.4143 8.517 16.0001 8.517V10.017ZM9.8751 11.076C9.46089 11.076 9.1251 11.4118 9.1251 11.826C9.1251 12.2402 9.46089 12.576 9.8751 12.576V11.076ZM15.1251 12.576C15.5393 12.576 15.8751 12.2402 15.8751 11.826C15.8751 11.4118 15.5393 11.076 15.1251 11.076V12.576ZM9.1631 5V4.24998L9.15763 4.25002L9.1631 5ZM15.8381 5L15.8438 4.25H15.8381V5ZM19.5001 8.717L18.7501 8.71149V8.717H19.5001ZM19.5001 13.23H18.7501L18.7501 13.2355L19.5001 13.23ZM18.4384 15.8472L17.9042 15.3207L17.9042 15.3207L18.4384 15.8472ZM15.8371 16.947V17.697L15.8426 17.697L15.8371 16.947ZM9.1631 16.947V16.197C9.03469 16.197 8.90843 16.23 8.79641 16.2928L9.1631 16.947ZM5.5001 19H4.7501C4.7501 19.2662 4.89125 19.5125 5.12097 19.6471C5.35068 19.7817 5.63454 19.7844 5.86679 19.6542L5.5001 19ZM5.5001 8.717H6.25012L6.25008 8.71149L5.5001 8.717ZM6.56175 6.09984L6.02756 5.5734H6.02756L6.56175 6.09984ZM9.0001 10.017H16.0001V8.517H9.0001V10.017ZM9.8751 12.576H15.1251V11.076H9.8751V12.576ZM9.1631 5.75H15.8381V4.25H9.1631V5.75ZM15.8324 5.74998C17.4559 5.76225 18.762 7.08806 18.7501 8.71149L20.2501 8.72251C20.2681 6.2708 18.2955 4.26856 15.8438 4.25002L15.8324 5.74998ZM18.7501 8.717V13.23H20.2501V8.717H18.7501ZM18.7501 13.2355C18.7558 14.0153 18.4516 14.7653 17.9042 15.3207L18.9726 16.3736C19.7992 15.5348 20.2587 14.4021 20.2501 13.2245L18.7501 13.2355ZM17.9042 15.3207C17.3569 15.8761 16.6114 16.1913 15.8316 16.197L15.8426 17.697C17.0201 17.6884 18.1461 17.2124 18.9726 16.3736L17.9042 15.3207ZM15.8371 16.197H9.1631V17.697H15.8371V16.197ZM8.79641 16.2928L5.13341 18.3458L5.86679 19.6542L9.52979 17.6012L8.79641 16.2928ZM6.2501 19V8.717H4.7501V19H6.2501ZM6.25008 8.71149C6.24435 7.93175 6.54862 7.18167 7.09595 6.62627L6.02756 5.5734C5.20098 6.41216 4.74147 7.54494 4.75012 8.72251L6.25008 8.71149ZM7.09595 6.62627C7.64328 6.07088 8.38882 5.75566 9.16857 5.74998L9.15763 4.25002C7.98006 4.2586 6.85413 4.73464 6.02756 5.5734L7.09595 6.62627Z"
          fill="currentColor"
        ></path>{' '}
      </g>
    </svg>
  )
}

export const PointerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.8791 3.08391L10.5905 4.45128C11.1036 4.64028 11.541 4.80139 11.8581 4.97473C12.1904 5.15633 12.5053 5.41185 12.5999 5.84267C12.6945 6.27348 12.5157 6.63746 12.2901 6.94157C12.0748 7.23184 11.7452 7.56141 11.3586 7.94803L10.8825 8.42404L13.1654 10.7069C13.292 10.8335 13.4043 10.9458 13.4915 11.0457C13.584 11.1518 13.6727 11.2708 13.7335 11.4177C13.868 11.7423 13.868 12.1072 13.7335 12.4319C13.6727 12.5788 13.584 12.6977 13.4915 12.8038C13.4043 12.9037 13.292 13.016 13.1654 13.1426L13.1437 13.1644C13.017 13.291 12.9048 13.4033 12.8048 13.4904C12.6987 13.583 12.5798 13.6716 12.4329 13.7325C12.1082 13.867 11.7434 13.867 11.4187 13.7325C11.2718 13.6716 11.1529 13.583 11.0467 13.4904C10.9468 13.4033 10.8345 13.291 10.7079 13.1643L8.42508 10.8815L7.94907 11.3575C7.56245 11.7442 7.23288 12.0738 6.94261 12.2891C6.6385 12.5146 6.27452 12.6935 5.84371 12.5989C5.41289 12.5043 5.15737 12.1893 4.97577 11.8571C4.80243 11.54 4.64132 11.1026 4.45232 10.5895L3.08495 6.87807C2.6977 5.827 2.38744 4.98491 2.24977 4.33623C2.1123 3.68848 2.10443 3.04472 2.57509 2.57405C3.04575 2.10339 3.68952 2.11127 4.33727 2.24874C4.98595 2.3864 5.82804 2.69666 6.8791 3.08391ZM4.12967 3.22695C3.55096 3.10413 3.3715 3.19186 3.2822 3.28116C3.19289 3.37046 3.10517 3.54992 3.22799 4.12863C3.34879 4.69784 3.63254 5.47174 4.03868 6.57412L5.37707 10.2069C5.58347 10.7671 5.71979 11.1333 5.85324 11.3775C5.9784 11.6064 6.04365 11.6193 6.05706 11.6219C6.05751 11.622 6.0579 11.6221 6.05823 11.6222C6.05856 11.6222 6.05895 11.6223 6.05939 11.6224C6.07268 11.6257 6.1373 11.6413 6.34689 11.4859C6.57037 11.3201 6.84759 11.0448 7.26976 10.6226L8.07153 9.82085C8.26679 9.62558 8.58337 9.62558 8.77863 9.82085L11.4042 12.4464C11.5449 12.5871 11.633 12.6748 11.7041 12.7368C11.7718 12.7959 11.7966 12.8066 11.8014 12.8086C11.881 12.8416 11.9705 12.8416 12.0502 12.8086C12.055 12.8066 12.0798 12.7959 12.1475 12.7368C12.2186 12.6748 12.3067 12.5871 12.4474 12.4464C12.5882 12.3056 12.6759 12.2176 12.7379 12.1465C12.7969 12.0788 12.8077 12.0539 12.8096 12.0492C12.8426 11.9695 12.8426 11.88 12.8096 11.8003C12.8077 11.7956 12.7969 11.7707 12.7379 11.703C12.6759 11.632 12.5882 11.5439 12.4474 11.4031L9.82188 8.7776C9.62662 8.58233 9.62662 8.26575 9.82188 8.07049L10.6237 7.26872C11.0458 6.84655 11.3212 6.56933 11.4869 6.34585C11.6424 6.13626 11.6267 6.07164 11.6235 6.05835C11.6234 6.05791 11.6233 6.05752 11.6232 6.05719C11.6231 6.05686 11.623 6.05647 11.623 6.05602C11.6203 6.04261 11.6075 5.97736 11.3785 5.85221C11.1344 5.71875 10.7682 5.58244 10.2079 5.37604L6.57516 4.03764C5.47278 3.6315 4.69888 3.34775 4.12967 3.22695Z"
        fill="white"
      />
    </svg>
  )
}

export const AltArrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.512 4.43a.75.75 0 0 1 1.057.082l6 7a.75.75 0 0 1 0 .976l-6 7a.75.75 0 0 1-1.138-.976L14.012 12 8.431 5.488a.75.75 0 0 1 .08-1.057Z"
      clipRule="evenodd"
    />
  </svg>
)

export const ArrowRightV2Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4697 5.46967C13.7626 5.17678 14.2374 5.17678 14.5303 5.46967L20.5303 11.4697C20.8232 11.7626 20.8232 12.2374 20.5303 12.5303L14.5303 18.5303C14.2374 18.8232 13.7626 18.8232 13.4697 18.5303C13.1768 18.2374 13.1768 17.7626 13.4697 17.4697L18.1893 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H18.1893L13.4697 6.53033C13.1768 6.23744 13.1768 5.76256 13.4697 5.46967Z"
        fill="#1F2937"
      />
    </svg>
  )
}

export const HamburgerMenuLargeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.667 9.33301C27.667 9.88529 27.2193 10.333 26.667 10.333L5.33366 10.333C4.78138 10.333 4.33366 9.88529 4.33366 9.33301C4.33366 8.78072 4.78138 8.33301 5.33366 8.33301L26.667 8.33301C27.2193 8.33301 27.667 8.78072 27.667 9.33301Z"
        fill="#1C274C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.667 16C27.667 16.5523 27.2193 17 26.667 17L5.33366 17C4.78138 17 4.33366 16.5523 4.33366 16C4.33366 15.4477 4.78138 15 5.33366 15L26.667 15C27.2193 15 27.667 15.4477 27.667 16Z"
        fill="#1C274C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.667 22.667C27.667 23.2193 27.2193 23.667 26.667 23.667L5.33366 23.667C4.78138 23.667 4.33366 23.2193 4.33366 22.667C4.33366 22.1147 4.78138 21.667 5.33366 21.667L26.667 21.667C27.2193 21.667 27.667 22.1147 27.667 22.667Z"
        fill="#1C274C"
      />
    </svg>
  )
}

export const DocumentTextIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.4436 1.25H13.5564C15.3942 1.24998 16.8498 1.24997 17.989 1.40314C19.1614 1.56076 20.1104 1.89288 20.8588 2.64124C21.6071 3.38961 21.9392 4.33856 22.0969 5.51098C22.25 6.65019 22.25 8.10583 22.25 9.94359V14.0564C22.25 15.8942 22.25 17.3498 22.0969 18.489C21.9392 19.6614 21.6071 20.6104 20.8588 21.3588C20.1104 22.1071 19.1614 22.4392 17.989 22.5969C16.8498 22.75 15.3942 22.75 13.5564 22.75H11.4436C9.60583 22.75 8.15019 22.75 7.01098 22.5969C5.83856 22.4392 4.88961 22.1071 4.14124 21.3588C3.39288 20.6104 3.06076 19.6614 2.90314 18.489C2.74997 17.3498 2.74998 15.8942 2.75 14.0564V9.94358C2.74998 8.10582 2.74997 6.65019 2.90314 5.51098C3.06076 4.33856 3.39288 3.38961 4.14124 2.64124C4.88961 1.89288 5.83856 1.56076 7.01098 1.40314C8.15019 1.24997 9.60582 1.24998 11.4436 1.25ZM7.21085 2.88976C6.20476 3.02502 5.62511 3.27869 5.2019 3.7019C4.77869 4.12511 4.52502 4.70476 4.38976 5.71085C4.25159 6.73851 4.25 8.09318 4.25 10V14C4.25 15.9068 4.25159 17.2615 4.38976 18.2892C4.52502 19.2952 4.77869 19.8749 5.2019 20.2981C5.62511 20.7213 6.20476 20.975 7.21085 21.1102C8.23851 21.2484 9.59318 21.25 11.5 21.25H13.5C15.4068 21.25 16.7615 21.2484 17.7892 21.1102C18.7952 20.975 19.3749 20.7213 19.7981 20.2981C20.2213 19.8749 20.475 19.2952 20.6102 18.2892C20.7484 17.2615 20.75 15.9068 20.75 14V10C20.75 8.09318 20.7484 6.73851 20.6102 5.71085C20.475 4.70476 20.2213 4.12511 19.7981 3.7019C19.3749 3.27869 18.7952 3.02502 17.7892 2.88976C16.7615 2.75159 15.4068 2.75 13.5 2.75H11.5C9.59318 2.75 8.23851 2.75159 7.21085 2.88976ZM7.75 8C7.75 7.58579 8.08579 7.25 8.5 7.25H16.5C16.9142 7.25 17.25 7.58579 17.25 8C17.25 8.41421 16.9142 8.75 16.5 8.75H8.5C8.08579 8.75 7.75 8.41421 7.75 8ZM7.75 12C7.75 11.5858 8.08579 11.25 8.5 11.25H16.5C16.9142 11.25 17.25 11.5858 17.25 12C17.25 12.4142 16.9142 12.75 16.5 12.75H8.5C8.08579 12.75 7.75 12.4142 7.75 12ZM7.75 16C7.75 15.5858 8.08579 15.25 8.5 15.25H13.5C13.9142 15.25 14.25 15.5858 14.25 16C14.25 16.4142 13.9142 16.75 13.5 16.75H8.5C8.08579 16.75 7.75 16.4142 7.75 16Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const ResourceIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={`${className}`}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.45526 2.25C4.47013 2.25001 4.48505 2.25001 4.50001 2.25001L20.5448 2.25C20.9776 2.24995 21.3744 2.24991 21.6972 2.29331C22.0527 2.3411 22.4284 2.45355 22.7374 2.76257C23.0465 3.07159 23.1589 3.44732 23.2067 3.8028C23.2501 4.12561 23.2501 4.52245 23.25 4.95526V5.04475C23.2501 5.47757 23.2501 5.8744 23.2067 6.19721C23.1589 6.55269 23.0465 6.92842 22.7374 7.23744C22.4437 7.53121 22.0896 7.64733 21.75 7.69914V13.0564C21.75 14.8942 21.75 16.3498 21.5969 17.489C21.4392 18.6615 21.1071 19.6104 20.3588 20.3588C19.6104 21.1071 18.6615 21.4392 17.489 21.5969C16.3498 21.75 14.8942 21.75 13.0564 21.75H11.9436C10.1058 21.75 8.6502 21.75 7.51098 21.5969C6.33856 21.4392 5.38961 21.1071 4.64125 20.3588C3.89289 19.6104 3.56077 18.6615 3.40314 17.489C3.24998 16.3498 3.24999 14.8942 3.25001 13.0564L3.25001 7.69914C2.91038 7.64733 2.55634 7.53121 2.26257 7.23744C1.95355 6.92842 1.8411 6.55269 1.79331 6.19721C1.74991 5.8744 1.74995 5.47757 1.75 5.04476C1.75001 5.02988 1.75001 5.01496 1.75001 5.00001C1.75001 4.98505 1.75001 4.97013 1.75 4.95526C1.74995 4.52244 1.74991 4.12561 1.79331 3.8028C1.8411 3.44732 1.95355 3.07159 2.26257 2.76257C2.57159 2.45355 2.94732 2.3411 3.3028 2.29331C3.62561 2.24991 4.02244 2.24995 4.45526 2.25ZM4.75001 7.75001V13C4.75001 14.9068 4.7516 16.2615 4.88977 17.2892C5.02503 18.2952 5.2787 18.8749 5.70191 19.2981C6.12512 19.7213 6.70477 19.975 7.71086 20.1102C8.73852 20.2484 10.0932 20.25 12 20.25H13C14.9068 20.25 16.2615 20.2484 17.2892 20.1102C18.2952 19.975 18.8749 19.7213 19.2981 19.2981C19.7213 18.8749 19.975 18.2952 20.1102 17.2892C20.2484 16.2615 20.25 14.9068 20.25 13V7.75001H4.75001ZM3.32324 3.82324L3.32568 3.82187C3.32761 3.82086 3.33093 3.81924 3.33597 3.81717C3.35775 3.80821 3.40611 3.79291 3.50267 3.77993C3.71339 3.7516 4.0074 3.75001 4.50001 3.75001H20.5C20.9926 3.75001 21.2866 3.7516 21.4973 3.77993C21.5939 3.79291 21.6423 3.80821 21.664 3.81717C21.6691 3.81924 21.6724 3.82086 21.6743 3.82187L21.6768 3.82323L21.6781 3.82568C21.6792 3.82761 21.6808 3.83093 21.6828 3.83597C21.6918 3.85775 21.7071 3.90611 21.7201 4.00267C21.7484 4.21339 21.75 4.5074 21.75 5.00001C21.75 5.49261 21.7484 5.78662 21.7201 5.99734C21.7071 6.0939 21.6918 6.14226 21.6828 6.16404C21.6808 6.16909 21.6792 6.1724 21.6781 6.17434L21.6768 6.17678L21.6743 6.17815C21.6724 6.17916 21.6691 6.18077 21.664 6.18285C21.6423 6.19181 21.5939 6.2071 21.4973 6.22008C21.2866 6.24841 20.9926 6.25001 20.5 6.25001H4.50001C4.0074 6.25001 3.71339 6.24841 3.50267 6.22008C3.40611 6.2071 3.35775 6.19181 3.33597 6.18285C3.33093 6.18077 3.32761 6.17916 3.32568 6.17815L3.32324 6.17677L3.32187 6.17434C3.32086 6.1724 3.31924 6.16909 3.31717 6.16404C3.30821 6.14226 3.29291 6.0939 3.27993 5.99734C3.2516 5.78662 3.25001 5.49261 3.25001 5.00001C3.25001 4.5074 3.2516 4.21339 3.27993 4.00267C3.29291 3.90611 3.30821 3.85775 3.31717 3.83597C3.31924 3.83093 3.32086 3.82761 3.32187 3.82568L3.32324 3.82324ZM3.32324 6.17677C3.32284 6.17636 3.32297 6.17644 3.32324 6.17677V6.17677ZM10.9782 9.75001H14.0218C14.236 9.74999 14.4329 9.74998 14.5982 9.76126C14.7759 9.77338 14.9712 9.80099 15.1697 9.88322C15.5985 10.0608 15.9392 10.4015 16.1168 10.8303C16.199 11.0288 16.2266 11.2242 16.2388 11.4018C16.25 11.5671 16.25 11.764 16.25 11.9782V12.0218C16.25 12.236 16.25 12.4329 16.2388 12.5982C16.2266 12.7759 16.199 12.9712 16.1168 13.1697C15.9392 13.5985 15.5985 13.9392 15.1697 14.1168C14.9712 14.199 14.7759 14.2266 14.5982 14.2388C14.4329 14.25 14.236 14.25 14.0218 14.25H10.9782C10.764 14.25 10.5671 14.25 10.4018 14.2388C10.2242 14.2266 10.0288 14.199 9.83031 14.1168C9.40151 13.9392 9.06083 13.5985 8.88322 13.1697C8.80099 12.9712 8.77338 12.7759 8.76126 12.5982C8.74998 12.4329 8.74999 12.236 8.75001 12.0218V11.9782C8.74999 11.764 8.74998 11.5671 8.76126 11.4018C8.77338 11.2242 8.80099 11.0288 8.88322 10.8303C9.06083 10.4015 9.40151 10.0608 9.83031 9.88322C10.0288 9.80099 10.2242 9.77338 10.4018 9.76126C10.5671 9.74998 10.764 9.74999 10.9782 9.75001ZM10.4013 11.2703C10.3425 11.2956 10.2956 11.3425 10.2703 11.4013C10.2684 11.4087 10.2623 11.4371 10.2578 11.5039C10.2504 11.6119 10.25 11.7568 10.25 12C10.25 12.2432 10.2504 12.3881 10.2578 12.4961C10.2623 12.5629 10.2684 12.5913 10.2703 12.5987C10.2956 12.6575 10.3425 12.7044 10.4013 12.7297C10.4087 12.7316 10.4371 12.7377 10.5039 12.7422C10.6119 12.7496 10.7568 12.75 11 12.75H14C14.2432 12.75 14.3881 12.7496 14.4961 12.7422C14.5629 12.7377 14.5913 12.7316 14.5987 12.7297C14.6575 12.7044 14.7044 12.6575 14.7297 12.5987C14.7316 12.5913 14.7377 12.5629 14.7422 12.4961C14.7496 12.3881 14.75 12.2432 14.75 12C14.75 11.7568 14.7496 11.6119 14.7422 11.5039C14.7377 11.4371 14.7316 11.4087 14.7297 11.4013C14.7044 11.3425 14.6575 11.2956 14.5987 11.2703C14.5913 11.2684 14.5629 11.2623 14.4961 11.2578C14.3881 11.2504 14.2432 11.25 14 11.25H11C10.7568 11.25 10.6119 11.2504 10.5039 11.2578C10.4371 11.2623 10.4087 11.2684 10.4013 11.2703Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const RightOutlined = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2273 4.55806C11.4714 4.31398 11.8671 4.31398 12.1112 4.55806L17.1112 9.55806C17.3553 9.80214 17.3553 10.1979 17.1112 10.4419L12.1112 15.4419C11.8671 15.686 11.4714 15.686 11.2273 15.4419C10.9833 15.1979 10.9833 14.8021 11.2273 14.5581L15.1604 10.625H3.33594C2.99076 10.625 2.71094 10.3452 2.71094 10C2.71094 9.65482 2.99076 9.375 3.33594 9.375H15.1604L11.2273 5.44194C10.9833 5.19786 10.9833 4.80214 11.2273 4.55806Z"
        fill="#4B5563"
      />
    </svg>
  )
}
export const AntSelectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.76911 5.81995C2.93759 5.62339 3.23351 5.60063 3.43007 5.76911L7.50001 9.25763L11.57 5.76911C11.7665 5.60063 12.0624 5.62339 12.2309 5.81995C12.3994 6.01651 12.3766 6.31243 12.1801 6.48091L7.80507 10.2309C7.62953 10.3814 7.37049 10.3814 7.19495 10.2309L2.81995 6.48091C2.62339 6.31243 2.60063 6.01651 2.76911 5.81995Z"
        fill="#1C274C"
      />
    </svg>
  )
}
export const PencilV2Icon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0992 2.39109C15.6207 0.869636 18.0875 0.869636 19.6089 2.39109C21.1304 3.91255 21.1304 6.37932 19.6089 7.90077L12.0149 15.4948C11.5869 15.9228 11.3255 16.1842 11.0342 16.4115C10.691 16.6792 10.3196 16.9087 9.92667 17.096C9.59315 17.2549 9.24244 17.3718 8.66818 17.5632L5.99553 18.4541L5.35386 18.668C4.77951 18.8594 4.14629 18.7099 3.7182 18.2818C3.2901 17.8537 3.14062 17.2205 3.33207 16.6462L4.43683 13.3318C4.62822 12.7576 4.7451 12.4069 4.90405 12.0734C5.09132 11.6804 5.32084 11.309 5.58856 10.9658C5.81578 10.6745 6.07719 10.4131 6.50525 9.98509L14.0992 2.39109ZM5.96092 16.8845L5.11556 16.0391L5.84398 13.8538C6.05606 13.2176 6.14366 12.9589 6.25814 12.7187C6.39854 12.4241 6.57061 12.1457 6.77132 11.8883C6.93497 11.6785 7.12718 11.4845 7.60141 11.0102L13.4924 5.11927C13.7355 5.72927 14.147 6.46549 14.8408 7.15927C15.5345 7.85306 16.2708 8.26447 16.8807 8.50764L10.9898 14.3986C10.5155 14.8728 10.3215 15.065 10.1117 15.2287C9.85436 15.4294 9.57594 15.6015 9.28134 15.7419C9.04113 15.8564 8.78244 15.944 8.14619 16.156L5.96092 16.8845ZM18.076 7.31241C17.9521 7.28522 17.7973 7.24432 17.6213 7.18325C17.1373 7.01532 16.5006 6.69778 15.9014 6.09861C15.3022 5.49944 14.9847 4.86276 14.8168 4.37873C14.7557 4.2027 14.7148 4.04787 14.6876 3.92404L15.1599 3.45175C16.0956 2.51608 17.6126 2.51608 18.5483 3.45175C19.4839 4.38742 19.4839 5.90444 18.5483 6.84011L18.076 7.31241ZM3.25002 22C3.25002 21.5858 3.58581 21.25 4.00002 21.25H20V22.75H4.00002C3.58581 22.75 3.25002 22.4142 3.25002 22Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const PencilFillV2Icon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16666 14.6667C2.16666 14.3905 2.39051 14.1667 2.66666 14.1667H13.3333C13.6095 14.1667 13.8333 14.3905 13.8333 14.6667C13.8333 14.9428 13.6095 15.1667 13.3333 15.1667H2.66666C2.39051 15.1667 2.16666 14.9428 2.16666 14.6667Z"
        fill="currentColor"
      />
      <path
        d="M7.68003 9.95263L7.68004 9.95262L11.6245 6.00816C11.0877 5.78473 10.4518 5.4177 9.85047 4.81636C9.24903 4.21492 8.88199 3.57897 8.65856 3.04208L4.71403 6.98661L4.71402 6.98662C4.40621 7.29443 4.2523 7.44834 4.11994 7.61804C3.9638 7.81823 3.82993 8.03483 3.72071 8.26401C3.62811 8.45829 3.55928 8.66478 3.42162 9.07777L2.6957 11.2555C2.62795 11.4588 2.68085 11.6828 2.83233 11.8343C2.98381 11.9858 3.20787 12.0387 3.41111 11.971L5.58889 11.245C6.00186 11.1074 6.20836 11.0385 6.40264 10.9459C6.63183 10.8367 6.84843 10.7029 7.04861 10.5467C7.21831 10.4144 7.37223 10.2604 7.68003 9.95263Z"
        fill="currentColor"
      />
      <path
        d="M12.719 4.91363C13.5381 4.09458 13.5381 2.76665 12.719 1.94761C11.9 1.12857 10.5721 1.12857 9.75303 1.94761L9.27994 2.4207C9.28642 2.44026 9.29314 2.46009 9.30011 2.48018C9.47351 2.97999 9.80068 3.6352 10.4162 4.25067C11.0316 4.86615 11.6868 5.19332 12.1866 5.36672C12.2066 5.37366 12.2264 5.38035 12.2459 5.3868L12.719 4.91363Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const DiscussionIcon = ({ className }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5 2.75C7.39137 2.75 3.25 6.89137 3.25 12C3.25 13.4811 3.59753 14.8788 4.2148 16.1181C4.46254 16.6155 4.55794 17.2103 4.40163 17.7945L3.80602 20.0205C3.69663 20.4293 4.07066 20.8034 4.47949 20.694L6.70553 20.0984C7.28973 19.9421 7.88451 20.0375 8.38191 20.2852C9.62121 20.9025 11.0189 21.25 12.5 21.25C17.6086 21.25 21.75 17.1086 21.75 12C21.75 6.89137 17.6086 2.75 12.5 2.75ZM1.75 12C1.75 6.06294 6.56294 1.25 12.5 1.25C18.4371 1.25 23.25 6.06294 23.25 12C23.25 17.9371 18.4371 22.75 12.5 22.75C10.7817 22.75 9.15552 22.3463 7.71315 21.6279C7.49791 21.5207 7.27814 21.4979 7.09324 21.5474L4.8672 22.143C3.34337 22.5507 1.94927 21.1566 2.357 19.6328L2.9526 17.4068C3.00208 17.2219 2.97933 17.0021 2.87213 16.7869C2.15371 15.3445 1.75 13.7183 1.75 12ZM7.75 10.5C7.75 10.0858 8.08579 9.75 8.5 9.75H16.5C16.9142 9.75 17.25 10.0858 17.25 10.5C17.25 10.9142 16.9142 11.25 16.5 11.25H8.5C8.08579 11.25 7.75 10.9142 7.75 10.5ZM7.75 14C7.75 13.5858 8.08579 13.25 8.5 13.25H14C14.4142 13.25 14.75 13.5858 14.75 14C14.75 14.4142 14.4142 14.75 14 14.75H8.5C8.08579 14.75 7.75 14.4142 7.75 14Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const NoCertificationIcon = ({ className }: IIconProps) => {
  return (
    <svg
      width="125.55"
      height="125.55"
      viewBox="0 0 185 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_d_4398_26737)">
        <rect
          x="20"
          y="33.646"
          width="125.551"
          height="125.55"
          rx="19.6025"
          fill="white"
        />
        <rect
          x="32.5801"
          y="46.13"
          width="100.428"
          height="9.56452"
          rx="4.78226"
          fill="#F3F4F6"
        />
      </g>
      <rect
        x="32.5801"
        y="64.576"
        width="90.8634"
        height="9.56452"
        rx="4.78226"
        fill="#F6F6F6"
      />
      <rect
        x="32.2705"
        y="82.8518"
        width="52.6051"
        height="9.56452"
        rx="4.78226"
        fill="#F6F6F6"
      />
      <rect
        x="32.2974"
        y="101.469"
        width="52.6051"
        height="43.0403"
        rx="7"
        fill="#F6F6F6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M128.936 126.006C133.712 122.438 136.798 116.785 136.798 110.42C136.798 99.6281 127.927 90.8799 116.985 90.8799C106.043 90.8799 97.1731 99.6281 97.1731 110.42C97.1731 117.06 100.531 122.926 105.664 126.457V136.318C105.664 138.61 108.13 140.055 110.129 138.936L117.3 134.922L124.47 138.936C126.47 140.055 128.936 138.61 128.936 136.318V126.006Z"
        fill="#E5E7EB"
      />
      <g filter="url(#filter1_d_4398_26737)">
        <rect
          x="110.463"
          y="18.8037"
          width="49.5369"
          height="49.5367"
          rx="12.0848"
          fill="white"
        />
        <path
          d="M138.418 36.696C137.742 35.376 136.68 34.716 135.232 34.716C133.783 34.716 132.709 35.376 132.009 36.696C131.333 38.016 130.995 40.308 130.995 43.572C130.995 46.836 131.333 49.128 132.009 50.448C132.709 51.768 133.783 52.428 135.232 52.428C136.68 52.428 137.742 51.768 138.418 50.448C139.118 49.128 139.468 46.836 139.468 43.572C139.468 40.308 139.118 38.016 138.418 36.696ZM143.125 53.904C141.411 56.016 138.78 57.072 135.232 57.072C131.683 57.072 129.04 56.016 127.302 53.904C125.589 51.792 124.732 48.348 124.732 43.572C124.732 38.796 125.589 35.352 127.302 33.24C129.04 31.128 131.683 30.072 135.232 30.072C138.78 30.072 141.411 31.128 143.125 33.24C144.863 35.352 145.732 38.796 145.732 43.572C145.732 48.348 144.863 51.792 143.125 53.904Z"
          fill="#E5E7EB"
        />
      </g>
      <ellipse
        cx="116.985"
        cy="110.179"
        rx="12.9805"
        ry="12.9804"
        fill="#FEFEFE"
      />
      <defs>
        <filter
          id="filter0_d_4398_26737"
          x="0"
          y="18.646"
          width="165.551"
          height="165.55"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4398_26737"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4398_26737"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_4398_26737"
          x="86.2935"
          y="0.676461"
          width="97.8762"
          height="97.8761"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.04242" />
          <feGaussianBlur stdDeviation="12.0848" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4398_26737"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4398_26737"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
export const ComingSoonIcon = ({ className }: IIconProps) => {
  return (
    <svg
      width="168"
      height="138"
      viewBox="0 0 168 138"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_d_10196_107162)">
        <rect
          x="12.5"
          y="9.63477"
          width="131.723"
          height="112.731"
          rx="12.0098"
          fill="white"
        />
        <circle cx="25.978" cy="21.2749" r="2.45067" fill="#E5E7EB" />
        <circle cx="33.9429" cy="21.2749" r="2.45067" fill="#E5E7EB" />
        <circle cx="41.9077" cy="21.2749" r="2.45067" fill="#E5E7EB" />
        <rect
          x="16.1758"
          y="29.2402"
          width="124.984"
          height="6.12667"
          rx="3.06334"
          fill="#F2F3F5"
        />
        <rect
          x="66.4141"
          y="48.2324"
          width="28.5233"
          height="27.0221"
          rx="4.50368"
          fill="#F7F7F7"
        />
        <rect
          x="23.5273"
          y="79.4785"
          width="34.3094"
          height="30.6334"
          rx="4.50368"
          fill="#F7F7F7"
        />
        <rect
          x="23.5273"
          y="48.2324"
          width="34.3094"
          height="13.4787"
          rx="4.50368"
          fill="#F7F7F7"
        />
        <rect
          x="66.4141"
          y="96.6338"
          width="20.2666"
          height="13.511"
          rx="4.50368"
          fill="#F7F7F7"
        />
        <rect
          x="99.3477"
          y="81.9297"
          width="32.4714"
          height="28.1827"
          rx="4.50368"
          fill="#F7F7F7"
        />
      </g>
      <g filter="url(#filter1_d_10196_107162)">
        <rect
          x="108.078"
          y="43.9443"
          width="44.4239"
          height="44.4239"
          rx="7.40398"
          fill="white"
        />
        <g clip-path="url(#clip0_10196_107162)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M130.292 54.113C123.641 54.113 118.25 59.5048 118.25 66.1558C118.25 72.8068 123.641 78.1985 130.292 78.1985C136.944 78.1985 142.335 72.8068 142.335 66.1558C142.335 59.5048 136.944 54.113 130.292 54.113ZM116.297 66.1558C116.297 58.4262 122.563 52.1602 130.292 52.1602C138.022 52.1602 144.288 58.4262 144.288 66.1558C144.288 73.8853 138.022 80.1514 130.292 80.1514C122.563 80.1514 116.297 73.8853 116.297 66.1558ZM130.292 59.9717C130.832 59.9717 131.269 60.4088 131.269 60.9481V65.7513L134.238 68.7201C134.619 69.1014 134.619 69.7197 134.238 70.101C133.856 70.4823 133.238 70.4823 132.857 70.101L129.602 66.8462C129.419 66.6631 129.316 66.4147 129.316 66.1558V60.9481C129.316 60.4088 129.753 59.9717 130.292 59.9717Z"
            fill="#E5E7EB"
            stroke="#E5E7EB"
            stroke-width="1.53167"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_10196_107162"
          x="0.246654"
          y="0.444756"
          width="156.229"
          height="137.237"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.06334" />
          <feGaussianBlur stdDeviation="6.12667" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10196_107162"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10196_107162"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_10196_107162"
          x="93.2702"
          y="32.8384"
          width="74.0417"
          height="74.0398"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.70199" />
          <feGaussianBlur stdDeviation="7.40398" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10196_107162"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10196_107162"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_10196_107162">
          <rect
            width="31.246"
            height="31.246"
            fill="white"
            transform="translate(114.668 50.5332)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ChapterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M7.75 7C7.75 6.58579 8.08579 6.25 8.5 6.25H16.5C16.9142 6.25 17.25 6.58579 17.25 7C17.25 7.41422 16.9142 7.75 16.5 7.75H8.5C8.08579 7.75 7.75 7.41422 7.75 7Z"
        fill="white"
      />
      <path
        d="M8.5 9.75C8.08579 9.75 7.75 10.0858 7.75 10.5C7.75 10.9142 8.08579 11.25 8.5 11.25H13.5C13.9142 11.25 14.25 10.9142 14.25 10.5C14.25 10.0858 13.9142 9.75 13.5 9.75H8.5Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.4451 1.25C9.07754 1.24998 7.97521 1.24996 7.10825 1.36652C6.20814 1.48754 5.45027 1.74643 4.84835 2.34835C4.24643 2.95027 3.98754 3.70814 3.86652 4.60825C3.74996 5.47521 3.74998 6.57753 3.75 7.94512V16.0549C3.74998 17.4225 3.74996 18.5248 3.86652 19.3918C3.98754 20.2919 4.24643 21.0497 4.84835 21.6517C5.45027 22.2536 6.20814 22.5125 7.10825 22.6335C7.97522 22.75 9.07754 22.75 10.4451 22.75H14.5549C15.9225 22.75 17.0248 22.75 17.8918 22.6335C18.7919 22.5125 19.5497 22.2536 20.1517 21.6517C20.7536 21.0497 21.0125 20.2919 21.1335 19.3918C21.25 18.5248 21.25 17.4225 21.25 16.0549V7.94513C21.25 6.57754 21.25 5.47522 21.1335 4.60825C21.0125 3.70814 20.7536 2.95027 20.1517 2.34835C19.5497 1.74643 18.7919 1.48754 17.8918 1.36652C17.0248 1.24996 15.9225 1.24998 14.5549 1.25H10.4451ZM5.90901 3.40901C6.18577 3.13225 6.57435 2.9518 7.30812 2.85315C8.06347 2.75159 9.06459 2.75 10.5 2.75H14.5C15.9354 2.75 16.9365 2.75159 17.6919 2.85315C18.4257 2.9518 18.8142 3.13225 19.091 3.40901C19.3678 3.68577 19.5482 4.07435 19.6469 4.80812C19.7484 5.56347 19.75 6.56459 19.75 8V15.25L8.28198 15.25C7.46402 15.2497 6.90587 15.2495 6.42721 15.3778C5.99923 15.4925 5.60224 15.6798 5.25 15.9259V8C5.25 6.56459 5.25159 5.56347 5.35315 4.80812C5.4518 4.07435 5.63225 3.68577 5.90901 3.40901ZM5.27676 18.2491C5.29196 18.6029 5.31579 18.914 5.35315 19.1919C5.4518 19.9257 5.63225 20.3142 5.90901 20.591C6.18577 20.8678 6.57435 21.0482 7.30812 21.1469C8.06347 21.2484 9.06459 21.25 10.5 21.25H14.5C15.9354 21.25 16.9365 21.2484 17.6919 21.1469C18.4257 21.0482 18.8142 20.8678 19.091 20.591C19.3678 20.3142 19.5482 19.9257 19.6469 19.1919C19.7297 18.5756 19.746 17.7958 19.7492 16.75H8.39778C7.41952 16.75 7.07752 16.7564 6.81544 16.8267C6.09612 17.0194 5.52268 17.5541 5.27676 18.2491Z"
        fill="white"
      />
    </svg>
  )
}

export const FilterCourseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.25 7.5C18.25 9.57107 16.5711 11.25 14.5 11.25C12.4289 11.25 10.75 9.57107 10.75 7.5C10.75 5.42893 12.4289 3.75 14.5 3.75C16.5711 3.75 18.25 5.42893 18.25 7.5ZM14.5 9.75C15.7426 9.75 16.75 8.74264 16.75 7.5C16.75 6.25736 15.7426 5.25 14.5 5.25C13.2574 5.25 12.25 6.25736 12.25 7.5C12.25 8.74264 13.2574 9.75 14.5 9.75Z"
        fill="#1C274C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.75 17.5C5.75 19.5711 7.42893 21.25 9.5 21.25C11.5711 21.25 13.25 19.5711 13.25 17.5C13.25 15.4289 11.5711 13.75 9.5 13.75C7.42893 13.75 5.75 15.4289 5.75 17.5ZM9.5 19.75C8.25736 19.75 7.25 18.7426 7.25 17.5C7.25 16.2574 8.25736 15.25 9.5 15.25C10.7426 15.25 11.75 16.2574 11.75 17.5C11.75 18.7426 10.7426 19.75 9.5 19.75Z"
        fill="#1C274C"
      />
      <path
        d="M14.25 17.4585C14.25 17.0443 14.5858 16.7085 15 16.7085H22C22.4142 16.7085 22.75 17.0443 22.75 17.4585C22.75 17.8727 22.4142 18.2085 22 18.2085H15C14.5858 18.2085 14.25 17.8727 14.25 17.4585Z"
        fill="#1C274C"
      />
      <path
        d="M9 6.70852C9.41421 6.70852 9.75 7.04431 9.75 7.45852C9.75 7.87273 9.41421 8.20852 9 8.20852L2 8.20852C1.58579 8.20852 1.25 7.87273 1.25 7.45852C1.25 7.04431 1.58579 6.70852 2 6.70852L9 6.70852Z"
        fill="#1C274C"
      />
      <path
        d="M1.25 17.4585C1.25 17.0443 1.58579 16.7085 2 16.7085H4C4.41421 16.7085 4.75 17.0443 4.75 17.4585C4.75 17.8727 4.41421 18.2085 4 18.2085H2C1.58579 18.2085 1.25 17.8727 1.25 17.4585Z"
        fill="#1C274C"
      />
      <path
        d="M22 6.70852C22.4142 6.70852 22.75 7.04431 22.75 7.45852C22.75 7.87273 22.4142 8.20852 22 8.20852H20C19.5858 8.20852 19.25 7.87273 19.25 7.45852C19.25 7.04431 19.5858 6.70852 20 6.70852H22Z"
        fill="#1C274C"
      />
    </svg>
  )
}

export const AltArrowLeft = ({ className }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4881 4.43057C15.8026 4.70014 15.839 5.17361 15.5694 5.48811L9.98781 12L15.5694 18.5119C15.839 18.8264 15.8026 19.2999 15.4881 19.5695C15.1736 19.839 14.7001 19.8026 14.4306 19.4881L8.43056 12.4881C8.18981 12.2072 8.18981 11.7928 8.43056 11.5119L14.4306 4.51192C14.7001 4.19743 15.1736 4.161 15.4881 4.43057Z"
      fill="#1F2937"
    />
  </svg>
)

export const EssentialIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.75 7C22.75 7.41421 22.4142 7.75 22 7.75L2 7.75C1.58579 7.75 1.25 7.41421 1.25 7C1.25 6.58579 1.58579 6.25 2 6.25L22 6.25C22.4142 6.25 22.75 6.58579 22.75 7Z"
        fill="#1C274C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.75 12C19.75 12.4142 19.4142 12.75 19 12.75L5 12.75C4.58579 12.75 4.25 12.4142 4.25 12C4.25 11.5858 4.58579 11.25 5 11.25L19 11.25C19.4142 11.25 19.75 11.5858 19.75 12Z"
        fill="#1C274C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17Z"
        fill="#1C274C"
      />
    </svg>
  )
}

export const CheckIconV2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1084 5.39155C17.3525 5.63563 17.3525 6.03136 17.1084 6.27544L9.95359 13.4302C9.05867 14.3252 7.60767 14.3252 6.71272 13.4302L3.72456 10.4421C3.48049 10.198 3.48049 9.80233 3.72456 9.55824C3.96864 9.31416 4.36437 9.31416 4.60844 9.55824L7.5966 12.5464C8.00339 12.9532 8.66292 12.9532 9.06975 12.5464L16.2246 5.39155C16.4687 5.14748 16.8643 5.14748 17.1084 5.39155Z"
        fill="#FFB800"
      />
    </svg>
  )
}

export const EllipsisIconV2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12Z"
        fill="#1C274C"
      />
      <path
        d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
        fill="#1C274C"
      />
      <path
        d="M21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12Z"
        fill="#1C274C"
      />
    </svg>
  )
}

export const MobileNotFriendlyIcon = ({
  className,
}: {
  className?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="89"
      height="88"
      viewBox="0 0 89 88"
      fill="none"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.8085 5.34595H44.4345C38.4285 5.34595 33.6655 5.34595 29.9475 5.85195C26.1195 6.37995 23.0175 7.47995 20.5645 9.96595C18.1225 12.4519 17.0335 15.6089 16.5165 19.5139C16.0105 23.2979 16.0215 28.1379 16.0215 34.2539V55.6269C16.0215 61.7429 16.0215 66.583 16.5165 70.367C17.0335 74.2609 18.1225 77.418 20.5645 79.9149C23.0065 82.4009 26.1085 83.5119 29.9475 84.0289C33.6765 84.535 38.4285 84.535 44.4345 84.535H44.8085C50.8145 84.535 55.5775 84.535 59.2955 84.0289C63.1235 83.5009 66.2255 82.4009 68.6785 79.9149C71.1205 77.4289 72.2095 74.2719 72.7265 70.367C73.2325 66.583 73.2325 61.7429 73.2325 55.6269V34.2539C73.2325 28.1379 73.2325 23.2979 72.7265 19.5139C72.2095 15.6199 71.1205 12.4629 68.6785 9.96595C66.2365 7.47995 63.1345 6.36895 59.2955 5.85195C55.5665 5.34595 50.8145 5.34595 44.8085 5.34595ZM32.3675 72.0719C32.3675 70.6969 33.4675 69.575 34.8205 69.575H54.4335C55.7865 69.575 56.8865 70.6969 56.8865 72.0719C56.8865 73.4469 55.7865 74.5689 54.4335 74.5689H34.8205C33.4675 74.5689 32.3675 73.4469 32.3675 72.0719Z"
        fill="#FFB700"
      />
      <path
        d="M44.5996 14.7949C46.1184 14.7949 47.3496 13.5637 47.3496 12.0449C47.3496 10.5261 46.1184 9.29492 44.5996 9.29492C43.0808 9.29492 41.8496 10.5261 41.8496 12.0449C41.8496 13.5637 43.0808 14.7949 44.5996 14.7949Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M36.5605 32.7612C37.7089 31.6128 39.5562 31.6128 40.7046 32.7612L44.4992 36.5558L48.2938 32.7612C49.4422 31.6128 51.2896 31.6128 52.4379 32.7612C53.5863 33.9095 53.5863 35.7569 52.4379 36.9053L48.6433 40.6999L52.4379 44.4945C53.5863 45.6429 53.5863 47.4903 52.4379 48.6386C51.2896 49.787 49.4422 49.787 48.2938 48.6386L44.4992 44.844L40.7046 48.6386C39.5562 49.787 37.7089 49.787 36.5605 48.6386C35.4121 47.4903 35.4121 45.6429 36.5605 44.4945L40.3551 40.6999L36.5605 36.9053C35.4121 35.7569 35.4121 33.9095 36.5605 32.7612Z"
        fill="white"
      />
    </svg>
  )
}

export const MenuDotsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M12.5 15.8889C11.6716 15.8889 11 16.5853 11 17.4444C11 18.3036 11.6716 19 12.5 19C13.3284 19 14 18.3036 14 17.4444C14 16.5853 13.3284 15.8889 12.5 15.8889Z"
        fill="currentColor"
      />
      <path
        d="M12.5 10.4444C11.6716 10.4444 11 11.1409 11 12C11 12.8591 11.6716 13.5556 12.5 13.5556C13.3284 13.5556 14 12.8591 14 12C14 11.1409 13.3284 10.4444 12.5 10.4444Z"
        fill="currentColor"
      />
      <path
        d="M12.5 5C11.6716 5 11 5.69645 11 6.55556C11 7.41467 11.6716 8.11111 12.5 8.11111C13.3284 8.11111 14 7.41467 14 6.55556C14 5.69645 13.3284 5 12.5 5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ArrowActionSearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.4999 7.75V3.75C18.4999 3.33579 18.8357 3 19.2499 3C19.6642 3 19.9999 3.33579 19.9999 3.75V7.75C19.9999 12.5825 16.0824 15.5 11.2499 15.5H6.56049L10.0537 18.9922C10.3465 19.2851 10.3465 19.7608 10.0537 20.0537C9.76076 20.3466 9.28502 20.3466 8.99213 20.0537L4.21967 15.2803C3.92678 14.9874 3.92678 14.5126 4.21967 14.2197L8.99213 9.44629C9.28502 9.1534 9.76076 9.1534 10.0537 9.44629C10.3465 9.73918 10.3465 10.2149 10.0537 10.5078L6.56049 14H11.2499C15.254 14 18.4999 11.7541 18.4999 7.75Z"
        fill="#4B5563"
      />
    </svg>
  )
}

export const OutlineArchive = ({ className }: ISVG) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.95526 2.25C3.97013 2.25001 3.98505 2.25001 4.00001 2.25001L20.0448 2.25C20.4776 2.24995 20.8744 2.24991 21.1972 2.29331C21.5527 2.3411 21.9284 2.45355 22.2374 2.76257C22.5465 3.07159 22.6589 3.44732 22.7067 3.8028C22.7501 4.12561 22.7501 4.52245 22.75 4.95526V5.04475C22.7501 5.47757 22.7501 5.8744 22.7067 6.19721C22.6589 6.55269 22.5465 6.92842 22.2374 7.23744C21.9437 7.53121 21.5896 7.64733 21.25 7.69914V13.0564C21.25 14.8942 21.25 16.3498 21.0969 17.489C20.9392 18.6615 20.6071 19.6104 19.8588 20.3588C19.1104 21.1071 18.1615 21.4392 16.989 21.5969C15.8498 21.75 14.3942 21.75 12.5564 21.75H11.4436C9.60583 21.75 8.1502 21.75 7.01098 21.5969C5.83856 21.4392 4.88961 21.1071 4.14125 20.3588C3.39289 19.6104 3.06077 18.6615 2.90314 17.489C2.74998 16.3498 2.74999 14.8942 2.75001 13.0564L2.75001 7.69914C2.41038 7.64733 2.05634 7.53121 1.76257 7.23744C1.45355 6.92842 1.3411 6.55269 1.29331 6.19721C1.24991 5.8744 1.24995 5.47757 1.25 5.04476C1.25001 5.02988 1.25001 5.01496 1.25001 5.00001C1.25001 4.98505 1.25001 4.97013 1.25 4.95526C1.24995 4.52244 1.24991 4.12561 1.29331 3.8028C1.3411 3.44732 1.45355 3.07159 1.76257 2.76257C2.07159 2.45355 2.44732 2.3411 2.8028 2.29331C3.12561 2.24991 3.52244 2.24995 3.95526 2.25ZM4.25001 7.75001V13C4.25001 14.9068 4.2516 16.2615 4.38977 17.2892C4.52503 18.2952 4.7787 18.8749 5.20191 19.2981C5.62512 19.7213 6.20477 19.975 7.21086 20.1102C8.23852 20.2484 9.59319 20.25 11.5 20.25H12.5C14.4068 20.25 15.7615 20.2484 16.7892 20.1102C17.7952 19.975 18.3749 19.7213 18.7981 19.2981C19.2213 18.8749 19.475 18.2952 19.6102 17.2892C19.7484 16.2615 19.75 14.9068 19.75 13V7.75001H4.25001ZM2.82324 3.82324L2.82568 3.82187C2.82761 3.82086 2.83093 3.81924 2.83597 3.81717C2.85775 3.80821 2.90611 3.79291 3.00267 3.77993C3.21339 3.7516 3.5074 3.75001 4.00001 3.75001H20C20.4926 3.75001 20.7866 3.7516 20.9973 3.77993C21.0939 3.79291 21.1423 3.80821 21.164 3.81717C21.1691 3.81924 21.1724 3.82086 21.1743 3.82187L21.1768 3.82323L21.1781 3.82568C21.1792 3.82761 21.1808 3.83093 21.1828 3.83597C21.1918 3.85775 21.2071 3.90611 21.2201 4.00267C21.2484 4.21339 21.25 4.5074 21.25 5.00001C21.25 5.49261 21.2484 5.78662 21.2201 5.99734C21.2071 6.0939 21.1918 6.14226 21.1828 6.16404C21.1808 6.16909 21.1792 6.1724 21.1781 6.17434L21.1768 6.17678L21.1743 6.17815C21.1724 6.17916 21.1691 6.18077 21.164 6.18285C21.1423 6.19181 21.0939 6.2071 20.9973 6.22008C20.7866 6.24841 20.4926 6.25001 20 6.25001H4.00001C3.5074 6.25001 3.21339 6.24841 3.00267 6.22008C2.90611 6.2071 2.85775 6.19181 2.83597 6.18285C2.83093 6.18077 2.82761 6.17916 2.82568 6.17815L2.82324 6.17677L2.82187 6.17434C2.82086 6.1724 2.81924 6.16909 2.81717 6.16404C2.80821 6.14226 2.79291 6.0939 2.77993 5.99734C2.7516 5.78662 2.75001 5.49261 2.75001 5.00001C2.75001 4.5074 2.7516 4.21339 2.77993 4.00267C2.79291 3.90611 2.80821 3.85775 2.81717 3.83597C2.81924 3.83093 2.82086 3.82761 2.82187 3.82568L2.82324 3.82324ZM2.82324 6.17677C2.82284 6.17636 2.82297 6.17644 2.82324 6.17677V6.17677ZM10.4782 9.75001H13.5218C13.736 9.74999 13.9329 9.74998 14.0982 9.76126C14.2759 9.77338 14.4712 9.80099 14.6697 9.88322C15.0985 10.0608 15.4392 10.4015 15.6168 10.8303C15.699 11.0288 15.7266 11.2242 15.7388 11.4018C15.75 11.5671 15.75 11.764 15.75 11.9782V12.0218C15.75 12.236 15.75 12.4329 15.7388 12.5982C15.7266 12.7759 15.699 12.9712 15.6168 13.1697C15.4392 13.5985 15.0985 13.9392 14.6697 14.1168C14.4712 14.199 14.2759 14.2266 14.0982 14.2388C13.9329 14.25 13.736 14.25 13.5218 14.25H10.4782C10.264 14.25 10.0671 14.25 9.9018 14.2388C9.72416 14.2266 9.52881 14.199 9.33031 14.1168C8.90151 13.9392 8.56083 13.5985 8.38322 13.1697C8.30099 12.9712 8.27338 12.7759 8.26126 12.5982C8.24998 12.4329 8.24999 12.236 8.25001 12.0218V11.9782C8.24999 11.764 8.24998 11.5671 8.26126 11.4018C8.27338 11.2242 8.30099 11.0288 8.38322 10.8303C8.56083 10.4015 8.90151 10.0608 9.33031 9.88322C9.52881 9.80099 9.72416 9.77338 9.9018 9.76126C10.0671 9.74998 10.264 9.74999 10.4782 9.75001ZM9.90131 11.2703C9.84248 11.2956 9.79559 11.3425 9.77031 11.4013C9.76844 11.4087 9.76234 11.4371 9.75778 11.5039C9.75041 11.6119 9.75001 11.7568 9.75001 12C9.75001 12.2432 9.75041 12.3881 9.75778 12.4961C9.76234 12.5629 9.76844 12.5913 9.77031 12.5987C9.79559 12.6575 9.84248 12.7044 9.90131 12.7297C9.90867 12.7316 9.93707 12.7377 10.0039 12.7422C10.1119 12.7496 10.2568 12.75 10.5 12.75H13.5C13.7432 12.75 13.8881 12.7496 13.9961 12.7422C14.0629 12.7377 14.0913 12.7316 14.0987 12.7297C14.1575 12.7044 14.2044 12.6575 14.2297 12.5987C14.2316 12.5913 14.2377 12.5629 14.2422 12.4961C14.2496 12.3881 14.25 12.2432 14.25 12C14.25 11.7568 14.2496 11.6119 14.2422 11.5039C14.2377 11.4371 14.2316 11.4087 14.2297 11.4013C14.2044 11.3425 14.1575 11.2956 14.0987 11.2703C14.0913 11.2684 14.0629 11.2623 13.9961 11.2578C13.8881 11.2504 13.7432 11.25 13.5 11.25H10.5C10.2568 11.25 10.1119 11.2504 10.0039 11.2578C9.93707 11.2623 9.90866 11.2684 9.90131 11.2703Z"
      fill="currentColor"
    />
  </svg>
)

export const MyCourseTeacherIcon = ({ selected }: { selected?: boolean }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M14.217 3.70326C12.796 3.03706 11.2035 3.03706 9.78252 3.70326L5.48919 5.71607C6.27114 5.80045 6.98602 6.29301 7.31789 7.06738C7.80739 8.20955 7.2783 9.53228 6.13613 10.0218L5.06046 10.4828C4.52594 10.7119 4.22261 10.8442 4.01782 10.9492C4.0167 10.9656 4.01564 10.9824 4.01465 10.9998L9.78261 13.704C11.2036 14.3702 12.7961 14.3702 14.2171 13.704L20.9082 10.567C22.3637 9.88466 22.3637 7.52261 20.9082 6.84025L14.217 3.70326Z"
        fill={selected ? '#FFB800' : '#9CA3AF'}
      />
      <path
        d="M4.9998 13.1183V16.829C4.9998 17.8371 5.50331 18.7808 6.38514 19.2692C7.85351 20.0824 10.2038 21.2036 11.9998 21.2036C13.7958 21.2036 16.1461 20.0824 17.6145 19.2692C18.4963 18.7808 18.9998 17.8371 18.9998 16.829V13.1184L14.8538 15.0621C13.0294 15.9174 10.9703 15.9174 9.14588 15.0621L4.9998 13.1183Z"
        fill={selected ? '#FFB800' : '#9CA3AF'}
      />
      <path
        d="M5.54544 8.64316C5.92616 8.48 6.10253 8.03909 5.93936 7.65837C5.7762 7.27764 5.33529 7.10128 4.95456 7.26445L3.84318 7.74075C3.28571 7.97965 2.81328 8.1821 2.44254 8.39067C2.04805 8.61259 1.70851 8.87305 1.45419 9.25875C1.19986 9.64444 1.09421 10.0591 1.04563 10.5091C0.999964 10.9321 0.999981 11.446 1 12.0525V14.9538C1 15.368 1.33579 15.7038 1.75 15.7038C2.16422 15.7038 2.5 15.368 2.5 14.9538V12.0914C2.5 11.4356 2.50101 11.0031 2.53696 10.6702C2.57095 10.3553 2.63046 10.1997 2.70645 10.0845C2.78244 9.96924 2.90202 9.85325 3.178 9.69799C3.46985 9.5338 3.867 9.3625 4.46976 9.10417L5.54544 8.64316Z"
        fill={selected ? '#FFB800' : '#9CA3AF'}
      />
    </svg>
  )
}
export const OutlineVideo = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.95202 1.0415H10.0477C11.9713 1.04149 13.4788 1.04148 14.6551 1.19963C15.859 1.36149 16.809 1.69928 17.5547 2.44495C18.3004 3.19063 18.6382 4.14065 18.8 5.34459C18.9582 6.52083 18.9582 8.02836 18.9582 9.95203V10.0476C18.9582 11.9713 18.9582 13.4788 18.8 14.6551C18.6382 15.859 18.3004 16.809 17.5547 17.5547C16.809 18.3004 15.859 18.6382 14.6551 18.8C13.4788 18.9582 11.9713 18.9582 10.0476 18.9582H9.95203C8.02836 18.9582 6.52083 18.9582 5.34459 18.8C4.14065 18.6382 3.19063 18.3004 2.44495 17.5547C1.69928 16.809 1.36149 15.859 1.19963 14.6551C1.04148 13.4788 1.04149 11.9713 1.0415 10.0477V9.95202C1.04149 8.02836 1.04148 6.52083 1.19963 5.34459C1.36149 4.14065 1.69928 3.19063 2.44495 2.44495C3.19063 1.69928 4.14065 1.36149 5.34459 1.19963C6.52083 1.04148 8.02836 1.04149 9.95202 1.0415ZM5.51115 2.43848C4.44582 2.58171 3.80355 2.85412 3.32883 3.32883C2.85412 3.80355 2.58171 4.44582 2.43848 5.51115C2.41585 5.67945 2.39671 5.85596 2.38051 6.0415H5.49008L7.87016 2.30138C6.9306 2.3158 6.15988 2.35126 5.51115 2.43848ZM9.33914 2.29177C9.32365 2.33541 9.30304 2.37799 9.27713 2.41872L6.97172 6.0415H10.9067L13.2656 2.33476C12.3796 2.29209 11.3121 2.2915 9.99984 2.2915C9.77236 2.2915 9.55224 2.29152 9.33914 2.29177ZM14.665 2.46399L12.3884 6.0415H17.6192C17.603 5.85596 17.5838 5.67945 17.5612 5.51115C17.418 4.44582 17.1456 3.80355 16.6708 3.32883C16.2229 2.88092 15.6259 2.61312 14.665 2.46399ZM17.6859 7.2915H11.2592C11.2526 7.29161 11.2459 7.29161 11.2393 7.2915H5.84252C5.8359 7.29161 5.82927 7.29161 5.82264 7.2915H2.31377C2.29188 8.05961 2.2915 8.95163 2.2915 9.99984C2.2915 11.9817 2.29283 13.4052 2.43848 14.4885C2.58171 15.5539 2.85412 16.1961 3.32883 16.6708C3.80355 17.1456 4.44582 17.418 5.51115 17.5612C6.59447 17.7068 8.01798 17.7082 9.99984 17.7082C11.9817 17.7082 13.4052 17.7068 14.4885 17.5612C15.5539 17.418 16.1961 17.1456 16.6708 16.6708C17.1456 16.1961 17.418 15.5539 17.5612 14.4885C17.7068 13.4052 17.7082 11.9817 17.7082 9.99984C17.7082 8.95163 17.7078 8.05961 17.6859 7.2915ZM11.14 9.9342L11.2247 9.98884C11.7412 10.322 12.1884 10.6105 12.5001 10.8862C12.8317 11.1795 13.1248 11.557 13.1248 12.0832C13.1248 12.6093 12.8317 12.9869 12.5001 13.2801C12.1884 13.5558 11.7412 13.8443 11.2247 14.1775L11.14 14.2321C10.6183 14.5689 10.1648 14.8615 9.78809 15.0288C9.39615 15.2028 8.89397 15.3282 8.41502 15.0239C7.96114 14.7355 7.82352 14.2434 7.76577 13.81C7.70812 13.3774 7.70814 12.806 7.70817 12.129V12.0374C7.70814 11.3604 7.70812 10.789 7.76577 10.3563C7.82352 9.92298 7.96114 9.4308 8.41502 9.14245C8.89397 8.83817 9.39615 8.96355 9.78809 9.13757C10.1648 9.30482 10.6183 9.59747 11.14 9.9342ZM9.0481 10.2096C9.0476 10.2089 9.05149 10.2079 9.06129 10.2085C9.05351 10.2105 9.04861 10.2102 9.0481 10.2096ZM9.08076 10.2109C9.11422 10.2166 9.17641 10.2337 9.28083 10.28C9.55715 10.4027 9.9277 10.6396 10.506 11.0127C11.0755 11.3801 11.4403 11.6176 11.672 11.8226C11.8854 12.0113 11.8757 12.0775 11.8749 12.0828C11.8757 12.0882 11.8854 12.1551 11.672 12.3438C11.4403 12.5487 11.0755 12.7862 10.506 13.1537C9.9277 13.5268 9.55715 13.7636 9.28083 13.8863C9.1764 13.9327 9.11422 13.9498 9.08075 13.9555C9.06225 13.9198 9.02997 13.8337 9.00482 13.6449C8.95952 13.305 8.95817 12.8183 8.95817 12.0832C8.95817 11.3481 8.95952 10.8614 9.00482 10.5214C9.02997 10.3327 9.06225 10.2465 9.08076 10.2109ZM9.0481 13.9568C9.04862 13.9561 9.05352 13.9558 9.06129 13.9579C9.05148 13.9585 9.04759 13.9574 9.0481 13.9568ZM9.09157 13.9733C9.09443 13.9757 9.09567 13.9774 9.09558 13.9776C9.09549 13.9778 9.09406 13.9766 9.09157 13.9733ZM9.09157 10.193C9.09406 10.1897 9.09549 10.1885 9.09558 10.1887C9.09567 10.189 9.09443 10.1906 9.09157 10.193Z"
      fill="#1C274C"
    />
  </svg>
)

export const CheckCircleOutlineYellow = ({
  className,
}: {
  className?: string
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6693 8.00065C14.6693 11.6825 11.6845 14.6673 8.0026 14.6673C4.32071 14.6673 1.33594 11.6825 1.33594 8.00065C1.33594 4.31875 4.32071 1.33398 8.0026 1.33398C11.6845 1.33398 14.6693 4.31875 14.6693 8.00065ZM10.6895 5.98043C10.8848 6.17569 10.8848 6.49228 10.6895 6.68754L7.35616 10.0209C7.1609 10.2161 6.84431 10.2161 6.64905 10.0209L5.31572 8.68754C5.12046 8.49228 5.12046 8.17569 5.31572 7.98043C5.51098 7.78517 5.82756 7.78517 6.02282 7.98043L7.0026 8.96021L8.49249 7.47032L9.98238 5.98043C10.1776 5.78517 10.4942 5.78517 10.6895 5.98043Z"
        fill="currentColor"
      />
    </svg>
  )
}

import React from 'react'

export const SpinIcon = () => {
  return (
    <svg
      aria-hidden="true"
      role="status"
      className="me-3 inline h-4 w-4 animate-spin text-white"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const UnstartedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M33.3638 8.79114C33.9108 10.208 33.2055 11.8 31.7887 12.347C31.2701 12.5472 30.7576 12.7597 30.2516 12.9844C28.8635 13.6006 27.2386 12.9749 26.6223 11.5867C26.0061 10.1986 26.6318 8.57371 28.02 7.95746C28.6085 7.69619 29.2046 7.44889 29.808 7.21599C31.2249 6.66904 32.8169 7.37426 33.3638 8.79114ZM20.7069 15.5478C21.7544 16.6476 21.7119 18.3883 20.6121 19.4357C20.21 19.8187 19.8172 20.2114 19.4343 20.6136C18.3868 21.7134 16.6461 21.7558 15.5463 20.7084C14.4465 19.661 14.404 17.9203 15.4515 16.8205C15.8961 16.3536 16.3521 15.8976 16.819 15.4529C17.9188 14.4055 19.6595 14.448 20.7069 15.5478ZM11.5853 26.6238C12.9734 27.2401 13.5991 28.865 12.9829 30.2531C12.7583 30.7591 12.5457 31.2715 12.3455 31.7901C11.7986 33.207 10.2066 33.9122 8.78968 33.3653C7.37279 32.8183 6.66757 31.2263 7.21452 29.8095C7.44742 29.2061 7.69472 28.61 7.95599 28.0214C8.57224 26.6333 10.1971 26.0076 11.5853 26.6238ZM7.40934 40.3483C8.92768 40.385 10.1288 41.6456 10.0921 43.164C10.0854 43.4418 10.082 43.7206 10.082 44.0002C10.082 44.2798 10.0854 44.5585 10.0921 44.8364C10.1288 46.3547 8.92768 47.6153 7.40934 47.652C5.891 47.6887 4.63041 46.4876 4.59373 44.9692C4.58594 44.6471 4.58203 44.3241 4.58203 44.0002C4.58203 43.6763 4.58594 43.3532 4.59373 43.0311C4.63041 41.5128 5.891 40.3117 7.40934 40.3483ZM79.2077 54.635C80.6246 55.182 81.3298 56.774 80.7829 58.1909C80.55 58.7942 80.3027 59.3904 80.0414 59.9789C79.4251 61.367 77.8003 61.9928 76.4121 61.3765C75.024 60.7603 74.3982 59.1354 75.0145 57.7472C75.2391 57.2413 75.4517 56.7288 75.6519 56.2102C76.1988 54.7933 77.7908 54.0881 79.2077 54.635ZM8.78968 54.6351C10.2066 54.0881 11.7986 54.7933 12.3455 56.2102C12.5457 56.7288 12.7583 57.2413 12.9829 57.7472C13.5991 59.1354 12.9734 60.7603 11.5853 61.3765C10.1971 61.9928 8.57224 61.367 7.95599 59.9789C7.69472 59.3904 7.44742 58.7942 7.21452 58.1909C6.66757 56.774 7.3728 55.182 8.78968 54.6351ZM72.4511 67.2919C73.5509 68.3393 73.5933 70.08 72.5459 71.1798C72.1013 71.6467 71.6453 72.1027 71.1784 72.5474C70.0786 73.5948 68.3379 73.5523 67.2905 72.4525C66.243 71.3527 66.2855 69.612 67.3853 68.5646C67.7874 68.1816 68.1802 67.7889 68.5631 67.3868C69.6106 66.287 71.3512 66.2445 72.4511 67.2919ZM15.5463 67.2919C16.6462 66.2445 18.3868 66.287 19.4343 67.3868C19.8172 67.7889 20.21 68.1816 20.6121 68.5646C21.7119 69.612 21.7544 71.3527 20.7069 72.4525C19.6595 73.5523 17.9188 73.5948 16.819 72.5474C16.3521 72.1027 15.8961 71.6467 15.4515 71.1798C14.404 70.08 14.4465 68.3393 15.5463 67.2919ZM26.6224 76.4136C27.2386 75.0255 28.8635 74.3997 30.2516 75.016C30.7576 75.2406 31.2701 75.4532 31.7887 75.6534C33.2055 76.2003 33.9108 77.7923 33.3638 79.2092C32.8169 80.6261 31.2249 81.3313 29.808 80.7843C29.2046 80.5514 28.6085 80.3041 28.02 80.0429C26.6318 79.4266 26.0061 77.8017 26.6224 76.4136ZM61.375 76.4136C61.9913 77.8017 61.3656 79.4266 59.9774 80.0429C59.3889 80.3041 58.7928 80.5514 58.1894 80.7843C56.7725 81.3313 55.1805 80.6261 54.6336 79.2092C54.0866 77.7923 54.7919 76.2003 56.2087 75.6534C56.7273 75.4532 57.2398 75.2406 57.7458 75.016C59.1339 74.3997 60.7588 75.0255 61.375 76.4136ZM40.3469 80.5895C40.3836 79.0712 41.6441 77.8701 43.1625 77.9067C43.4404 77.9135 43.7191 77.9168 43.9987 77.9168C44.2783 77.9168 44.557 77.9135 44.8349 77.9067C46.3532 77.8701 47.6138 79.0712 47.6505 80.5895C47.6872 82.1078 46.4861 83.3685 44.9677 83.4051C44.6456 83.4129 44.3226 83.4168 43.9987 83.4168C43.6748 83.4168 43.3518 83.4129 43.0296 83.4051C41.5113 83.3685 40.3102 82.1078 40.3469 80.5895Z"
        fill="#FFB700"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.2487 7.3335C41.2487 5.81471 42.4799 4.5835 43.9987 4.5835C65.7679 4.5835 83.4154 22.2309 83.4154 44.0002C83.4154 45.5189 82.1841 46.7502 80.6654 46.7502C79.1466 46.7502 77.9154 45.5189 77.9154 44.0002C77.9154 25.2685 62.7304 10.0835 43.9987 10.0835C42.4799 10.0835 41.2487 8.85228 41.2487 7.3335ZM43.9987 30.2502C45.5175 30.2502 46.7487 31.4814 46.7487 33.0002V44.9168H58.6654C60.1841 44.9168 61.4154 46.148 61.4154 47.6668C61.4154 49.1856 60.1841 50.4168 58.6654 50.4168H43.9987C42.4799 50.4168 41.2487 49.1856 41.2487 47.6668V33.0002C41.2487 31.4814 42.4799 30.2502 43.9987 30.2502Z"
        fill="#FFB700"
      />
    </svg>
  )
}

export const DeleteCommentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37.7997 8.25007H50.1983C50.9918 8.24956 51.683 8.24912 52.3357 8.35336C54.9145 8.76514 57.146 10.3735 58.3522 12.6897C58.6575 13.276 58.8756 13.9319 59.1261 14.6848L59.5353 15.9128C59.6046 16.1206 59.6244 16.1795 59.6412 16.2258C60.2833 18.0009 61.9481 19.2008 63.8351 19.2487C63.8847 19.2499 63.9455 19.2501 64.1657 19.2501H75.1657C76.6845 19.2501 77.9157 20.4814 77.9157 22.0001C77.9157 23.5189 76.6845 24.7501 75.1657 24.7501H12.832C11.3132 24.7501 10.082 23.5189 10.082 22.0001C10.082 20.4814 11.3132 19.2501 12.832 19.2501H23.8323C24.0525 19.2501 24.1133 19.2499 24.1629 19.2487C26.0499 19.2008 27.7147 18.001 28.3568 16.2259C28.3737 16.1792 28.3931 16.1216 28.4627 15.9128L28.8719 14.6849C29.1223 13.932 29.3406 13.276 29.6458 12.6897C30.852 10.3735 33.0835 8.76514 35.6623 8.35336C36.315 8.24912 37.0063 8.24956 37.7997 8.25007ZM33.0286 19.2501C33.2175 18.8797 33.3848 18.4948 33.5288 18.0968C33.5725 17.9759 33.6154 17.8472 33.6705 17.6819L34.0365 16.5841C34.3707 15.5812 34.4477 15.3766 34.5241 15.23C34.9261 14.4579 35.67 13.9218 36.5295 13.7845C36.6928 13.7585 36.9111 13.7501 37.9683 13.7501H50.0297C51.0869 13.7501 51.3052 13.7585 51.4685 13.7845C52.3281 13.9218 53.0719 14.4579 53.4739 15.23C53.5503 15.3766 53.6273 15.5811 53.9616 16.5841L54.3273 17.6812L54.4692 18.0968C54.6132 18.4949 54.7806 18.8797 54.9694 19.2501H33.0286Z"
        fill="#FFB700"
      />
      <path
        d="M21.6874 30.9839C21.5863 29.4685 20.2759 28.3219 18.7605 28.4229C17.2451 28.5239 16.0985 29.8343 16.1995 31.3497L17.8989 56.8394C18.2123 61.5428 18.4656 65.342 19.0595 68.3232C19.6769 71.4228 20.7271 74.0116 22.8963 76.041C25.0655 78.0704 27.7185 78.9461 30.8522 79.356C33.8663 79.7503 37.6739 79.7502 42.3876 79.7501H45.6102C50.3239 79.7502 54.1317 79.7503 57.1458 79.356C60.2795 78.9461 62.9325 78.0704 65.1017 76.041C67.2709 74.0116 68.3211 71.4228 68.9386 68.3232C69.5325 65.342 69.7857 61.5428 70.0992 56.8395L71.7985 31.3497C71.8995 29.8343 70.7529 28.5239 69.2375 28.4229C67.7221 28.3219 66.4117 29.4685 66.3107 30.9839L64.6242 56.2806C64.2947 61.2227 64.06 64.6614 63.5445 67.2487C63.0446 69.7583 62.3467 71.0868 61.3442 72.0247C60.3417 72.9626 58.9698 73.5705 56.4324 73.9025C53.8166 74.2446 50.3699 74.2501 45.4168 74.2501H42.5812C37.6281 74.2501 34.1814 74.2446 31.5656 73.9025C29.0282 73.5705 27.6563 72.9626 26.6538 72.0247C25.6513 71.0868 24.9534 69.7583 24.4535 67.2487C23.9381 64.6614 23.7033 61.2227 23.3738 56.2806L21.6874 30.9839Z"
        fill="#FFB700"
      />
      <path
        d="M34.5587 37.5971C36.07 37.446 37.4176 38.5486 37.5687 40.0598L39.4021 58.3932C39.5532 59.9044 38.4506 61.252 36.9393 61.4032C35.4281 61.5543 34.0805 60.4517 33.9293 58.9404L32.096 40.6071C31.9449 39.0959 33.0475 37.7482 34.5587 37.5971Z"
        fill="#FFB700"
      />
      <path
        d="M53.4393 37.5971C54.9506 37.7482 56.0532 39.0959 55.9021 40.6071L54.0687 58.9404C53.9176 60.4517 52.57 61.5543 51.0587 61.4032C49.5475 61.252 48.4449 59.9044 48.596 58.3932L50.4293 40.0598C50.5805 38.5486 51.9281 37.446 53.4393 37.5971Z"
        fill="#FFB700"
      />
    </svg>
  )
}

export const RestartQuizIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2577 3.50828C18.538 3.62437 18.7207 3.89785 18.7207 4.20119V8.44383C18.7207 8.85805 18.3849 9.19383 17.9707 9.19383H13.728C13.4247 9.19383 13.1512 9.0111 13.0351 8.73085C12.9191 8.45059 12.9832 8.128 13.1977 7.9135L14.8007 6.3105C12.1674 5.20912 9.01606 5.7309 6.87348 7.87348C4.04217 10.7048 4.04217 15.2952 6.87348 18.1265C9.70478 20.9578 14.2952 20.9578 17.1265 18.1265C18.7727 16.4803 19.4622 14.2401 19.1935 12.0937C19.142 11.6827 19.4335 11.3078 19.8445 11.2563C20.2555 11.2049 20.6304 11.4963 20.6819 11.9073C21.0057 14.4934 20.1746 17.1997 18.1872 19.1872C14.7701 22.6043 9.2299 22.6043 5.81282 19.1872C2.39573 15.7701 2.39573 10.2299 5.81282 6.81282C8.55119 4.07444 12.6515 3.5312 15.9309 5.18028L17.4404 3.67086C17.6549 3.45637 17.9774 3.3922 18.2577 3.50828Z"
        fill="#1C274C"
      />
    </svg>
  )
}

export const MKTInAppIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M18.3694 2.84255C19.9969 2.4837 21.8204 2.59133 22.9918 4.03265C23.7379 4.95103 23.8484 6.02716 23.6181 7.03135C23.4003 7.98161 22.8722 8.92392 22.2523 9.80218C21.0108 11.561 19.0849 13.4888 17.2939 15.2905C15.4446 17.1509 13.7363 18.8802 12.7067 20.3712C12.1902 21.1193 11.932 21.6871 11.859 22.086C11.8002 22.4082 11.8641 22.5471 11.9957 22.6824C12.05 22.7381 12.0943 22.7753 12.2809 22.7566C12.5362 22.7309 12.9388 22.5944 13.5127 22.2631C14.662 21.5997 16.014 20.4495 17.5088 19.172C18.9376 17.9508 20.5054 16.6053 21.9345 15.7774C22.6504 15.3628 23.4439 15.0096 24.2523 14.9142C25.1182 14.812 26.0145 15.0106 26.7484 15.6967C27.3496 16.259 27.6433 16.9676 27.6533 17.7241C27.6625 18.4205 27.4316 19.0761 27.1598 19.629C26.6259 20.7152 25.6882 21.8715 24.8994 22.8595C24.0448 23.9298 23.3386 24.8338 22.9775 25.6004C22.8025 25.9719 22.7677 26.194 22.7718 26.3035C22.7739 26.3584 22.7783 26.3979 22.8668 26.4806C23.0339 26.6364 23.2964 26.7811 23.9957 26.5366C24.7569 26.2703 25.7925 25.6022 27.1064 24.4142C27.6526 23.9203 28.4967 23.963 28.9905 24.5092C29.4841 25.0553 29.4413 25.8982 28.8955 26.392C27.4914 27.6616 26.1405 28.6129 24.8773 29.0548C23.5523 29.5182 22.1517 29.4597 21.0478 28.4298C20.4459 27.8681 20.1364 27.1649 20.1077 26.4037C20.0812 25.6971 20.2982 25.0296 20.5648 24.4636C21.0872 23.3545 22.0231 22.1885 22.8161 21.1954C23.6745 20.1203 24.3901 19.219 24.7666 18.4532C24.95 18.0801 24.988 17.8611 24.9866 17.7592C24.9861 17.7172 24.9895 17.7033 24.9267 17.6446C24.8619 17.5841 24.7908 17.5359 24.5648 17.5626C24.2808 17.5962 23.8563 17.7474 23.2718 18.086C22.0996 18.765 20.7347 19.9235 19.2418 21.1993C17.8148 22.4189 16.2555 23.7594 14.846 24.573C14.1408 24.98 13.3518 25.3294 12.5465 25.4103C11.673 25.4979 10.786 25.2627 10.0843 24.5418C9.25555 23.6902 9.04775 22.634 9.23533 21.6069C9.40895 20.6568 9.91609 19.7191 10.5114 18.8569C11.7062 17.1264 13.6132 15.2111 15.4033 13.4103C17.2518 11.5507 18.9907 9.79895 20.0739 8.26442C20.6162 7.49609 20.9154 6.88792 21.0192 6.435C21.1105 6.03634 21.0368 5.85538 20.9228 5.71494C20.6995 5.44005 20.1871 5.17252 18.9437 5.44671C17.7319 5.71399 16.184 6.43938 14.4814 7.55609C11.0887 9.78151 7.43072 13.3259 5.11554 16.8569C4.71184 17.4724 3.8862 17.6443 3.27049 17.241C2.65468 16.8372 2.4826 16.0104 2.88637 15.3946C5.41555 11.5374 9.34115 7.73875 13.0179 5.32692C14.85 4.12514 16.7099 3.20858 18.3694 2.84255Z"
        fill="white"
      />
    </svg>
  )
}
export const EyeV2Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0013 6.87467C8.27541 6.87467 6.8763 8.27378 6.8763 9.99967C6.8763 11.7256 8.27541 13.1247 10.0013 13.1247C11.7272 13.1247 13.1263 11.7256 13.1263 9.99967C13.1263 8.27378 11.7272 6.87467 10.0013 6.87467ZM8.1263 9.99967C8.1263 8.96414 8.96577 8.12467 10.0013 8.12467C11.0368 8.12467 11.8763 8.96414 11.8763 9.99967C11.8763 11.0352 11.0368 11.8747 10.0013 11.8747C8.96577 11.8747 8.1263 11.0352 8.1263 9.99967Z"
        fill="#1C274C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0013 2.70801C6.23953 2.70801 3.70571 4.96151 2.23511 6.87206L2.20859 6.90651C1.876 7.33845 1.56969 7.73628 1.36187 8.20667C1.13934 8.7104 1.04297 9.25942 1.04297 9.99967C1.04297 10.7399 1.13934 11.2889 1.36187 11.7927C1.56969 12.2631 1.876 12.6609 2.20859 13.0928L2.23511 13.1273C3.70571 15.0378 6.23953 17.2913 10.0013 17.2913C13.7631 17.2913 16.2969 15.0378 17.7675 13.1273L17.794 13.0929C18.1266 12.6609 18.4329 12.2631 18.6407 11.7927C18.8633 11.2889 18.9596 10.7399 18.9596 9.99967C18.9596 9.25942 18.8633 8.7104 18.6407 8.20667C18.4329 7.73627 18.1266 7.33844 17.794 6.90649L17.7675 6.87206C16.2969 4.96151 13.7631 2.70801 10.0013 2.70801ZM3.22565 7.63451C4.5835 5.87044 6.79327 3.95801 10.0013 3.95801C13.2093 3.95801 15.4191 5.87044 16.777 7.63451C17.1424 8.10933 17.3565 8.39305 17.4973 8.7118C17.6289 9.00969 17.7096 9.37379 17.7096 9.99967C17.7096 10.6256 17.6289 10.9897 17.4973 11.2876C17.3565 11.6063 17.1424 11.89 16.777 12.3648C15.4191 14.1289 13.2093 16.0413 10.0013 16.0413C6.79327 16.0413 4.5835 14.1289 3.22565 12.3648C2.86016 11.89 2.64608 11.6063 2.50527 11.2876C2.37367 10.9897 2.29297 10.6256 2.29297 9.99967C2.29297 9.37379 2.37367 9.00969 2.50527 8.7118C2.64608 8.39306 2.86016 8.10933 3.22565 7.63451Z"
        fill="#1C274C"
      />
    </svg>
  )
}

export const CloseEyeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5808 5.2587C18.898 5.39467 19.045 5.7621 18.909 6.07937L18.3346 5.83317C18.909 6.07937 18.9091 6.07922 18.909 6.07937L18.9084 6.08077L18.9075 6.08284L18.9049 6.08897L18.896 6.10904C18.8885 6.12581 18.8778 6.14933 18.864 6.17906C18.8363 6.23852 18.7957 6.32296 18.742 6.4283C18.6346 6.63884 18.4742 6.93373 18.2583 7.28022C17.9037 7.84942 17.395 8.56455 16.7196 9.27498L17.5265 10.0819C17.7706 10.326 17.7706 10.7217 17.5265 10.9658C17.2824 11.2099 16.8867 11.2099 16.6426 10.9658L15.8088 10.132C15.2591 10.5926 14.6286 11.0249 13.9138 11.38L14.6918 12.5756C14.88 12.865 14.7981 13.2521 14.5088 13.4404C14.2194 13.6286 13.8323 13.5467 13.644 13.2574L12.7364 11.8625C12.087 12.0745 11.3838 12.2187 10.6262 12.2704V13.7498C10.6262 14.095 10.3464 14.3748 10.0012 14.3748C9.65606 14.3748 9.37624 14.095 9.37624 13.7498V12.2704C8.64205 12.2203 7.95888 12.0833 7.32616 11.8818L6.43109 13.2574C6.24284 13.5467 5.85569 13.6287 5.56636 13.4404C5.27704 13.2522 5.19511 12.865 5.38336 12.5757L6.14371 11.4071C5.42339 11.0554 4.78781 10.625 4.23332 10.165L3.4325 10.9659C3.18843 11.2099 2.7927 11.2099 2.54862 10.9659C2.30454 10.7218 2.30454 10.3261 2.54862 10.082L3.31842 9.31218C2.63129 8.59577 2.11401 7.87196 1.75361 7.29539C1.53451 6.94486 1.3718 6.64621 1.26287 6.43291C1.20837 6.32619 1.16722 6.24062 1.13911 6.18037C1.12505 6.15023 1.11424 6.1264 1.10665 6.1094L1.09765 6.08908L1.09495 6.08287L1.09405 6.08078L1.09371 6.07999C1.09364 6.07984 1.09344 6.07937 1.66791 5.83317L1.09371 6.07999C0.957734 5.76272 1.10444 5.39467 1.42171 5.2587C1.73871 5.12284 2.10579 5.26946 2.24203 5.58619C2.24199 5.58608 2.24208 5.58629 2.24203 5.58619L2.24283 5.58801L2.24789 5.59944C2.2528 5.61044 2.2608 5.62809 2.27191 5.6519C2.29413 5.69953 2.32877 5.77171 2.3761 5.8644C2.47085 6.04991 2.61598 6.31673 2.81357 6.63283C3.20991 7.2669 3.81094 8.08908 4.63097 8.85116C5.35256 9.52176 6.23679 10.1395 7.29434 10.5463C8.08975 10.8524 8.98911 11.0415 10.0012 11.0415C11.036 11.0415 11.953 10.8438 12.7617 10.5255C13.8128 10.1118 14.691 9.49004 15.4068 8.81816C16.2148 8.05981 16.807 7.2458 17.1974 6.61917C17.3921 6.30676 17.5351 6.04339 17.6284 5.86039C17.675 5.76896 17.7092 5.69781 17.7311 5.65087C17.742 5.62741 17.7499 5.61002 17.7547 5.5992L17.7597 5.58797L17.7601 5.58697C17.7601 5.58705 17.7601 5.58689 17.7601 5.58697M18.5808 5.2587C18.2636 5.12277 17.8962 5.26987 17.7601 5.58697L18.5808 5.2587ZM2.24203 5.58619C2.24199 5.58608 2.24208 5.58629 2.24203 5.58619V5.58619Z"
        fill="#1C274C"
      />
    </svg>
  )
}
export { default as NotificationIcon } from './NotificationIcon'
export { SadIcon } from './SadIcon'
